import { Injectable } from '@angular/core';

import {GoogleMapLoaderService} from './google/google-map-loader.service';
import * as MarkerWithLabelLibrary from 'markerwithlabel';
import * as $ from 'jquery';
import {SclMapConstantService} from './scl-map-constant.service';
import {SclMapViewsService} from './scl-map-views.service';
import {SclAssetLayersService} from './scl-asset-layers.service';
import {SclUtilMapService} from './scl-util-map.service';
import { isNumber, isArray, cloneDeep, isEqual } from 'lodash';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { MapLibrary, MapDrawType, ShapeIdGroup, MapDrawAction, MapDrawTypeSpecial
, MapDrawMode, MapComponentName, MapSelectAssetMode, MapSelectAssetType, GEOJSON_TYPE, 
FEATURE_TYPE} from './map-library';
import * as uuid from 'uuid';

const sclMapViews = new SclMapViewsService();
const sclAssetLayers = new SclAssetLayersService();
const sclUtilMap = new SclUtilMapService();
const GoogleMapsLoader = new GoogleMapLoaderService();



@Injectable({
    providedIn: 'root'
})
export class SclMappingFunctionGoogleService extends MapLibrary {

    constructor() {
        super();
        console.log('************ GG constructor');
        this.zoomFloor = 17; // 14254
        this.drawingToolsSupported = ['point', 'line', 'polygon', 'circle', 'box', 'currentLocation'
        , 'delete', 'text', 'arrowAtFirstPoint', 'arrowAtLastPoint', 'dimension'];
        this.totalDrawTool = 6; // total tool for drawing (point, line, polygon, circle, box)
    }

    apiKey = 'AIzaSyDLF3KfOk7figOYUQAudATOTTqCbzf1ylc'; // localhost:3000

    countPoint: number;
    multipleSelection: any;
    modeMultiple: any;
    drawingManager = null;
    selectedShape = null;
    selectedFeatures = []; // use for sc-address-map
    ActionControls = [];
    shapes = null;
    funcSingleSelectMode = null;
    // for sc-boundary <id, count> , support one multi for each type ( multi point, multi line string, multi polygon )
    dicDrawShape = {};
    heatLayerConfig = {};
    google = null;
    MarkerWithLabel = null;
    btnZoomIn = null; btnZoomOut = null;
    checkImgTransparent = null; checkImgTransparentCount = 0;
    markerImage = null; // 15260
    divCustomControl = null; // 15336#c59379 
    // MarkerClusterer = null; // 15251
    clusterImageSize = []; // 15251: store width & height of cluster marker icon [{width: 18, height: 30}]
    singleSelectModeCluster = null; drawStartCluster = null; drawEndCluster = null; // 15251
    findBtnZoomIn = null; findBtnZoomInCount = 0; findBtnZoomLimit = 10; // 15737#c63119
    findBtnZoomOut = null; findBtnZoomOutCount = 0; // 15737#c63119
    dynamicIconRotate = ''; dynamicIconRotateInterval = [];
    dynamicIconRotateCount = []; dynamicIconRotateLimit = 10;
    dynamicIconScale = ''; dynamicIconScaleInterval = [];
    dynamicIconScaleCount = []; dynamicIconScaleLimit = 20;
    vertexes = []; arrow = null;
    iconAnchors = []; // [{fileNo: '...', imageAnchor: [0.5 * img.width, 0.4 * img.height]}]
    currentDimensionId = null;
    dimensionOverlays = {}; // store dimension of polyline
    currentDrawingMode = null;
    overlays = [];
    isDrawing = false;
    isSetRadius = false;
    drawingShapeMouseMoveListener = null;
    rotateIconWidth = 0;
    rotateIconHeight = 0;
    previousMousePosition;

    async load(constructObj, cb) {
        this.apiKey = (constructObj.googleKey === null ? this.apiKey : constructObj.googleKey );
        GoogleMapsLoader.KEY = this.apiKey;
        GoogleMapsLoader.LIBRARIES = 'places,drawing,visualization,geometry';
        GoogleMapsLoader.SENSOR = true;
        GoogleMapsLoader.load((google: any) => {
            this.google = google;
            if (this.google) {
                this.MarkerWithLabel = new MarkerWithLabelLibrary(google.maps);
            } else {
                console.log(`**** LOAD GOOGLE MAP DONE BUT google is NULL`);
            }
            if (cb && typeof cb === 'function') {
                // console.log(`**** GG MAP LOAD CALLBACK...`);
                cb();
            }
        }, (err) => {
            console.log(`**** LOAD GOOGLE MAP ERROR:`, err);
        });
    }

    // function for calculating 6 letters hex value
    calculateFull(hex, opacity) {
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // set results
        return 'rgba(' + r + ', ' + g + ', ' + b + ',' + opacity + ' )';
    }

    // function for calculating 3 letters hex value
    calculatePartial(hex, opacity) {
        const r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
        const g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
        const b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);

        // set results
        return 'rgba(' + r + ', ' + g + ', ' + b + ',' + opacity + ' )';
    }
    clampZoomFloor() {
        // console.log('%c clampZoomFloor, currentZoom = ' + this.map.getZoom() + ', zoomFloor = ' + this.zoomFloor, 'color:blue');
        if (this.map.getZoom() > this.zoomFloor) {
            this.map.setZoom(this.zoomFloor);
        }
    }
    colourNameToRGB(color, opacity) {
        const colors = {aliceblue: '#f0f8ff', antiquewhite: '#faebd7', aqua: '#00ffff', aquamarine: '#7fffd4', azure: '#f0ffff',
        beige: '#f5f5dc', bisque: '#ffe4c4', black: '#000000', blanchedalmond: '#ffebcd', blue: '#0000ff', blueviolet: '#8a2be2',
        brown: '#a52a2a', burlywood: '#deb887', cadetblue: '#5f9ea0', chartreuse: '#7fff00', chocolate: '#d2691e', coral: '#ff7f50',
        cornflowerblue: '#6495ed', cornsilk: '#fff8dc', crimson: '#dc143c', cyan: '#00ffff', darkblue: '#00008b', darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b', darkgray: '#a9a9a9', darkgreen: '#006400', darkkhaki: '#bdb76b', darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f', darkorange: '#ff8c00', darkorchid: '#9932cc', darkred: '#8b0000', darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f', darkslateblue: '#483d8b', darkslategray: '#2f4f4f', darkturquoise: '#00ced1',
        darkviolet: '#9400d3', deeppink: '#ff1493', deepskyblue: '#00bfff', dimgray: '#696969', dodgerblue: '#1e90ff',
        firebrick: '#b22222', floralwhite: '#fffaf0', forestgreen: '#228b22', fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc', ghostwhite: '#f8f8ff', gold: '#ffd700', goldenrod: '#daa520', gray: '#808080', green: '#008000',
        greenyellow: '#adff2f', honeydew: '#f0fff0', hotpink: '#ff69b4', indianred: '#cd5c5c', indigo: '#4b0082', ivory: '#fffff0',
        khaki: '#f0e68c', lavender: '#e6e6fa', lavenderblush: '#fff0f5', lawngreen: '#7cfc00', lemonchiffon: '#fffacd',
        lightblue: '#add8e6', lightcoral: '#f08080', lightcyan: '#e0ffff', lightgoldenrodyellow: '#fafad2',
        lightgrey: '#d3d3d3', lightgreen: '#90ee90', lightpink: '#ffb6c1', lightsalmon: '#ffa07a', lightseagreen:'#20b2aa',
        lightskyblue: '#87cefa', lightslategray: '#778899', lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0', lime: '#00ff00', limegreen: '#32cd32', linen: '#faf0e6',
        magenta: '#ff00ff', maroon: '#800000', mediumaquamarine: '#66cdaa', mediumblue: '#0000cd', mediumorchid: '#ba55d3',
        mediumpurple: '#9370d8', mediumseagreen: '#3cb371', mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a', mediumturquoise: '#48d1cc', mediumvioletred: '#c71585', midnightblue: '#191970',
        mintcream: '#f5fffa', mistyrose: '#ffe4e1', moccasin: '#ffe4b5',
        navajowhite: '#ffdead', navy: '#000080', oldlace: '#fdf5e6', olive: '#808000', olivedrab: '#6b8e23', orange: '#ffa500',
        orangered: '#ff4500', orchid: '#da70d6', palegoldenrod: '#eee8aa', palegreen: '#98fb98', paleturquoise: '#afeeee',
        palevioletred: '#d87093', papayawhip: '#ffefd5', peachpuff: '#ffdab9', peru: '#cd853f', pink: '#ffc0cb', plum: '#dda0dd',
        powderblue: '#b0e0e6', purple: '#800080', rebeccapurple: '#663399', red: '#ff0000', rosybrown: '#bc8f8f',
        royalblue: '#4169e1', saddlebrown: '#8b4513', salmon: '#fa8072', sandybrown: '#f4a460', seagreen: '#2e8b57',
        seashell: '#fff5ee', sienna: '#a0522d', silver: '#c0c0c0', skyblue: '#87ceeb', slateblue: '#6a5acd', slategray: '#708090',
        snow: '#fffafa' , springgreen: '#00ff7f', steelblue: '#4682b4', tan: '#d2b48c', teal: '#008080', thistle: '#d8bfd8',
        tomato: '#ff6347', turquoise: '#40e0d0', violet: '#ee82ee', wheat: '#f5deb3', white: '#ffffff', whitesmoke: '#f5f5f5',
        yellow: '#ffff00', yellowgreen: '#9acd32'};

        let hex;
        if (colors.hasOwnProperty(color)) {
            hex = colors[color].substr(1);
            return this.calculateFull(hex, opacity);
        } else {
            // strip # from HEX
            hex = ( color.charAt(0) === '#' ? color.substr(1) : color );
            // check if 6 letters are provided
            if (hex.length === 6) {
                return this.calculateFull(hex, opacity);
            } else if (hex.length === 3) {
                return this.calculatePartial(hex, opacity);
            }
        }

        return color;
    }

    createLayerCluster(zIndex, options, map) {
        let textColor = 'white';
        if (options.clusterTextColor) { textColor = options.clusterTextColor; }
        let textSize = 10;
        if (options.clusterTextSize) { textSize = options.clusterTextSize; }
        let clusterDistance = 20;
        if (options.clusterDistance) { clusterDistance = options.clusterDistance; }
        let clusterImageWidth = 18;
        if (options.clusterImageWidth) { clusterImageWidth = options.clusterImageWidth; }
        let clusterImageHeight = 30;
        if (options.clusterImageHeight) { clusterImageHeight = options.clusterImageHeight; }

        let isExists = false;
        for (let i = 0; i < this.clusterImageSize.length; i++) {
            if (this.clusterImageSize[i].width === clusterImageWidth && this.clusterImageSize[i].height === clusterImageHeight) {
                isExists = true;
                break;
            }
        }
        if (isExists === false) {
            this.clusterImageSize.push({ width: clusterImageWidth, height: clusterImageHeight});
        }

        const styleRenderer = {
            render: function ({ count, position }, stats) {
                // create marker using svg icon
                return new google.maps.Marker({
                    position,
                    icon: {
                        url: options.clusterImageFileNo,
                        scaledSize: new google.maps.Size(clusterImageWidth, clusterImageHeight),
                    },
                    label: {
                        text: String(count),
                        color: textColor,
                        fontSize: `${textSize}px`,
                    },
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });
            },
        };
        const clusterLayer = new MarkerClusterer({renderer: styleRenderer});
        clusterLayer.set('isHeatMap', false);
        clusterLayer.set('isCluster', true);
        clusterLayer.set('clusterImageWidth', clusterImageWidth);
        clusterLayer.set('clusterImageHeight', clusterImageHeight);

        clusterLayer.onClusterClick = (mouseEvent, cluster, map) => {
            const m = cluster.markers;
            const clusterFeaturesSelected = [];
            for (let i = 0; i < m.length; i++) {
                clusterFeaturesSelected.push(m[i]);
            }
            const latLng = mouseEvent.latLng;
            const pixel = this.convertLatLngToPixel(latLng);
            if (this.clusterClick && typeof this.clusterClick === 'function') {
                this.clusterClick(clusterFeaturesSelected, pixel);
            }
        };
        return clusterLayer;
    }

    createEmptyLayer(zIndex, pStyle, title, isHeatMap = false, options = null, map = null) {
        if (isHeatMap) {
            const heatLayer = new this.google.maps.visualization.HeatmapLayer({
                opacity: 1
            });

            this.heatLayerConfig[zIndex] = {};

            if (options != null) {
                if (typeof options.gradient !== 'undefined') {
                    const g = ['rgba(0, 255, 255, 0)', 'rgba(0, 255, 255, 1)']; // to make gradient work we need to put this first 2 items
                    for (let i = 0; i < options.gradient.length; i++) {
                        const c = this.colourNameToRGB(options.gradient[i], 1);
                        g.push(c);
                    }
                    if (options.gradient.length > 0) {
                        this.heatLayerConfig[zIndex].gradient = g;
                        // heatLayer.set('gradient', heatLayer.get('gradient') ? null : g);
                    }
                }

                if (typeof options.opacity !== 'undefined') {
                    // heatLayer.set('opacity', options.opacity);
                    this.heatLayerConfig[zIndex].opacity = options.opacity;
                }
                if (typeof options.radius !== 'undefined') {
                    // heatLayer.set('radius', options.radius);
                    this.heatLayerConfig[zIndex].radius = options.radius;
                }
                if (typeof options.zoomLevel !== 'undefined') {
                    // heatLayer.set('radius', options.radius);
                    this.heatLayerConfig[zIndex].zoomLevel = options.zoomLevel;
                }

            }
            heatLayer.set('isHeatMap', true);

            return heatLayer;
        } else {
            if (options && options.type === 'cluster') {
                return this.createLayerCluster(zIndex, options, map);
            } else {
                // normal layer
                const dataLayer = new this.google.maps.Data();
                pStyle.zIndex = zIndex;
                dataLayer.setStyle(pStyle);

                dataLayer.set('isHeatMap', false);
                
                return dataLayer;
            }
        }

    }

    createLayerAsset(layerQuery, styleLayer, hasFilterQuery, styleFilter, hasSecondary, styleSecondary
                                   , hasPrimary, stylePrimary, hasUserItems, styleSelected, hasAddressPoint, stylePoint, map) {
        // 1) UI controls (zoom, map selector. etc)
        // 2) Tooltips, other popup controls
        // 3) User added items : address pins, selections, etc
        // 4) Objects returned from "primaryAssetFilter"
        // 5) Objects returned from "secondaryAssetFilter"
        // 6) Objects returned from a "filter" query at the root of the component
        // 7) Items returned from the layers[0] entry
        // 8) items returned from layers[1] entry
        // 9) Items returned from layers[n] entry, where n is the last layer in the array
        // 10) Base map images
        let layerIndex = 0;
        if (this.layerAssets == null) { this.layerAssets = []; }
        if (layerQuery) {// 9,8,7
            for (let i = 0; i < layerQuery.length; i++) {
                if (layerQuery[i].query.indexOf('_layer') < 0) {
                    continue;
                }
                layerIndex++;
                this.layerAssets.push(this.createEmptyLayer(layerIndex, styleLayer, 'layer' + layerIndex
                , layerQuery[i].isHeatMap, layerQuery[i].layer, map));
            }
        }
        if (hasFilterQuery) {// 6
            layerIndex++;
            this.layerAssets.push(this.createEmptyLayer(layerIndex, styleLayer, 'filter'));
            this.layerIndexFilter = layerIndex;
        }
        if (hasSecondary) {// 5
            layerIndex++;
            this.layerAssets.push(this.createEmptyLayer(layerIndex, styleSecondary, 'secondary'));
            this.layerIndexSecondary = layerIndex;
        }
        if (hasPrimary) {// 4
            layerIndex++;
            this.layerAssets.push(this.createEmptyLayer(layerIndex, stylePrimary, 'primary'));
            this.layerIndexPrimary = layerIndex;
        }

        if (hasUserItems) {// 3
            layerIndex++;
            this.layerAssets.push(this.createEmptyLayer(layerIndex, styleSelected, 'selectedItems'));
            this.layerIndexUser = layerIndex;
        }
        if (hasAddressPoint) {// 3
            layerIndex++;
            this.layerAssets.push(this.createEmptyLayer(layerIndex, stylePoint, 'addressPoint'));
            this.layerIndexAddress = layerIndex;
        }
        // tooltips
        this.layerIndexTooltips = layerIndex + 1;
        // controls button
        this.layerIndexControl = layerIndex + 2;
    }
    createLayers(initObj, map) {
        this.layerAssets = [];
        this.layerAssets.push(this.createEmptyLayer(0, {}, null));

        if (this.mapType === MapComponentName.BOUNDARY) {// sc-boundary
            // const boundary = this.styleBoundary(initObj);
            const boundary = this.styleAddress.bind(this);
            this.createLayerAsset(initObj.layerAssets, boundary, true, boundary, false, null, false, null, false, null, true, boundary, map);
        } else if (this.mapType === MapComponentName.ADDRESS_MAP) {// sc-address-map
            if (initObj.layerAssets) {
                this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, this.styleAddress.bind(this)
                , false, null, false, null, true, this.styleSelectedFunc.bind(this), false, null, map);
            } else {
                this.createLayerAsset([], this.styleAddress.bind(this), true, this.styleAddress.bind(this), false, null
                , false, null, true, this.styleSelectedFunc.bind(this), false, null, map);
            }
        } else if (this.mapType === MapComponentName.STREET_ADDRESS) {// sc-street-address
            this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, this.styleAddress.bind(this), false, null, false, null
            , false, null, true, this.styleStAddress.bind(this), map);
        } else if (this.mapType === MapComponentName.SELECTED_ASSET) {// sc-selected-asset
            if (initObj.layerAssets) {
                this.createLayerAsset(initObj.layerAssets, this.styleAsset.bind(this), true, this.styleAsset.bind(this)
                , true, this.styleSecondaryAssetFunc.bind(this), true, this.stylePrimaryAssetFunc.bind(this), false, null
                , true, this.styleAsset.bind(this), map);
            } else {
                this.createLayerAsset([], this.styleAsset.bind(this), true, this.styleAsset.bind(this), true
                , this.styleSecondaryAssetFunc.bind(this), true, this.stylePrimaryAssetFunc.bind(this), false, null
                , true, this.styleAsset.bind(this), map);
            }
        }

    }

    createHeatMap(layerIndex) {
        // logger.info('GG , createHeatMap, layerIndex = ' + layerIndex);

        this.layerAssets[layerIndex] = new this.google.maps.visualization.HeatmapLayer({
            data: this.heatDatas,
            map: this.map,
            opacity: 1,
            isHeatMap: true
        });

        if (typeof this.heatLayerConfig[layerIndex].gradient !== 'undefined') {
            this.layerAssets[layerIndex].set('gradient', this.heatLayerConfig[layerIndex].gradient);
        }
        if (typeof this.heatLayerConfig[layerIndex].opacity !== 'undefined') {
            this.layerAssets[layerIndex].set('opacity', this.heatLayerConfig[layerIndex].opacity);
        }
        if (typeof this.heatLayerConfig[layerIndex].radius !== 'undefined') {
            this.layerAssets[layerIndex].set('radius', this.heatLayerConfig[layerIndex].radius);
        }
        if (typeof this.heatLayerConfig[layerIndex].zoomLevel !== 'undefined') {
            const z = this.map.getZoom();
            if (z < this.heatLayerConfig[layerIndex].zoomLevel) {
                this.layerAssets[layerIndex].setMap(null);
            }
        }


        this.heatDatas = []; // reset
        this.lstHeatWeight = []; // reset
    }

    checkAndDrawGeoJson(geoJSON) {
        this.shapes.clearAllShape();
        // delete all overlay
        for (let i = this.overlays.length - 1; i > -1; i--) {
            // console.log(`***** delete overlay ${i} = ${this.overlays[i]}`);
            if (this.overlays[i]) {
                this.overlays[i].setMap(null);
            }
        }
        this.overlays = []; // reset

        // delete all dimenstion overlay
        for(let key in this.dimensionOverlays) {
            this.dimensionOverlays[key].overlay.setMap(null);
        }
        this.dimensionOverlays = {}; // reset

        geoJSON = this.normalizeGeoJson(geoJSON);

        const featureJSON = geoJSON.features;
        const obj = this.initHaveJSON(featureJSON, this.mapType);

        this.bounds = obj.bounds;
        this.countPoint = obj.countPoint;
    }

    

    getIconAnchor(fileNo) {
        let anchor = [0, 0];
        let index = -1;
        for (let i = 0; i < this.iconAnchors.length; i++) {
            if (this.iconAnchors[i].fileNo === fileNo) {
                index = i;
                break;
            }
        }
        if (index > -1) {
            anchor = this.iconAnchors[index].imageAnchor;
        } else {
            console.log(`*** the fileNo has not existed in config: ${fileNo}`)
        }
        return anchor;
    }

    createPointByJson(geoJson, id, bounds, countPoint, fillColor, color, lineWidth, lineWidthSaved, lineDash, arrowHead, icon
        , anchor, isSelect) {
        let radius = null;
        if (geoJson.properties) {
            radius = (typeof geoJson.properties.radius === 'undefined' ||
            geoJson.properties.radius === null ) ? null :
            geoJson.properties.radius;
        }
        const latLng = new this.google.maps.LatLng(geoJson.geometry.coordinates[1]
            , geoJson.geometry.coordinates[0]);
        
        if (geoJson.properties?.fillColor) { fillColor = geoJson.properties?.fillColor; }
        if (geoJson.properties?.color) { color = geoJson.properties?.color; }
        if (radius == null) { // just a marker
            let mIcon = null;
            if (this.mapType === MapComponentName.BOUNDARY) {
                if (icon) {
                    const imageAnchor = this.getIconAnchor(icon);
                    mIcon = {
                        url: icon,
                        anchor: new this.google.maps.Point(imageAnchor[0], imageAnchor[1])
                    };
                } else {
                    mIcon = {
                        path: this.google.maps.SymbolPath.CIRCLE,
                        fillColor: fillColor,
                        fillOpacity: 0.6,
                        strokeColor: color,
                        strokeOpacity: 0.9,
                        strokeWeight: lineWidth,
                        scale: 7
                    };
                    if (geoJson.properties?.text) {
                        mIcon.strokeOpacity = 0;
                        mIcon.fillOpacity = 0;
                    }
                }
                
            }
            // marker
            const pointStyle: any = {
                position: latLng,
                map: this.map,
                // editable: true,
                draggable: true,
                strokeColor: color,
                fillColor: fillColor,
                icon: mIcon
            };
            if (geoJson.properties?.text) {
                pointStyle.strokeOpacity = 0;
                pointStyle.fillOpacity = 0;
            }
            const m = new this.google.maps.Marker(pointStyle);
            // m.overlay = overlay;
            m.type = this.google.maps.drawing.OverlayType.MARKER;
            m.realType = MapDrawType.MARKER;
            bounds.extend(latLng);
            countPoint++;

            if (typeof geoJson.properties?.textId === 'string'
             && geoJson.properties?.textId.trim().length > 0) {
                const id = geoJson.properties?.textId;
                // console.log(`***** show textbox id = ${id}`);
                this.createTextBoxFeature(m, latLng
                    , geoJson.properties?.text
                    , id, false, geoJson, geoJson.properties?.font
                    , geoJson.properties?.fontSize);
            } else {
                this.shapes.add(m, geoJson, id, null, color, lineWidthSaved, lineDash, arrowHead, icon, anchor, null, null, isSelect);
            }
        } else {
            // circle
            const circleStyle: any = {
                map: this.map,
                center: latLng,
                radius: radius,
                // editable: true,
                draggable: true,
                strokeColor: color,
                fillColor: fillColor,
                strokeWeight: lineWidth,
            };
            const c = new this.google.maps.Circle(circleStyle);
            
            // c.overlay = overlay;
            c.type = this.google.maps.drawing.OverlayType.CIRCLE;
            c.realType = MapDrawType.CIRCLE;
            bounds.union(c.getBounds());

            this.shapes.add(c, geoJson, id, null, color, lineWidthSaved, lineDash, arrowHead, arrowHead, null, null, null, isSelect);
        }

        return { bounds, countPoint };
    }

    createMultiPointByJson(geoJson, bounds, fillColor, color, lineWidth, lineWidthSaved, lineDash, arrowHead, iconImage, anchor, isSelect) {
        let radius1 = null;
        color = this.multiColor;
        fillColor = this.multiColor;
        if (geoJson.properties) {
            radius1 = (typeof geoJson.properties.radius === 'undefined' ||
            geoJson.properties.radius === null ) ? null :
            geoJson.properties.radius;
            if (geoJson.properties.fillColor) { fillColor = geoJson.properties.fillColor; }
            if (geoJson.properties.color) { color = geoJson.properties.color; }
        }
        const dataCoords = geoJson.geometry.coordinates;
        if (radius1 == null) { // just a marker
            const idGroup = ShapeIdGroup.MULTI_POINT;
            for (let j = 0; j < dataCoords.length; j++) {
                const latLng1 = new this.google.maps.LatLng( dataCoords[j][1], dataCoords[j][0] );
                let icon = {};
                if (iconImage) {
                    icon = iconImage;
                } else {
                    icon = {
                        path: this.google.maps.SymbolPath.CIRCLE,
                        fillColor: fillColor,
                        fillOpacity: 0.6,
                        strokeColor: color,
                        strokeOpacity: 0.9,
                        strokeWeight: lineWidth,
                        scale: 7
                    };
                }
                const c = new this.google.maps.Marker({
                    map: this.map,
                    position: latLng1,
                    // editable: true,
                    draggable: true,
                    icon,
                });
                // c.overlay = overlay;
                c.type = this.google.maps.drawing.OverlayType.MARKER;
                c.realType = MapDrawType.MULTI_POINT;
                bounds.extend(latLng1);
                const geoFea = {
                    type: FEATURE_TYPE.FEATURE,
                    properties: geoJson.properties,
                    geometry: {
                        type: MapDrawType.MULTI_POINT,
                        coordinates: dataCoords[j]
                    }
                };
                const count = this.storeDrawMultiShape(idGroup);
                this.shapes.add(c, geoFea , idGroup + '_' + count, idGroup, color, lineWidthSaved, lineDash, arrowHead, arrowHead
                , icon, anchor, null, null, isSelect);
            }
        } else {
            // circle
            fillColor = (geoJson.properties?.fillColor) ? geoJson.properties.fillColor : this.singleColor;
            color = (geoJson.properties?.color) ? geoJson.properties.color : this.singleColor;
            const idGroup = ShapeIdGroup.MULTI_CIRCLE;
            for (let j = 0; j < dataCoords.length; j++) {
                const latLng2 = new this.google.maps.LatLng( dataCoords[j][1], dataCoords[j][0] );
                const c = new this.google.maps.Circle({
                    map: this.map,
                    center: latLng2,
                    radius: radius1,
                    // editable: true,
                    draggable: true,
                    strokeColor: color,
                    strokeWeight: lineWidth,
                    fillColor
                });
                // c.overlay = overlay;
                c.type = this.google.maps.drawing.OverlayType.CIRCLE;
                c.realType = MapDrawType.MULTI_POINT;
                bounds.union(c.getBounds());
                const geoFea = {
                    type: FEATURE_TYPE.FEATURE,
                    properties: geoJson.properties,
                    geometry: {
                        type: MapDrawType.MULTI_POINT,
                        coordinates: dataCoords[j]
                    }
                };
                const count = this.storeDrawMultiShape(idGroup);
                this.shapes.add(c, geoFea , idGroup + '_' + count, idGroup, color, lineWidthSaved, lineDash, arrowHead
                , null, null, null, null, isSelect);
            }
        }
        return bounds;
    }

    createPolygonByJson(geoJson, id, bounds, fillColor, colorSaved, lineWidth, lineWidthSaved, lineDash, arrowHead, isSelect) {
        // let triangleCoords = [
        //    {lat: 25.774, lng: -80.190},
        //    {lat: 18.466, lng: -66.118},
        //    {lat: 32.321, lng: -64.757},
        //    {lat: 25.774, lng: -80.190}
        // ];
        const triangleCoords = [];
        const dataCoords = geoJson.geometry.coordinates[0];
        for (let j = 0; j < dataCoords.length; j++ ) {
            const pLatLng = { lat: dataCoords[j][1], lng: dataCoords[j][0] };
            triangleCoords.push(pLatLng);
            bounds.extend(pLatLng);
        }
        fillColor = (geoJson.properties?.fillColor) ? geoJson.properties.fillColor : this.singleColor;
        const color = (geoJson.properties?.color) ? geoJson.properties.color : this.singleColor;
        colorSaved = (geoJson.properties?.color) ? geoJson.properties.color : colorSaved;
        let radius = null;
        if (geoJson.properties) {
            radius = (typeof geoJson.properties.radius === 'undefined' ||
            geoJson.properties.radius === null ) ? null :
            geoJson.properties.radius;
        }
        if (radius) {
            const center = sclUtilMap.calculateCircleCenterPoint(geoJson.geometry.coordinates[0][0]
                , geoJson.geometry.coordinates[0][2]);
            const latLng = new this.google.maps.LatLng(center[1], center[0]);
            // circle
            const style: any = {
                map: this.map,
                center: latLng,
                radius: radius,
                // editable: true,
                draggable: true,
                strokeColor: color,
                strokeWeight: lineWidth,
                fillColor
            };
            const c = new this.google.maps.Circle(style);
            // c.overlay = overlay;
            c.type = this.google.maps.drawing.OverlayType.CIRCLE;
            c.realType = MapDrawType.CIRCLE;
            bounds.union(c.getBounds());

            this.shapes.add(c, geoJson, id, null, colorSaved, lineWidthSaved, lineDash, arrowHead, null, null, null, null, isSelect);
        } else {
            const style: any = {
                map: this.map,
                paths: triangleCoords,
                // editable: true,
                draggable: true,
                strokeColor: color,
                strokeWeight: lineWidth,
                fillColor
            };
            const poly = new this.google.maps.Polygon(style);
            // poly.overlay = overlay;
            poly.type = this.google.maps.drawing.OverlayType.POLYGON;
            poly.realType = MapDrawType.POLYGON;
            this.shapes.add(poly, geoJson, id, null, colorSaved, lineWidthSaved, lineDash, arrowHead, null, null, null, null, isSelect);
        }

        return bounds;
    }

    createMultiPolygonByJson(geoJson, bounds, fillColor, colorSaved, lineWidth, lineWidthSaved, lineDash, arrowHead, isSelect) {
        // [
        //    [
        //        [[40, 40], [20, 45], [45, 30], [40, 40]]
        //    ],
        //    [
        //        [[20, 35], [10, 30], [10, 10], [30, 5], [45, 20], [20, 35]],
        //        [[30, 20], [20, 15], [20, 25], [30, 20]]
        //    ]
        // ]
        fillColor = (geoJson.properties?.fillColor) ? geoJson.properties.fillColor : this.multiColor;
        const color = (geoJson.properties?.color) ? geoJson.properties.color : this.multiColor;
        colorSaved = (geoJson.properties?.color) ? geoJson.properties.color : colorSaved;

        const dataCoords = geoJson.geometry.coordinates;
        const properties = geoJson.properties;
        const idGroup = (properties?.idGroup ? properties?.idGroup
                : ShapeIdGroup.MULTI_POLYGON);
        for (let j = 0; j < dataCoords.length; j++) {
            const mpCoords = [];

            for (let n = 0; n < dataCoords[j].length; n++) {
                const nCoords = [];
                for (let m = 0; m < dataCoords[j][n].length; m++) {
                    const pLatLng2 = { lat: dataCoords[j][n][m][1], lng: dataCoords[j][n][m][0] };
                    nCoords.push(pLatLng2);
                    bounds.extend(pLatLng2);
                }
                mpCoords.push(nCoords);
            }

            const poly = new this.google.maps.Polygon({
                map: this.map,
                paths: mpCoords,
                draggable: true,
                strokeColor: color,
                strokeWeight: lineWidth,
                fillColor
            });
            poly.type = this.google.maps.drawing.OverlayType.POLYGON;
            poly.realType = MapDrawType.MULTI_POLYGON;

            const geoFea = {
                type: FEATURE_TYPE.FEATURE,
                properties,
                geometry: {
                    type: MapDrawType.MULTI_POLYGON,
                    coordinates: dataCoords[j]
                }
            };

            const count = this.storeDrawMultiShape(idGroup);
            this.shapes.add(poly, geoFea , idGroup + '_' + count, idGroup, colorSaved, lineWidthSaved, lineDash, arrowHead
            , null, null, null, null, isSelect);
        }

        return bounds;
    }

    createLineStringByJson(geoJson, id, bounds, fillColor, colorSaved, lineWidth, lineWidthSaved, lineDash, arrowHead, icons
        , dimensionId, dimensionValue, fontFamily, fontSize, isSelect) {
        // let lineCoords = [
        //    {lat: 37.772, lng: -122.214},
        //    {lat: 21.291, lng: -157.821},
        //    {lat: -18.142, lng: 178.431},
        //    {lat: -27.467, lng: 153.027}
        // ];
        const lineCoords = [];
        const dataCoords = geoJson.geometry.coordinates;
        for (let j = 0; j < dataCoords.length; j++ ) {
            const lsLatLng = { lat: dataCoords[j][1], lng: dataCoords[j][0] };
            lineCoords.push(lsLatLng);
            bounds?.extend(lsLatLng);
        }
        fillColor = (geoJson.properties?.fillColor) ? geoJson.properties.fillColor : this.singleColor;
        const color = (geoJson.properties?.color) ? geoJson.properties.color : this.singleColor;
        colorSaved = (geoJson.properties?.color) ? geoJson.properties.color : colorSaved;
        const style: any = {
            map: this.map,
            path: lineCoords,
            geodesic: true,
            // editable: true,
            draggable: true,
            strokeColor: color,
            strokeWeight: lineWidth,
            fillColor,
        };
        
        if (icons) {
            icons.push(this.styleArrow(arrowHead));
            style.icons = icons;
            style.strokeOpacity = 0;
        } else {
            style.icons = [this.styleArrow(arrowHead)];
        }

        const poline = new this.google.maps.Polyline(style);
        // poline.overlay = overlay;
        poline.type = this.google.maps.drawing.OverlayType.POLYLINE;
        poline.realType = MapDrawType.LINE_STRING;
        this.shapes.add(poline, geoJson, id, null, colorSaved, lineWidthSaved, lineDash, arrowHead, null, null, dimensionId
            , dimensionValue, isSelect);

        if (typeof dimensionId === 'string' && dimensionId.trim().length > 0 ) {
            // console.log(`**** load dimension id = ${dimensionId}
            // , dimensionValue = ${dimensionValue}
            // , createDimensionFeature`);
            const coor = {lat: dataCoords[0][1], lng: dataCoords[0][0]};
            this.createDimensionFeature(dimensionId, coor, dimensionValue, fontFamily, fontSize);
        }

        return bounds;
    }

    createMultiLineStringByJson(geoJson, bounds, fillColor, colorSaved, lineWidth, lineWidthSaved, lineDash, arrowHead, icons
        , isSelect) {
        fillColor = (geoJson.properties?.fillColor) ? geoJson.properties.fillColor : this.multiColor;
        const color = (geoJson.properties?.color) ? geoJson.properties.color : this.multiColor;
        colorSaved = (geoJson.properties?.color) ? geoJson.properties.color : colorSaved;

        const dataCoords = geoJson.geometry.coordinates;
        let idGroup = ShapeIdGroup.MULTI_LINE_STRING;
        if (arrowHead === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
            idGroup = ShapeIdGroup.MULTI_ARROW_AT_FIRST_POINT;
        } else if (arrowHead === MapDrawTypeSpecial.ARROW_AT_LAST_POINT) {
            idGroup = ShapeIdGroup.MULTI_ARROW_AT_LAST_POINT;
        }
        for (let j = 0; j < dataCoords.length; j++) {
            const mCoords = [];
            const mCoorsJson = [];
            for (let n = 0; n < dataCoords[j].length; n++) {
                const pLatLng = { lat: dataCoords[j][n][1], lng: dataCoords[j][n][0] };
                mCoords.push(pLatLng);
                mCoorsJson.push(dataCoords[j][n]);
                bounds.extend(pLatLng);
            }
            const style: any = {
                map: this.map,
                path: mCoords,
                geodesic: true,
                // editable: true,
                draggable: true,
                strokeColor: color,
                strokeWeight: lineWidth,
                fillColor,
            };
            if (icons) {
                icons.push(this.styleArrow(arrowHead));
                style.icons = icons;
                style.strokeOpacity = 0;
            } else {
                style.icons = [this.styleArrow(arrowHead)];
            }
            const poline = new this.google.maps.Polyline(style);
            // poline.overlay = overlay;
            poline.type = this.google.maps.drawing.OverlayType.POLYLINE;
            poline.realType = MapDrawType.MULTI_LINE_STRING;
            const geoFea = {
                type: FEATURE_TYPE.FEATURE,
                properties: geoJson.properties,
                geometry:{
                    type: MapDrawType.MULTI_LINE_STRING,
                    coordinates: mCoorsJson
                }
            };

            const count = this.storeDrawMultiShape(idGroup);
            this.shapes.add(poline, geoFea , idGroup + '_' + count, idGroup, colorSaved, lineWidthSaved, lineDash, arrowHead
            , null, null, null, null, isSelect);
        }
        return bounds;
    }

    initHaveJSON(featureJSON, style) {
        // console.log(`**** initHaveJSON, featureJSON = `, featureJSON);
        let bounds = new this.google.maps.LatLngBounds();
        let countPoint = 0;


        for (let i = 0; i < featureJSON.length; i++) {
            if (typeof featureJSON[i].geometry === 'undefined' || featureJSON[i].geometry === null) { continue; }
            const type = featureJSON[i].geometry.type;
            let id = 'shape_' + i;
            if (typeof featureJSON[i].properties?.dimensionId === 'string'
             && featureJSON[i].properties?.dimensionId.trim().length > 0) {
                id = featureJSON[i].properties?.dimensionId;
            }

            let color = null;
            let fillColor = null;
            let lineWidth = 2;
            let lineWidthSaved = (featureJSON[i].properties?.lineWidth ? featureJSON[i].properties.lineWidth: null);
            let lineDash = (featureJSON[i].properties?.lineDash ? featureJSON[i].properties.lineDash: null);
            const arrowHead = featureJSON[i].properties?.arrowHead;
            const icon = featureJSON[i].properties?.point;
            // const anchor = featureJSON[i].properties?.anchor ? featureJSON[i].properties?.anchor: [0.5, 0.5];
            const anchor = featureJSON[i].properties?.anchor ? featureJSON[i].properties?.anchor: null;
            let icons = null;
            if (lineDash && Array.isArray(lineDash) && lineDash.length > 1) {
                icons = [
                    {
                      icon: {
                        path: `m 0 -${lineDash[0]} l 0 ${lineDash[0]}`, // dash length
                        strokeOpacity: 1,
                        scale: lineWidth,
                      },
                      offset: "0",
                      repeat: `${(lineDash[0] + lineDash[1]) * lineWidth}px`, // dash space
                    },
                ];
            }
            let isSelect = false;
            if (this.mapType == MapComponentName.BOUNDARY && this.shapes
                && this.shapes.selectedShape
                && isEqual(this.shapes.selectedShape.geoJson?.geometry?.coordinates
                    , featureJSON[i].geometry?.coordinates) ) {
                
                isSelect = true;
            }
            switch (type) {
                case MapDrawType.POINT:
                    const obj = this.createPointByJson(featureJSON[i], id, bounds, countPoint, fillColor, color
                        , lineWidth, lineWidthSaved, lineDash, arrowHead, icon, anchor, isSelect);
                    bounds = obj.bounds;
                    countPoint = obj.countPoint;
                    break;
                case MapDrawType.MULTI_POINT: {
                    bounds = this.createMultiPointByJson(featureJSON[i], bounds, fillColor, color
                        , lineWidth, lineWidthSaved, lineDash, arrowHead, icon, anchor, isSelect);
                    break;
                }
                case MapDrawType.POLYGON: {
                    bounds = this.createPolygonByJson(featureJSON[i], id, bounds, fillColor, color
                        , lineWidth, lineWidthSaved, lineDash, arrowHead, isSelect);
                    break;
                }
                case MapDrawType.MULTI_POLYGON: {
                    bounds = this.createMultiPolygonByJson(featureJSON[i], bounds, fillColor, color
                        , lineWidth, lineWidthSaved, lineDash, arrowHead, isSelect);
                    break;
                }
                case MapDrawType.LINE_STRING: {
                    bounds = this.createLineStringByJson(featureJSON[i], id, bounds, fillColor, color
                        , lineWidth, lineWidthSaved, lineDash, arrowHead, icons
                        , featureJSON[i].properties?.dimensionId, featureJSON[i].properties?.dimension
                        , featureJSON[i].properties?.font, featureJSON[i].properties?.fontSize, isSelect);
                    break;
                }
                case MapDrawType.MULTI_LINE_STRING: {
                    bounds = this.createMultiLineStringByJson(featureJSON[i], bounds, fillColor, color
                        , lineWidth, lineWidthSaved, lineDash, arrowHead, icons, isSelect);
                    break;
                }
            }
            
        }
        return { bounds: bounds, countPoint: countPoint };
    }

    shapeObject() {
        const self = this;
        return {
            collection: {},
            selectedShape: null,
            actionType: MapDrawAction.NA,
            dragging: false,
            spawnShape: function(e, geoJson, id, idGroup, isSelect, color, lineWidth, lineDash, text, arrowHead, iconImage
                , iconAnchor, dimensionId, dimensionValue, fontFamily, fontSize) {
                self.hasDocumentChangeValue = false; // reset
                
                const shape = (e.overlay != null) ? e.overlay : e;
                shape.canRotate = true;
                shape.type = e.type;
                shape.realType = e.realType;
                // shape.id=new Date().getTime()+'_'+Math.floor(Math.random()*1000);
                shape.id = id;
                shape.idGroup = idGroup;
                shape.geoJson = geoJson;
                console.log(`***** spawnShape, idGroup = ${idGroup}, properties = ${JSON.stringify(shape?.geoJson?.properties)}`);
                if (!shape.geoJson.properties) {
                    shape.geoJson.properties = {};
                }
                shape.geoJson.properties.idGroup = idGroup;
                if (color) {
                    shape.geoJson.properties.color = color;
                    shape.geoJson.properties.fillColor = color;
                }
                if (lineWidth) {
                    shape.geoJson.properties.lineWidth = lineWidth;
                }
                if (lineDash) {
                    shape.geoJson.properties.lineDash = lineDash;
                }
                if (typeof text === 'string' && text.trim().length > 0) {
                    shape.geoJson.properties.text = text;
                    shape.geoJson.properties.textId = id;
                    shape.canRotate = false;
                }
                if (arrowHead) {
                    shape.geoJson.properties.arrowHead = arrowHead;
                }
                if (iconImage) {
                    shape.geoJson.properties.point = iconImage;
                    shape.geoJson.properties.anchor = iconAnchor;
                }
                if (typeof dimensionId === 'string' && dimensionId.trim().length > 0) {
                    shape.geoJson.properties.dimensionId = dimensionId;
                    shape.geoJson.properties.dimension = dimensionValue;
                }
                if (fontFamily) {
                    shape.geoJson.properties.font = fontFamily;
                }
                if (fontSize) {
                    shape.geoJson.properties.fontSize = fontSize;
                }
                if (shape.type == self.google.maps.drawing.OverlayType.CIRCLE
                     || shape.type == self.google.maps.drawing.OverlayType.MARKER) {
                    shape.canRotate = false;
                }

                // logger.info("add new shape, geoJson = " + JSON.stringify(geoJson) );
                this.collection[shape.id] = shape;
                if (isSelect) {
                    this.setSelection(shape);
                    this.setCenter(shape);
                }

                return shape;
            },
            add: function(e, geoJson, id, idGroup, color, lineWidth, lineDash, arrowHead, iconImage, iconAnchor, dimensionId
                , dimensionValue, isSelect) {
                
                const shape = this.spawnShape(e, geoJson, id, idGroup, isSelect, color, lineWidth, lineDash, null, arrowHead, iconImage
                    , iconAnchor, dimensionId, dimensionValue);

                self.google.maps.event.addListener(shape, 'click', () => {
                    if (self.actionType === MapDrawAction.NA) {
                        return;
                    }
                    // console.log("click shape , type = " + e.type);
                    this.setSelection(shape);
                    this.setCenter(shape);
                    if (self.actionType === MapDrawAction.DELETE) {
                        this.deleteSelected();

                        if (typeof self.setDirtyFunction === 'function') {
                            self.setDirtyFunction();
                        }
                    } else if (self.actionType === MapDrawAction.SELECT) {
                        if (shape.canRotate) {
                            self.boundingRectangle = this.getBounds(shape);
                        }
                    }
                });
                self.google.maps.event.addListener(shape, 'mousemove', () => {
                    // console.log(`**** mouse move inside shape`);
                    self.rotateObject.style.display = 'none';
                });

                self.google.maps.event.addListener(shape, 'dragstart', (evt) => {
                    console.log(`**** drag start`);
                    this.dragging = true;
                });

                // If the overlay is dragged
                self.google.maps.event.addListener(shape, 'dragend', (evt) => {
                    console.log(`**** drag end`);
                    this.dragging = false;
                    switch (e.type) {
                        case self.google.maps.drawing.OverlayType.POLYGON:
                            const paths = shape.getPaths();
                            paths.forEach((path1: any, idx: any) => {
                                this.updateCoordsPolygon(shape, path1);
                            });

                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                            break;
                        case self.google.maps.drawing.OverlayType.CIRCLE:
                            shape.geoJson.geometry.coordinates = [ shape.getCenter().lng(), shape.getCenter().lat()];
                            
                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                            break;
                        case self.google.maps.drawing.OverlayType.RECTANGLE:
                            this.updateCoordsRectangle(shape);

                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                            break;
                        case self.google.maps.drawing.OverlayType.POLYLINE:
                            const path = shape.getPath();
                            this.updateCoordsPolyline(shape, path.getArray());


                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                            break;
                        case self.google.maps.drawing.OverlayType.MARKER:
                            const lng = shape.position.lng();
                            const lat = shape.position.lat();
                            shape.geoJson.geometry.coordinates = [ lng, lat];
                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                            break;
                        
                    }

                    if (typeof self.setDirtyFunction === 'function') {
                        self.setDirtyFunction();
                    }
                });

                // edit event
                switch (e.type) {
                    case self.google.maps.drawing.OverlayType.POLYGON:
                        const paths = shape.getPaths();
                        paths.forEach((path1: any, idx: any) => {
                            self.google.maps.event.addListener(path1, 'insert_at', () => {// add new point for polygon
                                console.log("**** POLYGON insert_at " + e.type);
                                this.updateCoordsPolygon(shape, path1);
                                if (typeof self.setDirtyFunction === 'function') {
                                    self.setDirtyFunction();
                                }
                                //
                            });

                            self.google.maps.event.addListener(path1, 'set_at', () => {// change position of a point in polygon
                                // ignore this event while dragging
                                if (this.dragging == true || self.allowRotate) { return; }
                                console.log("**** POLYGON set_at " + e.type);
                                this.updateCoordsPolygon(shape, path1);
                                if (typeof self.setDirtyFunction === 'function') {
                                    self.setDirtyFunction();
                                }
                            });

                            self.google.maps.event.addListener(path1, 'remove_at', () => {// remove point of polygon
                                console.log("**** POLYGON remove_at " + e.type);
                                this.updateCoordsPolygon(shape, path1);
                                if (typeof self.setDirtyFunction === 'function') {
                                    self.setDirtyFunction();
                                }

                            });
                        });
                        // logger.info("polygon, paths = " + paths);
                        break;
                    case self.google.maps.drawing.OverlayType.CIRCLE:
                        self.google.maps.event.addListener(shape, 'radius_changed', () => {
                            console.log(`**** CIRCLE radius change `);
                            shape.geoJson.properties.radius = shape.getRadius();
                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                        });
                        break;
                    case self.google.maps.drawing.OverlayType.RECTANGLE:
                        self.google.maps.event.addListener(shape, 'bounds_changed', () => {
                            console.log(`**** RECTANGLE bounds change `);
                            this.updateCoordsRectangle(shape);
                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                        });
                        break;
                    case self.google.maps.drawing.OverlayType.POLYLINE:
                        const path = shape.getPath();
                        self.google.maps.event.addListener(path, 'insert_at', () => {// add new point for polygon
                            console.log(`**** POLYLINE insert at`);
                            this.updateCoordsPolyline(shape, path.getArray());
                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                        });
                        self.google.maps.event.addListener(path, 'set_at', () => {// change position of a point in polygon
                            console.log(`**** POLYLINE set at`);
                            this.updateCoordsPolyline(shape, path.getArray());
                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                        });
                        self.google.maps.event.addListener(path, 'remove_at', () => {// remove point of polygon
                            console.log(`**** POLYLINE remove at`);
                            this.updateCoordsPolyline(shape, path.getArray());
                            if (typeof self.setDirtyFunction === 'function') {
                                self.setDirtyFunction();
                            }
                        });
                        break;
                }
            },
            addTextBoxAnchorPoint: function(e, geoJson, id, text, fontFamily, fontSize, textId) {
                const shape = this.spawnShape(e, geoJson, id, null, false, null, null, null, text, null, null, null
                    , fontFamily, fontSize);
                shape.geoJson.properties.textId = textId;
                // this.collection[id].set('draggable', false);
                // this.collection[id].set('editable', false);
                return shape;
            },
            setText: function(text, id) {
                this.collection[id].geoJson.properties.text = text;
            },
            findById: function(id) {
                return this.collection[id];
            },
            setSelection: function(shape) {
                // console.log('*********** setSelection');
                self.hasDocumentChangeValue = false; // reset
                if (this.selectedShape !== shape) {
                    this.clearSelection();
                    this.selectedShape = shape;

                    this.selectedShape.set('draggable', true);
                    this.selectedShape.set('editable', true);
                }
            },
            deleteSelected: function() {
                self.hasDocumentChangeValue = false; // reset
                if (this.selectedShape) {
                    const shape = this.selectedShape;
                    this.clearSelection();
                    // console.log('*********** deleteSelected a shape');
                    shape.setMap(null);
                    delete this.collection[shape.id];
                }
            },
            deleteFeatureById: function(id) {
                // console.log(`*********** deleteFeatureById ${id}`);
                self.hasDocumentChangeValue = false; // reset
                if (this.collection[id]) {
                    this.collection[id].setMap(null);
                    delete this.collection[id];
                }
            },
            clearSelection: function() {
                // console.log(`*********** clearSelection`);
                self.hasDocumentChangeValue = false; // reset
                for (let key in this.collection) {
                    this.collection[key].set('draggable', false);
                    this.collection[key].set('editable', false);

                }
                if (this.selectedShape) {
                    this.selectedShape.set('draggable', false);
                    this.selectedShape.set('editable', false);
                    this.selectedShape = null;

                }
            },
            getGeoJson: function() {
                const geoJson = [];
                const dicShape: any = {}; // dictionary , key = shape.idGroup, value = shape.geoJson
                const dicShared: Record<string, any> = {}; // key = sharedId, value = GeometryCollection


                console.log(`**** getGeoJson, feature.len = ${Object.keys(this.collection).length}`);
                for (const k in this.collection) {
                    if (!this.collection.hasOwnProperty(k)) continue;

                    const shape = this.collection[k];
                    const sharedId = shape.geoJson?.properties?.sharedId;
                    

                    if (typeof sharedId === 'string') {
                        // Group into GeometryCollection
                        if (!(sharedId in dicShared)) {
                            dicShared[sharedId] = {
                                type: FEATURE_TYPE.GEOMETRY_COLLECTION,
                                geometries: [],
                                properties: {
                                    ...shape.geoJson.properties // Copy properties for first time
                                }
                            };
                        }

                        const geometries = dicShared[sharedId].geometries;
                        const isMulti = shape.realType === MapDrawType.MULTI_POINT
                                    || shape.realType === MapDrawType.MULTI_LINE_STRING
                                    || shape.realType === MapDrawType.MULTI_POLYGON;

                        const existing = geometries.find(g => g.type === shape.realType);

                        if (existing) {
                            if (isMulti) {
                                existing.coordinates.push(shape.geoJson.geometry.coordinates);
                            } else {
                                geometries.push({
                                    type: shape.realType,
                                    coordinates: shape.geoJson.geometry.coordinates
                                });
                            }                 
                        } else {
                            geometries.push({
                                type: shape.realType,
                                coordinates: isMulti
                                    ? [shape.geoJson.geometry.coordinates]
                                    : shape.geoJson.geometry.coordinates
                            });
                        }

                    } else {
                        // Not GeometryCollection
                        if (shape.realType === MapDrawType.MULTI_LINE_STRING
                            || shape.realType === MapDrawType.MULTI_POINT
                            || shape.realType === MapDrawType.MULTI_POLYGON) {
                            const coors = [];
                            for (let i = 0; i < shape.geoJson.geometry.coordinates.length; i++) {
                                coors.push( shape.geoJson.geometry.coordinates[i] );
                            }
                            if (shape.idGroup in dicShape) {
                                const obj = dicShape[shape.idGroup];
                                if (obj) {
                                    obj.geometry.coordinates.push(coors);
                                    if (self.isEmptyObject(shape.geoJson.properties) == false) {
                                        obj.properties = shape.geoJson.properties;
                                    }
                                }
                            } else {
                                const jsonData: any = {
                                    type: FEATURE_TYPE.FEATURE,
                                    geometry: {
                                        type: shape.realType,
                                        coordinates: [coors]
                                    }
                                };
                                if (self.isEmptyObject(shape.geoJson.properties) == false) {
                                    jsonData.properties = shape.geoJson.properties;
                                }
                                dicShape[shape.idGroup] = jsonData;
                            }
                        } else if (shape.realType === MapDrawType.POINT
                                && shape.type === MapDrawType.CIRCLE
                                && self.isDrawCircleAsPolygon) {
                            const coords = sclUtilMap.circleToPolygon(shape.geoJson.geometry.coordinates
                                , shape.geoJson.properties.radius);
                            const json = {
                                type: FEATURE_TYPE.FEATURE,
                                geometry: {
                                    type: MapDrawType.POLYGON,
                                    coordinates: coords
                                },
                                properties: shape.geoJson.properties,
                            };
                            json.properties.subType = MapDrawType.CIRCLE;
                            geoJson.push(json);
                        } else if(shape.realType === MapDrawType.LINE_STRING 
                            && typeof shape.geoJson.properties?.textId === 'string') {
                            continue;
                        } else {
                            try {
                                if (self.isEmptyObject(shape.geoJson.properties) == true) {
                                    delete shape.geoJson.properties;
                                }
                                geoJson.push(shape.geoJson);    
                            } catch (error) {
                                console.log(`*** error at shape: `, shape);
                                console.log(error);
                            }
                            
                        }
                    }

                    
                }

                // add geometry collection to final result
                for (const key in dicShared) {
                    if (dicShared.hasOwnProperty(key)) {
                        delete dicShared[key].properties.sharedId;
                        delete dicShared[key].properties.idGroup;

                        geoJson.push(dicShared[key]);
                    }
                }

                // add geoJson of multilinestring to final result
                for (const key in dicShape) {
                    if (dicShape.hasOwnProperty(key)) {
                        geoJson.push(dicShape[key]);
                    }
                }
                
                // collection is the result
                return geoJson;
            },
            updateCoordsPolygon: function(shape, path) {
                const newGeoJson = shape.geoJson;
                const newCoords = [];
                const len = path.getLength();
                for (let i = 0; i < len; i++) {
                    const xy = path.getAt(i);
                    newCoords.push([ xy.lng(), xy.lat() ]);
                }
                if (newCoords[0][0] !== newCoords[len - 1][0] || newCoords[0][1] !== newCoords[len - 1][1]) {
                    newCoords.push([ path.getAt(0).lng(), path.getAt(0).lat() ]);
                }
                newGeoJson.geometry.coordinates[0] = newCoords;
                shape.geoJson = newGeoJson;
            },
            updateCoordsMultiPolygon: function(shape, path, idx) {
                const newGeoJson = shape.geoJson;
                const newCoords = [];
                const len = path.getLength();
                for (let i = 0; i < len; i++) {
                    const xy = path.getAt(i);
                    newCoords.push([ xy.lng(), xy.lat() ]);
                }
                if (newCoords[0][0] !== newCoords[len - 1][0] || newCoords[0][1] !== newCoords[len - 1][1]) {
                    newCoords.push([ path.getAt(0).lng(), path.getAt(0).lat() ]);
                }
                newGeoJson.geometry.coordinates[idx][0] = newCoords;
                // logger.info("newCoords = " + newCoords);
                shape.geoJson = newGeoJson;
                // this.collection[shape.id] = shape;
            },
            updateCoordsPolyline: function(shape, path) {
                const newCoords = [];
                for (let i = 0; i < path.length; i++) {
                    newCoords.push([ path[i].lng(), path[i].lat() ]);
                }
                
                shape.geoJson.geometry.coordinates = newCoords;

                // update dimension
                if (typeof shape.geoJson?.properties?.dimensionId === 'string'
                 && shape.geoJson?.properties?.dimensionId.trim().length > 0) {
                    const pos0 = {lat: newCoords[0][1], lng: newCoords[0][0]};
                    const pos = {lat: newCoords[newCoords.length - 1][1], lng: newCoords[newCoords.length - 1][0]};
                    const distance = self.google.maps.geometry.spherical.computeDistanceBetween(pos0, pos); // meters
                    shape.geoJson.properties.dimension = distance;
                }
            },
            updateCoordsPoint: function(shape, latLng) {
                
                shape.geoJson.geometry.coordinates = [latLng.lng(), latLng.lat()];

            },
            updateCoordsRectangle: function(shape) {
                const b = shape.getBounds();
                const p = [
                        [ b.getSouthWest().lng(), b.getSouthWest().lat()],
                        [ b.getNorthEast().lng(), b.getSouthWest().lat() ],
                        [ b.getNorthEast().lng(), b.getNorthEast().lat() ],
                        [ b.getSouthWest().lng(), b.getNorthEast().lat() ],
                        [ b.getSouthWest().lng(), b.getSouthWest().lat()]
                    ];

                shape.geoJson.geometry.coordinates[0] = p;
            },
            clearAllShape: function() {
                for (const k in this.collection) {
                    if (this.collection.hasOwnProperty(k)) {
                        const shapeId = this.collection[k].id;
                        this.collection[k].setMap(null);
                        delete this.collection[shapeId];
                    }
                }
            },
            getBounds: function(shape) {
                const bounds = new self.google.maps.LatLngBounds();
                shape.getPath().forEach(function(point) {
                    bounds.extend(point);
                });
                return bounds;
            },
            getCenter: function(shape) {
                const center = sclUtilMap.getCenterOfGeometry(shape.geoJson.geometry.coordinates
                    , shape.geoJson.geometry.type);
                return new self.google.maps.LatLng(center[1], center[0]);
            },
            setCenter: function(shape) {
                if (shape.canRotate) {
                    shape.shapeCenter = this.getCenter(shape);
                }
            }
        };
    }
    
    createRotateIcon() {
        this.rotateObjectId = `${this.keyName}_rotate`;

        this.rotateObject = document.createElement('div');
        this.rotateObject.style.position = 'absolute';
        this.rotateObject.id = this.rotateObjectId;
        this.rotateObject.setAttribute('class', 'material-icons');
        this.rotateObject.innerHTML = 'autorenew';
        
        this.rotateObject.style.display = 'block';
        this.map.getDiv().appendChild(this.rotateObject);

        this.rotateIconWidth = this.rotateObject.offsetWidth;
        this.rotateIconHeight = this.rotateObject.offsetHeight;

        this.rotateObject.onmousedown = (e) => {
            console.log(`**** rotateIcon mouse down`);
            e.stopPropagation();
            e.preventDefault();
            
            this.allowRotate = true;
            
        };
        this.rotateObject.onmouseup = (e) => {
            console.log(`**** rotateIcon mouse up`);
            e.stopPropagation();
            e.preventDefault();
            
            
            this.rotateShapeDone();
        };

        setTimeout(() => {
            this.rotateObject.style.display = 'none';
        }, 200);
    }
    cacheIconForDrawing(iconInfo){
        return new Promise((resolve, reject) => {
            const url = sclUtilMap.handleImageFileNo(iconInfo.fileNo);
            // console.log(`***** cacheIconForDrawing, loading: ${url}`);

            let result = {
                fileNo: url,
                imageAnchor: [0, 0]
            };
            try {
                
                let img = new Image()
                img.onload = () => {
                    let anchor = [0.5, 0.5];
                    if (Array.isArray(iconInfo.imageAnchor)
                        && iconInfo.imageAnchor.length == 2) {
                        anchor = iconInfo.imageAnchor;
                    }
        
                    const anchorX = img.width * anchor[0];
                    const anchorY = img.height * anchor[1];
        
                    result.imageAnchor = [anchorX, anchorY]
        
                    let existed = false;
                    for (let i = 0; i < this.iconAnchors.length; i++) {
                        if (this.iconAnchors[i].fileNo === url) {
                            existed = true;
                            break;
                        }
                    }
                    if (existed === false) {
                        this.iconAnchors.push(result);
                    }
                    console.log(`***** cacheIconForDrawing, loaded: ${url}`);
                    resolve(result);
                }
                img.onerror = (error) => {
                    console.log(`***** cacheIconForDrawing, load error: ${url}`, error);
                    reject(result);
                };
                img.src = url;
            } catch (err) {
                console.log(`*** load image error: ${JSON.stringify(iconInfo)}`, err);
                reject(result);
            }
            
        })
    }

    async init(initObj, keyName) {
        super.init(initObj, keyName);
        this.isDebugRotate = true;
        this.THRESHOLD_MIN = 30;
        this.THRESHOLD_MAX = 60;
        this.rotateSpeed = 500000;
        this.defaultLat = (initObj.defaultLat ? initObj.defaultLat : -37.8);
        this.defaultLon = (initObj.defaultLon ? initObj.defaultLon : 144.9);
        this.defaultZoom = (initObj.defaultZoom ? initObj.defaultZoom : 10);
        const scrollWheel = ( initObj.disableMouseWheel ? !initObj.disableMouseWheel : true);
        if (initObj.singleSelectMode) { this.funcSingleSelectMode = initObj.singleSelectMode; }
        if (initObj.singleSelectModeCluster) { this.singleSelectModeCluster = initObj.singleSelectModeCluster; }
        if (initObj.drawStartCluster) { this.drawStartCluster = initObj.drawStartCluster; }
        if (initObj.drawEndCluster) { this.drawEndCluster = initObj.drawEndCluster; }
        this.selectedAssets = [];
        
        this.shapes = this.shapeObject();
        
        
        this.selectedFeatures = [];
        const map = new this.google.maps.Map(initObj.target, {
            center: {lat: this.defaultLat, lng: this.defaultLon},
            zoom: this.defaultZoom,
            scrollwheel: scrollWheel,
            zoomControl: true,
            mapTypeControl: true
        });
        this.map = map;
        this.createLayers(initObj, this.map);
        for (let i = 0; i < this.layerAssets.length; i++) {
            this.layerAssets[i].setMap(this.map);
        }
        // if we have saved data
        this.dicDrawShape = {};// reset
        this.loadSaveData(initObj);
        const lstControlId = [];
        if (this.ActionControls.length > 0) {
            const mapHeight = this.map.getDiv().offsetHeight;
            // let css = {'display':'grid'};
            for (let i = 0; i < this.ActionControls.length; i++) {

                for (let j = 0; j < this.ActionControls[i].childNodes.length; j++) {
                    const cId = initObj.mapId + '_control' + j;
                    this.ActionControls[i].childNodes[j].id = cId;
                    lstControlId.push(cId);
                    if (this.isBottom) {
                        // let top = (mapHeight - 40) + 'px';
                        // this.ActionControls[i].childNodes[j].style.top = top;
                        this.ActionControls[i].childNodes[j].style.display = 'flex';

                        const div = document.createElement('div');
                        div.id = cId + '_div';
                        div.classList.add('gg-custom-control-bottom'); // must define this class in css of each component
                        // the gg map default button width is 40px
                        div.style.width = (this.ActionControls[i].childNodes[j].childNodes.length / 2 * this.drawToolButtonSize) + 'px';
                        // console.log('%c add control div id = ' + div.id, 'color:blue');
                        div.appendChild(this.ActionControls[i].childNodes[j]);

                        this.map.controls[this.google.maps.ControlPosition.BOTTOM_LEFT].push(div);
                        this.divCustomControl = div;
                    } else {
                        const div = document.createElement('div');
                        div.id = cId + '_div';
                        div.style.marginLeft = '10px';
                        div.classList.add('gg-custom-control'); // must define this class in css of each component
                        let h = 0;
                        for (let k = 0; k < this.ActionControls[i].childNodes[j].childNodes.length; k++) {
                            if (this.ActionControls[i].childNodes[j].childNodes[k].tagName.toLowerCase() === 'label') {
                                h += this.drawToolButtonSize; // the gg map default button height is 40px
                            }
                        }
                        div.style.height = h + 'px'; // total height of label

                        div.appendChild(this.ActionControls[i].childNodes[j]);

                        this.map.controls[this.google.maps.ControlPosition.LEFT_CENTER].push(div);
                        this.divCustomControl = div;
                    }

                }
            }

        }
        this.map.addListener( 'tilesloaded', this.onMapTilesloaded.bind(this, initObj));
        this.map.addListener('zoom_changed', this.onMapZoomChanged.bind(this));
        if (this.mapType === MapComponentName.ADDRESS_MAP) {
            this.styleAddress(null);
            if (typeof initObj.selectionStyle !== 'undefined' && initObj.selectionStyle !== null) {
                this.selectionStyle = initObj.selectionStyle;
            }
            // add click event for each layer asset & layer filter, this is this.google.map.data
            this.setLayerSelectAsset();

        } else if (this.mapType === MapComponentName.SELECTED_ASSET) { // sc-selected-asset
            if (typeof initObj.primaryAssetSelection !== 'undefined' && initObj.primaryAssetSelection !== null) {
                this.primaryAssetSelection = initObj.primaryAssetSelection;
            }
            if (typeof initObj.secondaryAssetSelection !== 'undefined' && initObj.secondaryAssetSelection !== null) {
                this.secondaryAssetSelection = initObj.secondaryAssetSelection;
            }
            this.addressImageAnchor = initObj.addressImageAnchor;
            this.primaryImageAnchor = initObj.primaryImageAnchor;
            this.secondaryImageAnchor = initObj.secondaryImageAnchor;
            this.styleAsset(null);
        } else if (this.mapType === MapComponentName.BOUNDARY) {
            this.mapDiv.addEventListener('click', this.mapDivOnClick.bind(this));
            // this.mapDiv.addEventListener('mousemove', this.mapDivOnMouseMove.bind(this));
            // this.mapDiv.addEventListener('mousedown', this.onMapMouseDown.bind(this));
            this.mapDiv.addEventListener('mouseup', this.mapDivOnMouseUp.bind(this));
            this.mapDiv.addEventListener('dblclick', this.mapDivOnDoubleClick.bind(this));
            this.createRotateIcon();
        }
        this.map.setOptions({draggableCursor: 'default'});
        this.map.addListener('idle', this.onMapIdle.bind(this));
        // 15336#c59379
        this.map.addListener('bounds_changed', this.onMapBoundsChanged.bind(this, initObj));
    }
    async loadSaveData(initObj) {
        // get the icon size to calculate the anchor of an icon
        if (this.drawIcons.length > 0) {
            for (let i = 0; i < this.drawIcons.length; i++) {
                try {
                    await this.cacheIconForDrawing(this.drawIcons[i]);
                    // console.log('***** loadSaveData, cacheIconForDrawing ' + i);
                } catch (error) {
                    console.log('***** Error in loadSaveData, cacheIconForDrawing ' + i, error);
                }
            }
        }

        if (initObj.formatGeoJSON && initObj.formatGeoJSON.features) {
            const featureJSON = initObj.formatGeoJSON.features;
            for (let i = 0; i < featureJSON.length; i++) {
                const icon = featureJSON[i].properties?.point;
                const anchor = featureJSON[i].properties?.anchor ? featureJSON[i].properties?.anchor: [0.5, 0.5];
                if (icon) {
                    try {
                        await this.cacheIconForDrawing({ fileNo: icon, imageAnchor: anchor });
                        // console.log('***** loadSaveData, cacheIconForDrawing ' + i + ' of formatGeoJSON.features');
                    } catch (error) {
                        console.log('***** Error in loadSaveData, cacheIconForDrawing ' + i + ' of formatGeoJSON.features', error);
                    }
                }
            }
            this.checkAndDrawGeoJson(initObj.formatGeoJSON);
        }
    }
    onMapTilesloaded(initObj) {
        // tiles have been loaded
        console.log('%c tiles have been loaded', 'color:blue');
        if (this.setupTooltipUI && (typeof this.setupTooltipUI === 'function')) {
            this.setupTooltipUI();
            this.setupTooltipUI = null; // call one time when init map
        }

        if (this.bounds != null) {
            // logger.info("|===> tiles have been loaded, self.bounds = " + JSON.stringify(self.bounds));
            this.map.fitBounds(this.bounds);
            this.map.setCenter(this.bounds.getCenter());
            this.map.panToBounds(this.bounds);

            if (this.mapType === MapComponentName.SELECTED_ASSET) {
                if (this.fitCoordCount === 1) {
                    let currentZoom = this.map.getZoom();
                    currentZoom = currentZoom - 2;
                    if (currentZoom < 0) { currentZoom = 1; }
                    this.map.setZoom(currentZoom);
                }
            } else {
                let len = 0;
                if (initObj.formatGeoJSON && initObj.formatGeoJSON.features) {
                    len = initObj.formatGeoJSON.features.length;
                }
                if (this.countPoint != null && initObj != null && initObj.formatGeoJSON.features.length === this.countPoint) {
                    const pointZoom = ((this.map.getZoom() - 5) < 1) ? 5 : (this.map.getZoom() - 5);
                    // logger.info("pointZoom = " + pointZoom);
                    this.map.setZoom( pointZoom );
                }
            }
            this.clampZoomFloor();
        }
        if (initObj.setupMapDone != null ) {
            initObj.setupMapDone(true); // test test
        }

        if (this.onTilesLoaded != null) { this.onTilesLoaded(); }

        this.isMapReady = true;
        this.google.maps.event.clearListeners(this.map, 'tilesloaded'); // make sure tilesload event call one time

        this.setupZoomButton(initObj);  

    }
    onMapZoomChanged() {
        const z = this.map.getZoom();
        // console.log('%c zoom change = ' + z , 'color:blue');
        if (this.mapType === MapComponentName.ADDRESS_MAP
             || this.mapType === MapComponentName.SELECTED_ASSET
             || this.mapType === MapComponentName.BOUNDARY
             || this.mapType === MapComponentName.STREET_ADDRESS) {// sc-address-map || sc-selected-asset
            if (this.onTilesLoaded != null) { this.onTilesLoaded(); }

            this.showHeatLayer(z); // if we have heat map and zoomLevel
        }
    }
    onMapIdle() {
        // console.log('%c idle ', 'color:blue');
        this.finishAddIcon();
        if (this.mapType !== MapComponentName.ADDRESS_MAP) {
            setTimeout(() => {
                this.updateRotateScaleByZoom();
            }, 250);
        }
    }
    onMapBoundsChanged(initObj) {
        // console.log('%c bounds_changed ', 'color:blue');
        const fullscreen = this.checkFullScreen();
        this.isFullScreen = fullscreen.hasFullScreen;

        if (this.fullScreenEvent != null && typeof this.fullScreenEvent === 'function') {
            this.fullScreenEvent(fullscreen.mapDivHeight, this.isFullScreen);
        }
        this.setupZoomButton(initObj);
        if (this.mapType === MapComponentName.BOUNDARY) {
            this.showStylingSubMenu(null, false);
            this.updateMenuChildCss();
        }
    }
    checkFullScreen() {
        const childs = $(this.map.getDiv()).children();
        const childLen = childs?.length;
        let hasFullScreen = false;
        let mapDivHeight = this.map.getDiv().clientHeight;
        let mapDivWidth = this.map.getDiv().clientWidth;
        for (let i = 0; i < childLen; i++) {
            if ( childs.eq(i).height() == window.innerHeight &&
            childs.eq(i).width()  == window.innerWidth ) {
                // console.log('FULL SCREEN');
                hasFullScreen = true;
                mapDivHeight = window.innerHeight;
                mapDivWidth = window.innerWidth;
                break;
            }
        }
        return {hasFullScreen, mapDivHeight, mapDivWidth};
    }

    setupZoomButton(initObj) {
        // 14479#0053120 ( just use for comp-dev )
        // -- find button zoom in
        if (this.findBtnZoomIn == null) {
            this.findBtnZoomIn = setInterval( () => this.setupBtnZoomIn(this, initObj), 200);
        }
        if (this.findBtnZoomOut == null) {
            this.findBtnZoomOut = setInterval( () => this.setupBtnZoomOut(this, initObj), 200);
        }
    }
    setupBtnZoomIn(self, initObj) {
        self.btnZoomIn = initObj.target.querySelector('[aria-label=\'Zoom in\']');
        if (self.btnZoomIn) {
            self.btnZoomIn.id = initObj.target.id + 'ZoomIn';

            self.btnZoomIn.addEventListener('mouseover', () => {
                self.btnZoomIn.setAttribute('title', 'Zoom in (' + this.map.getZoom() + ')');
            } );

            self.btnZoomIn.addEventListener('click', (e) => {
                // console.log(`**** click zoom in`);
                e.stopPropagation();
            });

            clearInterval(self.findBtnZoomIn);
            self.findBtnZoomIn = null;
            self.findBtnZoomInCount = 0; // reset
        } else {
            self.findBtnZoomInCount++;
            if (self.findBtnZoomInCount > self.findBtnZoomLimit) {
                clearInterval(self.findBtnZoomIn);
                self.findBtnZoomIn = null;
                self.findBtnZoomInCount = 0; // reset
            }
        }
    }
    setupBtnZoomOut(self, initObj) {
        self.btnZoomOut = initObj.target.querySelector('[aria-label=\'Zoom out\']');
        if (self.btnZoomOut) {
            self.btnZoomOut.id = initObj.target.id + 'ZoomOut';

            self.btnZoomOut.addEventListener('mouseover', () => {
                self.btnZoomOut.setAttribute('title', 'Zoom out (' + this.map.getZoom() + ')');
            } );

            self.btnZoomOut.addEventListener('click', (e) => {
                // console.log(`**** click zoom out`);
                e.stopPropagation();
            });

            clearInterval(self.findBtnZoomOut);
            self.findBtnZoomOut = null;
            self.findBtnZoomOutCount = 0; // reset
        } else {
            self.findBtnZoomOutCount++;
            if (self.findBtnZoomOutCount > self.findBtnZoomLimit) {
                clearInterval(self.findBtnZoomOut);
                self.findBtnZoomOut = null;
                self.findBtnZoomOutCount = 0; // reset
            }
        }
    }

    checkTransparenImgIsCluster(width, height) {
        let isCluster = false;
        for (let i = 0; i < this.clusterImageSize.length; i++) {
            if (this.clusterImageSize[i].width === width && this.clusterImageSize[i].height === height) {
                isCluster = true;
                break;
            }
        }
        return isCluster;
    }

    // 14405
    hideImgTransparency(cb) {
        if (this.checkImgTransparent) {
            if (cb && typeof cb === 'function') { cb(); }
            return;
        }
        this.checkImgTransparent = setInterval(() => {
            const lst = document.querySelectorAll('[src="https://maps.gstatic.com/mapfiles/transparent.png"]');
            // console.log('%c hideImgTransparency, lst.len = ' + lst.length, 'color:blue');
            if (lst && lst.length > 0) {
                let root = null;
                for (let i = 0; i < lst.length; i++) {
                    // this div is for multipoint, if remove it we can't select multipoint by clicking
                    if (lst[i].clientWidth === 16 || this.checkTransparenImgIsCluster( lst[i].clientWidth, lst[i].clientHeight )) { continue; }
                    const parent = lst[i].parentNode;
                    root = parent.parentNode;
                    if (root) {
                        root.removeChild(parent);
                    }
                }
                clearInterval(this.checkImgTransparent);
                this.checkImgTransparent = null;
                if (cb && typeof cb === 'function') { cb(); }
            } else {
                this.checkImgTransparentCount++;
                if (this.checkImgTransparentCount > 10) {
                    clearInterval(this.checkImgTransparent);
                    this.checkImgTransparent = null;
                    this.checkImgTransparentCount = 0;

                    if (cb && typeof cb === 'function') { cb(); }
                }
            }

        }, 200);

    }

    finishAddIcon() {
        // this.hideImgTransparency(() => { // 15492: no need to check Image transparent
            if (this.updateLocationMarkers.length > 0) {

                if (!this.marker) {
                    const geom = new this.google.maps.Data.Point(this.updateLocationMarkers[0].coor);
                    this.marker = new this.google.maps.Data.Feature();
                    this.marker.setGeometry(geom);

                    if (this.markerImage != null) { // 15260
                        this.marker.setProperty('icon', this.markerImage);
                    }

                    this.marker.setProperty('zIndex', this.layerIndexAddress);
                    this.marker.setProperty('id', this.updateLocationMarkers[0].proId);
                    this.marker.id = this.updateLocationMarkers[0].proId;
                    this.layerAssets[this.layerIndexAddress].add(this.marker);
                }
                if (this.updateLocationMarkers && this.updateLocationMarkers.length > 0) {
                    this.marker.setGeometry( new this.google.maps.Data.Point(
                        this.updateLocationMarkers[this.updateLocationMarkers.length - 1].coor) );
                }
                this.updateLocationMarkers = []; // reset
            }
        // }); // 15492: no need to check Image transparent
    }

    showHeatLayer(zoom) {
        // if we have heat map and zoomLevel
        for (const f in this.heatLayerConfig) {
            if (typeof this.heatLayerConfig[f].zoomLevel !== 'undefined') {
                if (zoom < this.heatLayerConfig[f].zoomLevel) {
                    this.layerAssets[f].setMap(null);
                } else { this.layerAssets[f].setMap(this.map); }
            }
        }
    }

    // use for sc-address-map
    removeSelectedAsset(id0) {
        let isRemove = false;  
        for (let i = this.selectedFeatures.length - 1; i > -1; i--) {
            const id = this.getFeatureId(this.selectedFeatures[i]);
            if (id && id.indexOf(id0) > -1 ) {
                this.layerAssets[this.layerIndexUser].remove(this.selectedFeatures[i]);
                this.selectedFeatures.splice(i, 1);
                isRemove = true;
                this.layerAssets[this.layerIndexUser].forEach((feature) => {
                    const id = this.getFeatureId(feature);
                    if (id && id.indexOf(id0) > -1 ) {
                        this.layerAssets[this.layerIndexUser].remove(feature);
                    }
                });
            }
        }
        if (isRemove) {
            if (this.setDirtyFunction) {
                this.setDirtyFunction(this.selectedFeatures);
            }
        }
        return isRemove;
    }
    setLayerSelectAsset() {
        const self = this;
        // for(let i = 0; i < this.layerIndexFilter + 1; i++){
        for (let i = 0; i < this.layerAssets.length; i++) {
            if (this.layerAssets[i].get('isCluster')) { continue; }
            this.layerAssets[i].addListener('click', function(event) {
                if (self.multipleSelection) {
                    if (!event || !event.feature) { return; }
                    const layerDisplayOnly = self.getFeatureProperty(event.feature, 'layerDisplayOnly');
                    if (layerDisplayOnly) { return; }

                    if (self.selectedFeatures == null) { self.selectedFeatures = []; }
                    const fs = self.getFeaturesCollection({feature: event.feature});
                    if (fs.length > 0) {
                        let isDirty = false;
                        for (let j = 0; j < fs.length; j++) {
                            const f = fs[j].feature;
                            const fId = self.getFeatureId(f);
                            let added = false;
                            for (let k = self.selectedFeatures.length - 1; k > -1; k--) {
                                const kId = self.getFeatureId(self.selectedFeatures[k]);
                                if (kId === fId) { // if(self.selectedFeatures[k].j.properties.id === f.j.properties.id){
                                    added = true;
                                    break;
                                }
                            }
                            if (!added) {
                                f.setProperty('zIndex', self.layerIndexUser); // f.j.properties.zIndex = self.layerIndexUser;
                                self.selectedFeatures.push(f);
                                self.layerAssets[self.layerIndexUser].add(f);
                                isDirty = true;
                                break;
                            }
                        }
                        if (isDirty && self.setDirtyFunction) {
                            self.setDirtyFunction(self.selectedFeatures);
                        }
                    }
                } else {
                    // logger.info("Latitude: "+event.latLng.lat()+" "+", longitude: "+event.latLng.lng() );
                    if (self.funcSingleSelectMode) {
                        const pixel = self.map.getProjection().fromLatLngToPoint(event.latLng);
                        const id = self.getFeatureId(event.feature);
                        self.funcSingleSelectMode({id: id, pixel : pixel});
                    }

                }
            });
        }
        this.layerAssets[this.layerIndexUser].addListener('click', (event) => {
            if (this.multipleSelection) {
                let id0 = self.getFeatureId(event.feature); // event.feature.j.properties.id;

                if (id0 && id0.indexOf('_') > -1) { id0 = id0.split('_')[0]; }
                this.removeSelectedAsset(id0);
            }
            
        });
    }
    setSelectAssetCluster(feature) {
        if (this.multipleSelection) {
            

            if (this.selectedFeatures == null) { this.selectedFeatures = []; }
            // const fs = this.getFeaturesCollection({feature: feature});
            // fs.push({feature});
            const fs = feature; // [{feature}];
            if (fs.length > 0) {
                let isDirty = false;
                for (let j = 0; j < fs.length; j++) {
                    const f = fs[j].feature;
                    const layerDisplayOnly = this.getFeatureProperty( f, 'layerDisplayOnly');
                    if (layerDisplayOnly) { continue; }
                    const fId = this.getFeatureId(f);
                    let added = false;
                    for (let k = this.selectedFeatures.length - 1; k > -1; k--) {
                        const kId = this.getFeatureId(this.selectedFeatures[k]);
                        if (kId === fId) { // if(self.selectedFeatures[k].j.properties.id === f.j.properties.id){
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        f.setProperty('zIndex', this.layerIndexUser);
                        this.selectedFeatures.push(f);
                        this.layerAssets[this.layerIndexUser].add(f);
                        isDirty = true;
                    }
                }
                if (isDirty && this.setDirtyFunction) {
                    this.setDirtyFunction(this.selectedFeatures);
                }
            }
        } else {
            // logger.info("Latitude: "+event.latLng.lat()+" "+", longitude: "+event.latLng.lng() );
            if (this.funcSingleSelectMode) {
                const pixel = this.map.getProjection().fromLatLngToPoint(feature.getPostion().latLng());
                const id = this.getFeatureId(feature);
                this.funcSingleSelectMode({id: id, pixel : pixel});
            }

        }
    }

    styleArrow(arrowHead) {
        if (arrowHead === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
            return {
                icon: {
                    path: this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    rotation: 180,
                },
                offset: `0%`,
            }
        } else if (arrowHead === MapDrawTypeSpecial.ARROW_AT_LAST_POINT) {
            return {
                icon: {
                    path: this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                },
                offset: `100%`,
            }
        }
        return {};
    }

    styleBoundary(color) {
        return{
            fillColor: color,
            strokeWeight: 1
        };
    }

    calculateSizeScaleInfo(scale, originWidth, originHeight) {
        let scaledWidth = originWidth;
        let scaledHeight = originHeight;
        let top = 0; let left = 0; let isFlip = false;
        if (isNumber(scale) && scale != 1) {
            const value = Math.abs(scale);
            scaledWidth *= value; scaledHeight *= value;
            left = scaledWidth * value; top = scaledHeight * value;
            if (scale < 0) { isFlip = true; }
        } else if (isArray(scale)) {
            if (isNumber(scale[0]) && scale[0] != 1) {
                const value0 = Math.abs(scale[0]);
                scaledWidth *= value0;
                left = scaledWidth * value0;
                if (scale[0] < 0) { isFlip = true; }
            }
            if (isNumber(scale[1]) && scale[1] != 1) {
                const value1 = Math.abs(scale[1]);
                scaledHeight *= value1;
                top = scaledHeight * value1;
            }
        }

        return { scaledWidth, scaledHeight, top, left, isFlip };
    }

    iconScaleStop(idx, pIcon) {
        this.dynamicIconScale = this.dynamicIconScale.replace(pIcon + ';', '');
        const intervalId = this.dynamicIconScaleInterval[idx];
        clearInterval(intervalId);
        this.dynamicIconScaleInterval.splice(idx, 1);
        this.dynamicIconScaleCount.splice(idx, 1);
    }

    iconScaleStopAll() {
        this.dynamicIconScaleInterval.forEach((interval, i) => {
            clearInterval(interval);
        });
        this.dynamicIconScale = ''; // [];
        this.dynamicIconScaleCount = [];
    }

    iconScale(pIcon, originWidth, originHeight, scaledWidth, scaledHeight, top, left, isFlip) {
        const isScale = (scaledWidth != originWidth || scaledHeight != originHeight);
        if (this.dynamicIconScale.indexOf(pIcon) < 0 && (isScale || isFlip)) {
            this.dynamicIconScale += pIcon + ';';
            this.dynamicIconScaleCount.push(0);
            this.dynamicIconScaleInterval.push(
                setInterval(() => {
                    const idx = this.dynamicIconScale.indexOf(pIcon);
                    if (idx < 0) {
                        console.log('%c Exception when scale asset ' + pIcon, 'color:blue');
                        // stop all scaling
                        this.iconScaleStopAll();
                    } else {
                        if ($(`img[src="${pIcon}"]`) && $(`img[src="${pIcon}"]`).length > 0) {
                            const css = $(`img[src="${pIcon}"]`).attr('style');
                            let doneScale = false; let doneFlip = false;
                            let appendStyleScale = ''; let appendStyleFlip = '';
                            if (isScale) {
                                const cssTop = $(`img[src="${pIcon}"]`).css('margin-top');
                                if (!cssTop || cssTop === '0px') { // css top = 0 is default of google api
                                    // console.log('*** Set scale for image');
                                    appendStyleScale = 'width: ' + scaledWidth + 'px !important;'
                                     + ' height: ' + scaledHeight + 'px !important;'
                                     + ' margin-top: ' + top + 'px !important;'
                                     + ' margin-left: ' + left + 'px !important;'
                                     + ' max-width: ' + scaledWidth + 'px !important;'
                                     + ' max-height: ' + scaledHeight + 'px !important;';
                                    this.dynamicIconScaleCount[idx]++;
                                } else {
                                    doneScale = true;
                                    // console.log('*** doneScale, cssTop = ' + cssTop);
                                }
                            }
                            if (isFlip) {
                                
                                if (css && css.indexOf('transform') > -1) { 
                                    doneFlip = true;
                                    // console.log('*** doneFlip, css = ' , css);
                                } else {
                                    appendStyleFlip = '-webkit-transform: scaleX(-1) !important;'
                                     + ' -moz-transform: scaleX(-1) !important;'
                                     +' -ms-transform: scaleX(-1) !important;'
                                     + ' transform: scaleX(-1) !important;';
                                    this.dynamicIconScaleCount[idx]++;
                                    // console.log('*** Set flip for image');
                                }
                            }
                            // console.log('appendStyleScale = ' +  appendStyleScale
                            // + '\n\t, appendStyleFlip = ' + appendStyleFlip);
                            if (!doneScale || !doneFlip) {
                                $(`img[src="${pIcon}"]`).css('cssText', css + appendStyleScale + appendStyleFlip);
                            }
                            if (this.dynamicIconScaleCount[idx] > this.dynamicIconScaleLimit) {
                                console.log('Out of limmit for setting scale for image has src = ' + pIcon
                                + ', css = ' + css);
                                console.log($(`img[src="${pIcon}"]`));
                                this.iconScaleStop(idx, pIcon);
                            }
                            if ((isScale && doneScale && isFlip && doneFlip)
                             || (isScale && doneScale && !isFlip)
                             || (isFlip && doneFlip && !isScale)) {
                                this.iconScaleStop(idx, pIcon);
    
                                const a = $(`img[src="${pIcon}"]`).attr('style');
                                const img = $(`img[src="${pIcon}"]`);
                                // console.log('***** done scale: ' + isScale + ', flip: ' + isFlip
                                //  + ', css = ' + a + ', img = ', img);
                                // console.log('******* for ', ($(`img[src="${pIcon}"]`)));
                            }
                            if (isScale && doneScale && isFlip && doneFlip) {
                                this.iconScaleStop(idx, pIcon);
                                // console.log('***** done scale & flip for ', ($(`img[src="${pIcon}"]`)));
                            } else if (isScale && doneScale && !isFlip) {
                                this.iconScaleStop(idx, pIcon);
                                // console.log('***** done scale & no flip for ', ($(`img[src="${pIcon}"]`)));
                            } else if (isFlip && doneFlip && !isScale) {
                                this.iconScaleStop(idx, pIcon);
                                // console.log('***** done flip & no scale for ', ($(`img[src="${pIcon}"]`)));
                            }
                            
                        } else {
                            console.log('Waiting google map init image has src = ' + pIcon + '...');
                            this.dynamicIconScaleCount[idx]++;
                            if (this.dynamicIconScaleCount[idx] > this.dynamicIconScaleLimit) {
                                console.log('Error when google map init image has src = ' + pIcon);
                                this.iconScaleStop(idx, pIcon);
                            }
                        }
                    }
                    
                }, 200)
            );
        }
    }

    iconRotateStop(idx, pIcon) {
        this.dynamicIconRotate = this.dynamicIconRotate.replace(pIcon + ';', '');
        const intervalId = this.dynamicIconRotateInterval[idx];
        clearInterval(intervalId);
        this.dynamicIconRotateInterval.splice(idx, 1);
        this.dynamicIconRotateCount.splice(idx, 1);
    }

    iconRotateStopAll() {
        this.dynamicIconRotateInterval.forEach((interval, i) => {
            clearInterval(interval);
        });
        this.dynamicIconRotate = ''; // [];
        this.dynamicIconRotateCount = [];
    }

    iconRotate(pIcon, rotation, id) {
        if (this.dynamicIconRotate.indexOf(pIcon) < 0 && rotation && rotation != 0 ) {
            const cssRotate = 'rotate('+ rotation +'deg)';
            
            this.dynamicIconRotate += pIcon + ';';
            this.dynamicIconRotateCount.push(0);
            this.dynamicIconRotateInterval.push( 
                setInterval(() => {
                    const idx = this.dynamicIconRotate.indexOf(pIcon);
                    if (idx < 0) {
                        console.log('%c Exception when rotating asset ' + pIcon, 'color:blue');
                        // stop all rotating
                        this.iconRotateStopAll();
                    } else {
                        const parent = $(`img[src="${pIcon}"]`).parent();
                        const css = parent.attr('style');
                        if ( css && css.indexOf('transform') > -1 ) { 
                            this.iconRotateStop(idx, pIcon);

                            if ($(`#${id}`).css('zIndex') < parent.css('zIndex')) { // set label always above icon
                                $(`#${id}`).css('zIndex', parent.css('zIndex') + 1 );
                            }
                            
                            // console.log('***** done rotation setStyle for ' + pIcon + ', cssRotate = ' + cssRotate
                            //  + ', parent = ', parent);
                        } else {
                            const appendRotate = '-webkit-transform: ' + cssRotate + ' !important;'
                             + '-moz-transform: ' + cssRotate + ' !important;'
                             + '-ms-transform: ' + cssRotate + ' !important;'
                             + '-o-transform: ' + cssRotate + ' !important;'
                             + 'transform: ' + cssRotate + ' !important;';
                            parent.css('cssText', css + appendRotate);
                            // if ($(`#${id}`).css('zIndex') < parent.css('zIndex')) { // set label always above icon
                            //     $(`#${id}`).css('zIndex', parent.css('zIndex') + 1 );
                            // }

                            // console.log('*** Set rotation for image has src = ' + pIcon);
                            // console.log('appendRotate = ' + appendRotate + ', div = ', parent);
                            this.dynamicIconRotateCount[idx]++;
                            if (this.dynamicIconRotateCount[idx] > this.dynamicIconRotateLimit) {
                                console.log('Out of limit for rotating image has src = ' + pIcon);
                                this.iconRotateStop(idx, pIcon);
                            }
                        }
                    }
                    
                }, 200)
            );
            
        }
    }


    styleFeature(feature) {
        if (feature == null) { return { }; }// if(feature == null || feature.j == null) return { };
    
        const p: any = this.getFeatureProperties(feature, ['color', 'lineWidth', 'type', 'lineDash', 'fillColor', 'fillOpacity'
            , 'zIndex', 'icon', 'size', 'anchor', 'rotation', 'scale', 'scaledInfo', 'id', 'circle', 'lineWidth'
            , 'fillColor']);
        // console.log('***** BEGIN:: styleAsset, id = ' + p.id + ', scale = ' + p.scale);
        const zIndex = p.zIndex;
        let color = 'gray';
        const pColor = p.color;
        if (pColor) { color = pColor; }
        let strokeWeight = 2;
        const lineWidth = p.lineWidth;
        if (lineWidth) { strokeWeight = lineWidth; }

        

        const type = p.type;

        // linedash
        let aIcon = [];
        const lineDash = p.lineDash;
        if (lineDash && Array.isArray(lineDash) && lineDash.length > 1) {
            const lineSymbol = {
                path: `m 0 -${lineDash[0]} l 0 ${lineDash[0]}`, // dash length
                strokeOpacity: 1,
                scale: strokeWeight,
                strokeColor: color,
                strokeWeight,
                fillColor: color
            };
            aIcon = [{
                icon: lineSymbol,
                offset: '0',
                repeat: `${(lineDash[0] + lineDash[1]) * strokeWeight}px`, // dash space
            }];
        }

        // fill color
        let fillColor = color;
        const pFillColor = p.fillColor;
        if (pFillColor) { fillColor = pFillColor; }

        // fillopacity
        let fillOpa = 0;
        const pFillOpacity = p.fillOpacity;
        if (pFillOpacity) { fillOpa = pFillOpacity; }
        
        if (type === MapDrawType.MULTI_POINT) {
            const dot = {
                path: this.google.maps.SymbolPath.CIRCLE,
                strokeOpacity: 0.9,
                scale: 7,
                strokeColor: color,
                strokeWeight: strokeWeight,
                fillColor: fillColor,
                fillOpacity: fillOpa
            };
            return ({
                icon: dot,
                fillOpacity: fillOpa,
                fillColor: color,
                strokeColor: color,
                strokeWeight: strokeWeight,
                zIndex: zIndex
            });
        }
        let pIcon = p.icon;
        
        if (pIcon) {
            const iconIndex = this.cacheImageUrls.indexOf(pIcon);
            // pIcon = pIcon + '#' + p.id;
            let objStyle = null;
            const size = p.size;

            if (iconIndex < 0) {
                console.log(`*** NULL STYLE HERE ************`);
                return null;
            }

            const image = this.cacheImages[iconIndex];
            let strBase64 = this.cacheImageBase64s[iconIndex];
            if (this.mapType === MapComponentName.ADDRESS_MAP) {
                if ((p.rotation && p.rotation != 0) || (p.scale && p.scale != 1)) {
                    const isFlip =  p.scale < 0 ? true : false;
                    const infoId = pIcon + '#' + p.rotation
                    + '#' + p.scale + '#' + isFlip;
                    let infoIndex = this.cacheImageModifiedInfo.indexOf(infoId);
                    if (infoIndex < 0) {
                        return null;
                    }
                    strBase64 = this.cacheImageModifiedBase64[infoIndex];
                    if (p.rotation != 0) {
                        let size = image.width;
                        if (image.width < image.height) { size = image.height; }
                        image.width = size;
                        image.height = size;
                    }
                    if (p.scale != 1) {
                        image.width *= p.scale;
                        image.height *= p.scale;
                    }
                }
            }
            
            if (!size) {
                objStyle = ({
                    icon: strBase64,
                    fillOpacity: fillOpa,
                    fillColor: color,
                    strokeColor: color,
                    strokeWeight: strokeWeight,
                    zIndex: zIndex
                });

                if (p.scale && !p.scaledInfo) {
                    if (p.scaledInfo) {
                        objStyle.icon.scaledSize = new this.google.maps.Size(p.scaledInfo.w, p.scaledInfo.h);
                    } else {
                        if (this.mapType === MapComponentName.ADDRESS_MAP) {
                            p.scaledInfo = {
                                w: image.width, h: image.height
                                , top: 0, left: 0
                                , isFlip: ( p.scale < 0 ? true : false )
                            };
                            feature.setProperty('scaledInfo', p.scaledInfo);

                            
                        } else {
                            const scaleInfo = this.calculateSizeScaleInfo(p.scale, image.width, image.height);

                            if (scaleInfo.scaledWidth != image.width || scaleInfo.scaledHeight != image.height) {
                                
                                objStyle.icon.scaledSize = new this.google.maps.Size(scaleInfo.scaledWidth, scaleInfo.scaledHeight);
                                
                                p.scaledInfo = {
                                    w: scaleInfo.scaledWidth, h: scaleInfo.scaledHeight
                                    , top: scaleInfo.top, left: scaleInfo.left
                                    , isFlip: scaleInfo.isFlip
                                };
                                feature.setProperty('scaledInfo', p.scaledInfo);
                            }
                        }
                        
                    }
                }

                feature.setProperty('size', [image.width, image.height]);
            } else {
                const anchorInfo = p.anchor;
                if (anchorInfo && anchorInfo.length > 1) {
                    let anchorX = anchorInfo[0] * size[0];
                    let anchorY = anchorInfo[1] * size[1];
                    const aIconA = {
                        url: strBase64, // url: pIcon,
                        anchor: new this.google.maps.Point(anchorX, anchorY)
                    };
                    objStyle = ({
                        icon: aIconA,
                        fillOpacity: fillOpa,
                        fillColor: color,
                        strokeColor: color,
                        strokeWeight: strokeWeight,
                        zIndex: zIndex
                    });
                } else {
                    objStyle = ({
                        icon: strBase64,
                        fillOpacity: fillOpa,
                        fillColor: color,
                        strokeColor: color,
                        strokeWeight: strokeWeight,
                        zIndex: zIndex
                    });
                }
                if (p.scale && p.scale != 1) {
                    let scaledWidth = size[0]; let scaledHeight = size[1];
                    let top = 0; let left = 0; let isFlip = false;
                    if(p.scaledInfo) {
                        scaledWidth = p.scaledInfo.w; scaledHeight = p.scaledInfo.h;
                        top = p.scaledInfo.top; left = p.scaledInfo.left;
                        isFlip = p.scaledInfo.isFlip;
                    } else {
                        const scaleInfo = this.calculateSizeScaleInfo(p.scale, p.size[0], p.size[1]);
                        scaledWidth = scaleInfo.scaledWidth; scaledHeight  = scaleInfo.scaledHeight;
                        top = scaleInfo.top; left  = scaleInfo.left;
                        isFlip = scaleInfo.isFlip;
                        p.scaledInfo = {
                            w: scaleInfo.scaledWidth, h: scaleInfo.scaledHeight
                            , top: scaleInfo.top, left: scaleInfo.left
                            , isFlip: scaleInfo.isFlip
                        };
                        feature.setProperty('scaledInfo', p.scaledInfo);
                    }
                    if (this.mapType !== MapComponentName.ADDRESS_MAP) {
                        this.iconScale(pIcon, size[0], size[1], scaledWidth, scaledHeight, top, left, isFlip);
                    }
                }
            }
            if (this.mapType !== MapComponentName.ADDRESS_MAP) {
                this.iconRotate(pIcon, p.rotation, p.id);
            }
            
            return objStyle;
        } else {
            let objStyle;
            if (aIcon.length > 0 && (type === MapDrawType.LINE_STRING
                 || type === MapDrawType.MULTI_LINE_STRING)) {
                objStyle = ({
                    icons: aIcon,
                    fillColor: fillColor,
                    fillOpacity: fillOpa,
                    strokeColor: color,
                    strokeWeight: strokeWeight,
                    strokeOpacity: 0,
                    zIndex: zIndex
                });
            } else {
                objStyle = ({
                    fillColor: fillColor,
                    fillOpacity: fillOpa,
                    strokeColor: color,
                    strokeWeight: strokeWeight,
                    zIndex: zIndex
                });
            }
            return objStyle;
        }
    }

    styleAddress(feature = null) {
        return this.styleFeature(feature);
        
    }

    styleStAddress(feature) {
        let color = 'red';
        const p: any = this.getFeatureProperties(feature, ['color', 'icon']);
        const pColor = p.color;
        const pIcon = p.icon;
        if ( pColor) { color = pColor; }
        if ( pIcon) {
            // tslint:disable-next-line: no-redundant-jsdoc
            return /** @type {!this.google.maps.Data.StyleOptions} */({
                icon: pIcon,
                fillColor: color,
                strokeColor: color,
                strokeWeight: 1
            });
        } else {
            return{
                fillColor: color,
                strokeWeight: 1
            };
        }

    }

    styleAsset(feature) {
        return this.styleFeature(feature);
    }
    getRotationDegrees(obj) {
        const matrix = obj.css("-webkit-transform") ||
        obj.css("-moz-transform")    ||
        obj.css("-ms-transform")     ||
        obj.css("-o-transform")      ||
        obj.css("transform");
        let angle = 0; 
        if(matrix && matrix !== 'none') {
            const values = matrix.split('(')[1].split(')')[0].split(',');
            const a = values[0];
            const b = values[1];
            angle = Math.round(Math.atan2(b, a) * (180/Math.PI));
        } else { angle = 0; }
        return (angle < 0) ? angle + 360 : angle;
    }

    

    styleSelectedFunc(feature) {
        const fGeom = feature.getGeometry();
        const fType = fGeom.getType();
        const z = this.layerIndexUser;
        if (typeof this.selectionStyle !== 'undefined' && this.selectionStyle !== null) {
            // feature.j.properties;
            const p: any = this.getFeatureProperties(feature, ['color', 'lineWidth', 'lineDash', 'icon', 'anchor'])
            const pColor = p.color;
            const lineWidth = p.lineWidth;
            const lineDash = p.lineDash;
            const pIcon = p.icon;

            const color = (this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : pColor);
            const fillColor = (this.selectionStyle.selectionFill ? this.selectionStyle.selectionFill : color) ;
            const opacity = (this.selectionStyle.selectionFillOpacity ? this.selectionStyle.selectionFillOpacity : 0.5 );
            let strokeWeight = 2;
            // logger.info("|===> color = " + color + ", fillColor = " + fillColor + ", opacity = " + opacity);

            if ( lineWidth) { strokeWeight = lineWidth; }
            const fId = this.getFeatureId(feature);
            if (fType === MapDrawType.MULTI_POINT) {
                // tslint:disable-next-line: no-redundant-jsdoc
                return /** @type {!this.google.maps.Data.StyleOptions} */({
                    icon: {
                        path: this.google.maps.SymbolPath.CIRCLE ,
                        strokeOpacity: 0.9,
                        scale: 7,
                        strokeColor: color,
                        strokeWeight: strokeWeight,
                        fillColor: fillColor,
                        fillOpacity: opacity
                    },
                    fillOpacity: opacity,
                    fillColor: fillColor,
                    strokeColor: color,
                    strokeWeight: strokeWeight,
                    zIndex: z
                });
            }

            
            if (pIcon) {
                let icon = pIcon;
                let anchor = p.anchor;

                if (this.selectionStyle) {
                    if (this.selectionStyle.selectionImageFileNo) {
                        icon = this.selectionStyle.selectionImageFileNo;
                    }
                    if (this.selectionStyle.selectionImageAnchor) {
                        anchor = this.selectionStyle.selectionImageAnchor;
                    }
                }
                const iconIndex = this.cacheImageUrls.indexOf(icon);
                if (iconIndex < 0) {
                    return null;
                }
                
                const strBase64 = this.cacheImageBase64s[iconIndex];

                const st1 = {
                    icon: strBase64,
                    zIndex: z
                };
                return st1;
            } else {
                // normal
                const st: any = {
                    fillColor: fillColor,
                    strokeColor: color,
                    strokeWeight,
                    fillOpacity: opacity,
                    strokeOpacity: 1,
                    zIndex: z
                };
                if (fType === MapDrawType.LINE_STRING || fType === MapDrawType.MULTI_LINE_STRING) {
                    // linedash
                    if ( lineDash && Array.isArray(lineDash) && lineDash.length > 1) {
                        const lineSymbol = {
                            path: `m 0 -${lineDash[0]} l 0 ${lineDash[0]}`, // dash length,
                            strokeOpacity: 1,
                            scale: strokeWeight,
                            strokeColor: color,
                            strokeWeight,
                            fillColor: color
                        };
                        st.icons = [{
                            icon: lineSymbol,
                            offset: '0',
                            repeat: `${(lineDash[0] + lineDash[1]) * strokeWeight}px`, // dash space
                        }];
                        st.strokeOpacity = 0;
                    }
                    return st;
                }
            }
        }
    }
    stylePrimaryAssetFunc(feature) {
        return this.styleSelectedAssetFunc(feature, this.primaryAssetSelection, this.layerIndexPrimary, SclMapConstantService.MAP_PRIMARY_ASSET
        , this.primaryImageAnchor, SclMapConstantService.MAP_PRIMARY_ASSET);
    }
    styleSecondaryAssetFunc(feature) {
        return this.styleSelectedAssetFunc(feature, this.secondaryAssetSelection, this.layerIndexSecondary
            , SclMapConstantService.MAP_SECONDARY_ASSET, this.secondaryImageAnchor, SclMapConstantService.MAP_SECONDARY_ASSET);
    }

    styleSelectedAssetFunc(feature, assetSelection, layerIndex, iconDefault, anchorDefault, assetType) {
        const fGeom = feature.getGeometry();
        const fType = fGeom.getType();
        const z = layerIndex;
        if (typeof assetSelection !== 'undefined' && assetSelection !== null){
            const p: any = this.getFeatureProperties(feature, ['lineWidth', 'color', 'zIndex', 'lineDash', 'icon', 'anchor'
                , 'assetType', 'primary', 'secondary', 'id']);
            let isPrimary = true;
            if (assetType === SclMapConstantService.MAP_PRIMARY_ASSET) {
                if (p.primary) {
                    assetSelection.selectionImageFileNo = p.primary.image;
                    assetSelection.selectionImageAnchor = p.primary.anchor;
                    assetSelection.selectionImageRotation = p.primary.rotation;
                    assetSelection.selectionColor = p.primary.color;
                    assetSelection.selectionFill = p.primary.fillColor;
                    assetSelection.selectionFillOpacity = p.primary.fillOpacity;
                    assetSelection.selectionLineCap = p.primary.lineCap;
                    assetSelection.selectionLineDash = p.primary.lineDash;
                    assetSelection.selectionLineWidth = p.primary.lineWidth;
                } else if (!assetSelection.selectionImageFileNo) {
                    assetSelection.selectionImageFileNo = SclMapConstantService.MAP_PRIMARY_ASSET;
                }
            } else if (assetType === SclMapConstantService.MAP_SECONDARY_ASSET) {
                isPrimary = false;
                if (p.secondary) {
                    assetSelection.selectionImageFileNo = p.secondary.image;
                    assetSelection.selectionImageAnchor = p.secondary.anchor;
                    assetSelection.selectionImageRotation = p.secondary.rotation;
                    assetSelection.selectionColor = p.secondary.color;
                    assetSelection.selectionFill = p.secondary.fillColor;
                    assetSelection.selectionFillOpacity = p.secondary.fillOpacity;
                    assetSelection.selectionLineCap = p.secondary.lineCap;
                    assetSelection.selectionLineDash = p.secondary.lineDash;
                    assetSelection.selectionLineWidth = p.secondary.lineWidth;
                } else if (!assetSelection.selectionImageFileNo) {
                    assetSelection.selectionImageFileNo = SclMapConstantService.MAP_SECONDARY_ASSET;
                }
            }

            assetSelection = sclUtilMap.checkStyleValue(assetSelection, isPrimary);
            
            // feature.j.properties;
            let strokeWeight = 2;
            let lineWidth = p.lineWidth;
            if (assetSelection.selectionLineWidth) { lineWidth = assetSelection.selectionLineWidth; }
            const pColor = p.color;
            const zIndex = p.zIndex;
            let lineDash = p.lineDash;
            if (assetSelection.selectionLineDash) { lineDash = assetSelection.selectionLineDash; }
            const pIcon = p.icon;
            if (lineWidth) { strokeWeight = lineWidth; }
            
            let color = (assetSelection.selectionColor ? assetSelection.selectionColor : pColor);
            const fillColor = (assetSelection.selectionFill ? assetSelection.selectionFill : color) ;
            const opacity = (assetSelection.selectionFillOpacity ? assetSelection.selectionFillOpacity : 0.5 );

            if (fType === MapDrawType.MULTI_POINT) {
                return ({
                    icon: {
                        path: this.google.maps.SymbolPath.CIRCLE ,
                        strokeOpacity: 0.9,
                        scale: 7,
                        strokeColor: color,
                        strokeWeight: strokeWeight,
                        fillColor: fillColor,
                        fillOpacity: opacity
                    },
                    fillOpacity: opacity,
                    fillColor: fillColor,
                    strokeColor: color,
                    strokeWeight: strokeWeight,
                    zIndex: zIndex
                });
            }

            
            if (pIcon) {
                let icon = pIcon;
                let anchor = p.anchor;
                let rotation = 0;
                const pAssetType = p.assetType;
                if (assetSelection) {
                    if (assetSelection.selectionImageFileNo) {
                        icon = assetSelection.selectionImageFileNo; // 15783 // '/api/getFile/' + selection.selectionImageFileNo;
                    }
                    if (assetSelection.selectionImageAnchor) {
                        anchor = assetSelection.selectionImageAnchor;
                    }
                    if (assetSelection.selectionImageRotation) {
                        rotation = assetSelection.selectionImageRotation;
                    }
                } else {
                    // if (icon === iconDefault) { anchor = anchorDefault; }
                    if (icon === SclMapConstantService.MAP_PRIMARY_ASSET) { anchor = this.primaryImageAnchor;
                    } else if (icon === SclMapConstantService.MAP_SECONDARY_ASSET) { anchor = this.secondaryImageAnchor;
                    } else if (icon === SclMapConstantService.MAP_MARKER) { anchor = [0.5, 1]; }// system defined image
                }
                if (anchor === undefined || anchor === null) {
                    // if (icon === iconDefault) {
                    //     anchor = [0.5, 1]; // system defined image
                    // } else {
                    //     if (pAssetType === assetType && anchorDefault !== undefined) {
                    //         anchor = anchorDefault;
                    //     } else { anchor = [0.5, 0.5]; } // no image anchor & is override image
                    // }
                    if (icon === SclMapConstantService.MAP_PRIMARY_ASSET || icon === SclMapConstantService.MAP_SECONDARY_ASSET
                        || icon === SclMapConstantService.MAP_MARKER) {
                        anchor = [0.5, 1]; // system defined image
                    } else {
                        if (typeof p.assetType !== 'undefined' && p.assetType === MapSelectAssetType.PRIMARY) {
                            if (this.primaryImageAnchor !== undefined) { anchor = this.primaryImageAnchor; }
                            if (p.primary) { anchor = p.primary.anchor; }
                        } else if (typeof p.assetType !== 'undefined' && p.assetType === MapSelectAssetType.SECONDARY) {
                            if (this.secondaryImageAnchor !== undefined) { anchor = this.secondaryImageAnchor; }
                            if (p.secondary) { anchor = p.secondary.anchor; }
                        } else { anchor = [0.5, 0.5]; }// no image anchor & is override image
                    }
                }
                icon = icon + '#' + p.id;
                const image = {
                    url: icon,
                    // anchor: anchor,
                    // origin: new this.google.maps.Point(0, 0)
                };
                
                const st = {
                    icon: image,
                    // fillColor: fillColor,
                    // strokeColor: color,
                    // strokeWeight: strokeWeight,
                    // strokeOpacity: (fType == "LineString" ? 0 : 1),
                    zIndex: z
                };

                this.iconRotate(icon, rotation, p.id);
                return st;
            } else {
                // style has no icon
                const st: any = {
                    fillColor: fillColor,
                    strokeColor: color,
                    strokeWeight: strokeWeight,
                    strokeOpacity: 1,
                    zIndex: z
                };
                
                if (fType === MapDrawType.LINE_STRING || fType === MapDrawType.MULTI_LINE_STRING) {
                    // linedash
                    if (lineDash && Array.isArray(lineDash) && lineDash.length > 1) {
                        const lineSymbol = {
                            path: `m 0 -${lineDash[0]} l 0 ${lineDash[0]}`, // dash length,
                            strokeOpacity: 1,
                            scale: strokeWeight,
                            strokeColor: color,
                            strokeWeight,
                            fillColor: color
                        };
                        st.icons = [{
                            icon: lineSymbol,
                            offset: '0',
                            repeat: `${(lineDash[0] + lineDash[1]) * strokeWeight}px`, // dash space
                        }];
                        st.strokeOpacity = 0;
                    }
                }
                return st;
            }
        }
    }

    point2LatLng(point) {
        let topRight = this.map
          .getProjection()
          .fromLatLngToPoint(this.map.getBounds().getNorthEast());
        let bottomLeft = this.map
          .getProjection()
          .fromLatLngToPoint(this.map.getBounds().getSouthWest());
        let scale = Math.pow(2, this.map.getZoom());
        let worldPoint = new google.maps.Point(
          point.x / scale + bottomLeft.x,
          point.y / scale + topRight.y
        );
        return this.map.getProjection().fromPointToLatLng(worldPoint);
    };

    distanceBetween2LatLngInPixel(latLng1, latLng2) {
        const projection = this.map.getProjection();
        const zoom = this.map.getZoom();
        const worldCoordinate1 = projection.fromLatLngToPoint(latLng1);
        const worldCoordinate2 = projection.fromLatLngToPoint(latLng2);

        const scale = Math.pow(2, zoom);

        const pixelCoordinate1 = new this.google.maps.Point(
            worldCoordinate1.x * scale,
            worldCoordinate1.y * scale
        );

        const pixelCoordinate2 = new this.google.maps.Point(
            worldCoordinate2.x * scale,
            worldCoordinate2.y * scale
        );

        const pixelDistance = Math.sqrt(
            Math.pow(pixelCoordinate2.x - pixelCoordinate1.x, 2) +
            Math.pow(pixelCoordinate2.y - pixelCoordinate1.y, 2)
        );
        return pixelDistance;
    }

    mapDivOnClick(e) {
        // console.log(`**** this.drawTypeSpecific = ${this.drawTypeSpecific}
        // , this.drawType = ${this.drawType}`);
        if (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
            // console.log(`**** mapDivOnClick, this.vertexes.length = ${this.vertexes.length}
            // , this.vertexes = `, this.vertexes);
            const latLng = this.getMapLatLngOnDomPosition(e);
            if (latLng == null) {
                return;
            }
            this.vertexes.push(latLng);
            
            if (this.vertexes.length == 2) {
                // add arrow
                const color = (this.isDrawModeSingle ? this.singleColorDraging : this.multiColorDraging);
                const bearing = this.google.maps.geometry.spherical.computeHeading(this.vertexes[1], this.vertexes[0] );

                if (this.arrow == null) {
                    this.arrow = new this.google.maps.Marker({
                        position: this.vertexes[0],
                        icon: {
                            path: this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                            fillColor: color,
                            strokeColor: color,
                            scale: (this.lineWidthCurrentSelected ? this.lineWidthCurrentSelected : 2),
                            rotation: bearing,
                        },
                    });
                    this.arrow.setMap(this.map);
                } else {
                    this.arrow.setPosition(this.vertexes[0]);
                }
                
            }

            const path = this.sketch.getPath();
            path.push(latLng);

        } else if (this.drawTypeSpecific === MapDrawTypeSpecial.DIMENSION) {
            // console.log(`**** map div click`);
            const latLng = this.getMapLatLngOnDomPosition(e);
            if (latLng == null) {
                return;
            }

            this.vertexes.push(latLng);
            if (this.vertexes.length == 1) {
                const id = uuid.v1();
                this.createDimensionFeature(id, latLng, null, this.fontCurrentSelected
                    , this.fontSizeCurrentSelected);
                this.sketch.dimensionId = id;
            }
            const path = this.sketch.getPath();
            path.push(latLng);
        } else if (this.drawType !== MapDrawType.NA && this.sketch) {
            this.isDrawing = true;
            const latLng = this.getMapLatLngOnDomPosition(e);
            if (latLng == null) {
                return;
            }
            console.log(`***** mapDivOnClick add coordinate to sketch, lat = ${latLng.lat()}
                , lng = ${latLng.lng()}`);
            this.vertexes.push(latLng);
            
            let path;
            switch(this.drawType) {
                case MapDrawType.MARKER:
                case MapDrawType.TEXT:
                    this.sketch.setPosition(latLng);
                    this.finishDrawShape(false);
                    break;
                case MapDrawType.CIRCLE:
                    if (this.isSetRadius == false) {
                        this.sketch.setCenter(latLng);
                        this.isSetRadius = true;
                    } else {
                        this.finishDrawCircle();
                    }
                    break;
                case MapDrawType.LINE_STRING:
                    path = this.sketch.getPath();
                    path.push(latLng);
                    break;
                case MapDrawType.POLYGON:
                    path = this.sketch.getPath();
                    const len = path.getLength();
                    if (this.vertexes.length == 1) {
                        path.setAt(0, latLng);
                    } else {
                        if (this.vertexes.length > 2) {
                            const distance = this.distanceBetween2LatLngInPixel(this.vertexes[0]
                                , this.vertexes[this.vertexes.length - 1]);
                            // console.log(`**** distance = ${distance}`);
                            if (distance < 10) {
                                path.setAt(len - 1, path.getAt(0));
                                this.finishDrawShape(false);
                            } else {
                                // path.push(latLng);    
                                path.setAt(len - 1, latLng);
                                path.push(latLng);
                            }
                        } else {
                            path.setAt(len - 1, latLng);
                            path.push(latLng);
                        }
                    }
                    break;
                case MapDrawType.BOX:
                    if (this.isSetRadius == false) {
                        this.sketch.setBounds(new this.google.maps.LatLngBounds(latLng, latLng));
                        this.isSetRadius = true;
                    } else {
                        this.finishDrawRectangle();
                        
                    }
                    break;
                default: break;
            }
            
            

        }
    }
    getMapPositionInPixel(e) {
        const offset = e?.target?.getClientRects()[0];
        if (offset && e?.clientX) {
            const point = {
                x: e?.clientX - offset?.left,
                y: e?.clientY - offset?.top,
            }
            return point;
        }
        return null;
    }
    getMapLatLngOnDomPosition(e) {
        const point = this.getMapPositionInPixel(e);
        if (point) {
            const pos = this.point2LatLng(point);
            return pos;
        }
        return null;
    }
    updatePositionSketchPoint(latLng) {
        if (!this.sketch) { return; }

        this.sketch.setPosition(latLng);
    }
    updatePositionSketchLineString(latLng) {
        if (!this.sketch) { return; }

        let path = this.sketch.getPath();
        const len = path.getLength();
        if (len == 0) {
            return;
        }
        if (len < 2) {
            path.push(latLng);
            // console.log(`**** updatePosition mousemove, push, len = ${len}
            // , latLng = [${latLng.lng()}, ${latLng.lat()}]`);
        } else {
            path.setAt(len - 1, latLng);
            // console.log(`**** updatePosition mousemove, setAt len -1, len = ${len}
            // , latLng = [${latLng.lng()}, ${latLng.lat()}]`);
            
        }
    }
    updatePositionSketchPolygon(latLng) {
        if (!this.sketch || this.vertexes.length == 0) {
            // console.log(`**** updatePosition mousemove QUIT`);
            return;
        }

        let path = this.sketch.getPath();
        const len = path.getLength();
        // console.log(`**** updatePosition mousemove, paths = ${JSON.stringify(path.getArray())}`);
        if (len < 2) {
            path.push(latLng);
            // console.log(`**** updatePosition mousemove, push, len = ${len}`);
        } else {
            path.setAt(len - 1, latLng);
            // console.log(`**** updatePosition mousemove, setAt len -1, len = ${len}`);
        }
    }
    updateRadiusSketchCircle(latLng) {
        if (!this.sketch || this.vertexes.length == 0) { return; }

        const center = this.sketch.getCenter();
        var distance = this.google.maps.geometry.spherical.computeDistanceBetween(center, latLng);
        // console.log(`**** center = [${center.lng()}, ${center.lat()}]
        // , latLng = [${latLng.lng()}, ${latLng.lat()}]
        // , distance = ${distance}, vertex.len = ${this.vertexes.length}`);
        this.sketch.setRadius(distance);
    }
    updatePositionSketchRectangle(latLng) {
        if (!this.sketch || this.vertexes.length == 0) { return; }

        let bounds = this.sketch.getBounds();

        const pivot = this.vertexes[0];

        if (latLng.lng() < pivot.lng()) {
            bounds = new this.google.maps.LatLngBounds(latLng, pivot);
        } else {
            bounds = new this.google.maps.LatLngBounds(pivot, latLng);
        }

        
        this.sketch.setBounds(bounds);
    }
    finishDrawShape(isUseEscape) {
        this.isDrawing = false;
        const completeObject = {
            type: this.currentDrawingMode,
            overlay: this.sketch,
        };
        const finishSetup = this.finishDrawingSetup();
        switch(this.drawType) {
            case MapDrawType.MARKER:
            case MapDrawType.TEXT:
                this.finishDrawPoint(completeObject, finishSetup.color, finishSetup.idGroup
                    , finishSetup.id, finishSetup.colorSaved, finishSetup.lineWidthSave
                    , finishSetup.lineDash, finishSetup.arrowHead);
                break;
            case MapDrawType.LINE_STRING:
                this.finishDrawPolyline(completeObject, finishSetup.color, finishSetup.idGroup
                    , finishSetup.id, finishSetup.colorSaved, finishSetup.lineWidthSave
                    , finishSetup.lineDash, finishSetup.arrowHead);
                break;
            case MapDrawType.POLYGON:
                this.finishDrawPolygon(completeObject, finishSetup.color, finishSetup.idGroup
                    , finishSetup.id, finishSetup.colorSaved, finishSetup.lineWidthSave
                    , finishSetup.lineDash, finishSetup.arrowHead);
                break;
            case MapDrawType.CIRCLE:
                if (isUseEscape) {
                    this.finishDrawCircle();
                }
                break;
            case MapDrawType.BOX:
                if (isUseEscape) {
                    this.finishDrawRectangle();
                }
                break;
            default: break;
        }
    }
    mapDivOnDoubleClick(e) {
        if (this.drawType === MapDrawType.NA) { return; }
        
        console.log(`***** onMapDoubleClick`);
        
        this.finishDrawShape(false);
    }
    rotatePoint(point, origin, angle) {
        var angleRad = angle * Math.PI / 180.0;
        return {
            x: Math.cos(angleRad) * (point.x - origin.x) - Math.sin(angleRad) * (point.y - origin.y) + origin.x,
            y: Math.sin(angleRad) * (point.x - origin.x) + Math.cos(angleRad) * (point.y - origin.y) + origin.y
        };
    }
    rotatePolygon(polygon, vertexes, centerPoint, angle) {
        const prj = this.map.getProjection();
        const origin = prj.fromLatLngToPoint(centerPoint)
    
        const coords = vertexes.getArray().map((latLng) => {
            const point = prj.fromLatLngToPoint(latLng);
            const rotatedLatLng =  prj.fromPointToLatLng(this.rotatePoint(point, origin, angle));
            // console.log(`**** rotatedLatLng: ${rotatedLatLng}
            // , lat = ${rotatedLatLng?.lat()}, lng = ${rotatedLatLng?.lng()}`);
            return {lat: rotatedLatLng.lat(), lng: rotatedLatLng.lng()};
        });
        polygon.setPath(coords);
        this.hasRotate = true;
        return polygon;
    }
    rotateShapeDone() {
        this.allowRotate = false;
        if (this.shapes && this.shapes.selectedShape) {
            this.shapes.setCenter(this.shapes.selectedShape);
            switch(this.shapes.selectedShape.type) {
                case this.google.maps.drawing.OverlayType.POLYGON:
                    const paths = this.shapes.selectedShape.getPaths();
                    paths.forEach((path1: any, idx: any) => {
                        this.shapes.updateCoordsPolygon(this.shapes.selectedShape, path1);
                    });

                    break;
                case this.google.maps.drawing.OverlayType.CIRCLE:
                    this.shapes.selectedShape.geoJson.geometry.coordinates =
                     [ this.shapes.selectedShape.getCenter().lng(),
                        this.shapes.selectedShape.getCenter().lat()];
                    
                    break;
                case this.google.maps.drawing.OverlayType.RECTANGLE:
                    this.shapes.updateCoordsRectangle(this.shapes.selectedShape);

                    break;
                case this.google.maps.drawing.OverlayType.POLYLINE:
                    const path = this.shapes.selectedShape.getPath();
                    this.shapes.updateCoordsPolyline(this.shapes.selectedShape, path.getArray());

                    break;
                case this.google.maps.drawing.OverlayType.MARKER:
                    if (this.shapes.selectedShape.realType === MapDrawType.MULTI_POINT) {
                        const lng = this.shapes.selectedShape.position.lng();
                        const lat = this.shapes.selectedShape.position.lat();
                        this.shapes.selectedShape.geoJson.geometry.coordinates = [ lng, lat];
                    }
                    break;
                default: break;
            }
        }
        if (this.hasRotate) {
            this.hasDocumentChangeValue = false;
            this.hasRotate = false; // reset

            if (typeof this.setDirtyFunction === 'function') {
              this.setDirtyFunction();
            }
        }
    }
    mapDivOnMouseMove(e) {
        // console.log(`**** mapDivOnMouseMove  currentDrawingType = ${this.currentDrawingMode}`);
        if (this.drawTypeSpecific === MapDrawTypeSpecial.DIMENSION) {
            // console.log(`**** currentDimensionId = ${this.currentDimensionId}
            // , dimensionOverlays: `, this.dimensionOverlays);
            if (this.vertexes.length > 0 && this.currentDimensionId !== null) {
                const label = document.getElementById(`${this.keyName}__dimension-label__${this.currentDimensionId}}`);
                if (label === null) {
                    return;
                }

                if (this.vertexes.length < 2) {
                    this.vertexes.push(e.latLng);
                }

                this.updatePositionSketchLineString(e.latLng);
                this.updateDimensionPosition(this.currentDimensionId);

                
            }
        } else if (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
            if (this.vertexes.length > 0) {

                this.updatePositionSketchLineString(e.latLng);
            }
        } else if (this.isDrawing) {
            const latLng = e.latLng;
            switch(this.currentDrawingMode) {
                case google.maps.drawing.OverlayType.MARKER:
                    // this.updatePositionSketchPoint(latLng);
                    break;
                case google.maps.drawing.OverlayType.CIRCLE:
                    this.updateRadiusSketchCircle(latLng);
                    break;
                case google.maps.drawing.OverlayType.POLYLINE:
                    this.updatePositionSketchLineString(latLng);
                    break;
                case google.maps.drawing.OverlayType.POLYGON:
                    this.updatePositionSketchPolygon(latLng);
                    break;
                case google.maps.drawing.OverlayType.RECTANGLE:
                    this.updatePositionSketchRectangle(latLng);
                    break;
                default: break;
            }
               
        } else if (this.actionType === MapDrawAction.SELECT) {
            if (this.shapes.selectedShape == null ||
                 this.shapes.selectedShape.canRotate == false) { return; }
            const isInsideShape = this.google.maps.geometry.poly.containsLocation(e.latLng, this.shapes.selectedShape);
            // console.log(`**** isInsideShape = ${isInsideShape}`);
            if (isInsideShape) {
                this.rotateObject.style.display = 'none';
                return;
            }

            const vertices = this.shapes.selectedShape.getPath();
            for (let i = 0; i < vertices.getLength(); i++) {
                const distance = this.google.maps.geometry.spherical.computeDistanceBetween(
                    e.latLng, vertices.getAt(i));
                // console.log(`**** distance = ${distance}`);
                if (distance > this.THRESHOLD_MIN && distance < this.THRESHOLD_MAX) {
                    const heading = this.google.maps.geometry.spherical.computeHeading(
                        vertices.getAt(i), e.latLng);
                    const latLng = this.google.maps.geometry.spherical.computeOffset(
                        e.latLng, 10, heading);
                    const position = this.getPixelByLatLng(latLng);
                    const isInShape = this.google.maps.geometry.poly.containsLocation(latLng, this.shapes.selectedShape);
                    if (position && !isInShape) {
                        this.rotateObject.style.left = `${(position.x - this.rotateIconWidth / 2)}px`;
                        this.rotateObject.style.top = `${(position.y - this.rotateIconHeight / 2)}px`;
    
                        this.rotateObject.style.display = 'block';
                    } else {
                        this.rotateObject.style.display = 'none';
                    }
                    break;
                } else {
                    this.rotateObject.style.display = 'none';
                }
            }
            
            const shapeCenter = this.shapes.selectedShape.shapeCenter;
            if (typeof shapeCenter === 'undefined' || shapeCenter === null) {
                // console.log(`**** shape center is NULL: ${shapeCenter}, shape = `, this.shapes.selectedShape);
                return;
            }
            if (this.allowRotate) {
                if (this.previousMousePosition) {
                    const deltaLng = e.latLng.lng() - this.previousMousePosition.lng();
                    const speed = deltaLng * this.rotateSpeed;
                    
                    this.shapes.selectedShape = this.rotatePolygon(this.shapes.selectedShape, vertices, shapeCenter, speed);
                }
                  
                // Update the previous mouse position
                this.previousMousePosition = e.latLng;
            }
        }
    }

    mapDivOnMouseUp(e) {
        if (this.actionType === MapDrawAction.SELECT) {
            console.log(`**** mapDivOnMouseUp`);
            if (typeof this.textBoxOnMouseUp === 'function') {
              this.textBoxOnMouseUp();
              this.textBoxOnMouseUp = null; // reset
            }
            
            this.rotateShapeDone();
          }
    }

    interactionSelectMultiple(isActive, cb) {
    };

    addInteractionSnap() {
    }
    removeInteractionSnap() {
    }
    addInteractionDraw(drawStart, drawEnd) {
        // this.hideImgTransparency();
        if (drawStart != null && drawEnd != null) {
            // for(let i = 1; i < this.layerIndexFilter + 1; i++){
            for (let i = 1; i < this.layerAssets.length; i++) {
                if (this.layerAssets[i].get('isCluster')) { continue; }
                this.layerAssets[i].addListener('click', function(event) {
                    const latLng = event.latLng;
                    const obj = {latLng: [ latLng.lng(), latLng.lat() ], clickFeature : event.feature};
                    drawStart(obj);
                    drawEnd(obj);
                });
            }
        }
    }
    removeInteractionDraw() {
        if (this.drawingManager) {
            this.drawingManager.setDrawingMode(null);
        }
        // this.google.maps.event.clearListeners(this.map.data, 'click');
        // for(let i = 1; i < this.layerIndexFilter + 1; i++){
        for (let i = 1; i < this.layerAssets.length; i++) {
            this.google.maps.event.clearListeners(this.layerAssets[i], 'click');
        }
    }

    clearSelection() {
        if (this.selectedShape) {
            // this.selectedShape.setEditable(false);
            this.selectedShape = null;
        }
    }

    setSelection(shape) {
        this.clearSelection();
        this.selectedShape = shape;
    }


    deselectAllControlBtn(currentBtnId) {
        if (this.shapes) {
            this.shapes.actionType = MapDrawAction.NA;
            this.shapes.clearSelection();
        }

        for (let i = 0; i < this.controlBtns.length; i++) {
            if (!this.controlBtns[i] || this.controlBtns[i].id === currentBtnId) { continue; }
            this.controlBtns[i].style.backgroundColor = 'white';
        }

        this.vertexes = []; // reset
        this.drawTypeSpecific = null; // reset
        this.sketch?.setMap(null);
        this.sketch = null; // reset
        this.isSetRadius = false; // reset
        this.isDrawing = false; // reset
    }

    modeAction(e) {
        e.stopPropagation();
        this.hideDrawTools();
        this.showMenu(false);
        this.showMenuButton(true);
        this.showTooltip = true;

        this.deselectAllControlBtn(e.currentTarget.id);

        // hide circle, box
        const cssOnlySingleMode = (this.isDrawModeSingle ? 'block': 'none');
        for (let i = 0; i < this.drawButtonsForOnlySingleMode.length; i++) {
            this.drawButtonsForOnlySingleMode[i].style.display = cssOnlySingleMode;
        }

        if (this.allowDrawingMode !== MapDrawMode.ALL) { return; }

        if (this.isDrawModeSingle) {
            if (e && e.currentTarget && e.currentTarget.title ) {
                e.currentTarget.title = 'Multi mode';
            }
            this.isDrawModeSingle = false;
            this.modeLabel.innerHTML = 'layers';

        } else {
            if (e && e.currentTarget && e.currentTarget.title ) {
                e.currentTarget.title = 'Single mode';
            }
            this.isDrawModeSingle = true;
            this.modeLabel.innerHTML = 'layers_clear';
        }
        this.drawingManager.markerOptions.icon.fillColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.markerOptions.icon.strokeColor = (this.isDrawModeSingle  ? this.singleColor : this.multiColor);
        this.drawingManager.circleOptions.fillColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.circleOptions.strokeColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.polylineOptions.fillColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.polylineOptions.strokeColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.rectangleOptions.fillColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.rectangleOptions.strokeColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.polygonOptions.fillColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        this.drawingManager.polygonOptions.strokeColor = (this.isDrawModeSingle ? this.singleColor : this.multiColor);

        
    }

    selectAction(e) {
        e.stopPropagation();

        this.hideDrawTools();
        this.showMenuButton(true);
        this.drawType = MapDrawType.NA;
        this.drawTypeSpecific = null;

        this.deselectAllControlBtn(e.currentTarget.id);
        if (e.currentTarget.style.backgroundColor === 'grey'){
            e.currentTarget.style.backgroundColor = 'white';
            this.actionType = MapDrawAction.NA;
            this.showTooltip = true;
        } else {
            e.currentTarget.style.backgroundColor = 'grey';
            this.actionType = MapDrawAction.SELECT;
            this.showTooltip = false;
        }
    }

    updateMenuChildCss() {
        const fullscreen = this.checkFullScreen();
        const mapDivSize = (this.isBottom ? fullscreen.mapDivHeight : fullscreen.mapDivWidth);
        this.updateDrawingSubMenuCss(mapDivSize);
    }


    showMenu(isShow) {
        if (!this.drawMenuChild) { return; }
        const displayBottom = (this.isBottom ? 'block': 'flex');
        const display = (isShow ? displayBottom: 'none');
        this.drawMenuChild.style.display = display;
        this.showMenuChilds(isShow);
    
        const cssOnlySingleMode = (this.isDrawModeSingle ? 'block' : 'none');
        // hide circle, box for multi mode
        for (let i = 0; i < this.drawButtonsForOnlySingleMode.length; i++) {
          this.drawButtonsForOnlySingleMode[i].style.display = cssOnlySingleMode;
        }

        if (isShow) {
            this.updateMenuChildCss();
        }
        
    }

    menuAction(e) {
        e.stopPropagation();

        this.deselectAllControlBtn(e.currentTarget.id);
        
        if (e.currentTarget.style.backgroundColor === 'grey') {
          e.currentTarget.style.backgroundColor = 'white';
          
          this.actionType = MapDrawAction.NA;
          this.showMenu(false);
          this.showTooltip = true;
        } else {
          e.currentTarget.style.backgroundColor = 'grey';
          this.actionType = MapDrawAction.MENU;
          this.showMenu(true);
          this.showTooltip = false;
        }
    }

    

    drawAction(e, drawingMode, drawTypeSpecific = null) {
        e.stopPropagation();

        this.deselectAllControlBtn(e.currentTarget.id);
        if (e.currentTarget.style.backgroundColor === 'grey') {
            e.currentTarget.style.backgroundColor = 'white';
            this.drawingManager.setDrawingMode(null);
            this.actionType = MapDrawAction.NA;
            this.drawType = MapDrawType.NA;
            this.currentDrawingMode = MapDrawType.NA;

            this.showMenu(true);
            this.hideDrawTools();
            this.showMenuButton(true);
        } else {
            e.currentTarget.style.backgroundColor = 'grey';
            this.drawTypeSpecific = drawTypeSpecific;
            this.currentDrawingMode = drawingMode;
            this.drawingManager.setDrawingMode(this.currentDrawingMode);

            this.showMenu(false);
            if (drawTypeSpecific === MapDrawTypeSpecial.TEXT_BOX) {
                this.drawType = MapDrawType.TEXT;
            }
        }
    }

    pointAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.MARKER);
    }

    circleAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.CIRCLE);
    }

    polygonAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.POLYGON);
    }

    lineAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.POLYLINE);
    }

    boxAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.RECTANGLE);
    }
    colorAction(e) {
        super.colorAction(e);
        this.vertexes = []; // reset
        this.drawTypeSpecific = null; // reset
    }
    textAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.MARKER
            , MapDrawTypeSpecial.TEXT_BOX);
    }
    arrowAtFirstPointAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.POLYLINE);
        this.drawTypeSpecific = MapDrawTypeSpecial.ARROW_AT_FIRST_POINT;
    }
    arrowAtLastPointAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.POLYLINE);
        this.drawTypeSpecific = MapDrawTypeSpecial.ARROW_AT_LAST_POINT;
    }
    drawIconAction(e) {
        this.drawAction(e, this.google.maps.drawing.OverlayType.MARKER);
        this.drawTypeSpecific = MapDrawTypeSpecial.ICON;
    }
    dimensionAction(e) {
        if (!this.isDrawModeSingle) { return; }
        this.drawAction(e, this.google.maps.drawing.OverlayType.POLYLINE);
        this.drawTypeSpecific = MapDrawTypeSpecial.DIMENSION;
    }
    cancelDrawing() {
        this.sketch?.setMap(null);
        this.finishDrawResetValue();
    }
    finishDrawing() {
        if (this.sketch) {
            let allowFinish = true;
            let len;
            const dimensionId = this.sketch.dimensionId;
            switch(this.drawType) {
                case MapDrawType.LINE_STRING:
                    const paths = this.sketch.getPath();
                    len = paths.getLength();
                    if (len > 0) {
                        paths.removeAt(len - 1);
                        len -= 1;
                    }
                    if (len < 2) { allowFinish = false; }
                    break;
                case MapDrawType.POLYGON:
                    len = this.sketch.getPath().getLength();
                    if (len < 4) { allowFinish = false; }
                    break;
                default: break;
            }
            if (allowFinish) {
                this.finishDrawShape(true);
            } else {
                this.cancelDrawing();
                
                if (typeof dimensionId === 'string') {
                    const dimensionObj = this.dimensionOverlays[dimensionId];
                    if (dimensionObj?.overlay) {
                        dimensionObj.overlay.setMap(null);
                    }
                    const idContainer = `${this.keyName}__dimension-container__${dimensionId}}`;
                    const dimensionContainer = document.getElementById(idContainer);
                    if (dimensionContainer) {
                        const parentNode = (dimensionContainer.parentNode as HTMLElement);
                        parentNode?.removeChild(dimensionContainer);
                    }
                }
            }
        } else {
            this.cancelDrawing();
        }
        // this.sketch = null;
        // this.vertexes = []; // reset
    }

    deleteAction(e) {
        e.stopPropagation();

        this.hideDrawTools();
        this.showMenuButton(true);

        this.deselectAllControlBtn(e.currentTarget.id);

        if (e.currentTarget.style.backgroundColor === 'grey') {
            e.currentTarget.style.backgroundColor = 'white';
            this.actionType = MapDrawAction.NA;
            if (this.shapes) {
                this.shapes.actionType = MapDrawAction.NA;
            }
            this.showTooltip = true;
        } else {
            this.actionType = MapDrawAction.DELETE;
            e.currentTarget.style.backgroundColor = 'grey';
            if (this.shapes) {
                this.shapes.actionType = MapDrawAction.DELETE;
            }
            this.showTooltip = false;
        }

        if (this.setDirtyFunction) {
            this.setDirtyFunction();
        }
    }
    deleteSelectedShape() {
        if (this.shapes && this.shapes.selectedShape
             && this.drawType === MapDrawType.NA
             && this.actionType === MapDrawAction.SELECT ) {
            this.shapes.deleteSelected();
            if (this.setDirtyFunction) {
                this.setDirtyFunction();
            }
        }
    }
    resetCheckLocationUI() {
        this.locationChecked = false;
        if (this.locationElementIcon) {
            this.locationElementIcon.setAttribute('class', 'material-icons');
        }
    }
    locationAction(e) {
        e.stopPropagation();

        this.hideDrawTools();
        this.showMenuButton(true);
        
        // this.actionType = 'location';
        

        // this.deselectAllControlBtn(e.currentTarget.id);
        for (let i = 0; i < this.controlBtns.length; i++) {
            if (!this.controlBtns[i] || this.controlBtns[i].id === e.currentTarget.id) { continue; }
            this.controlBtns[i].style.backgroundColor = 'white';
        }

        if (this.locationChecked) {
            this.actionType = MapDrawAction.NA;
            if (this.locationElementIcon) {
                this.locationElementIcon.setAttribute('class', 'material-icons');
            }
        } else {
            this.actionType = MapDrawAction.LOCATION;
            if (this.locationElementIcon) {
                this.locationElementIcon.setAttribute('class', 'material-icons button-location-pulse');
            }
            if (this.getLocationFn && typeof this.getLocationFn === 'function') {
                this.getLocationFn();
            }
        }
        this.locationChecked = !this.locationChecked;
        
    }

    // marker = M-point : 'mp', rectangle = M-polygon: 'mr', polygon = M-polygon: 'mo'
    // , polyline = M-line string : 'ml' , circle = M-point : 'mc'
    storeDrawMultiShape(key) {
        let count = 1;
        if (key in this.dicDrawShape) {
            count = this.dicDrawShape[key];
            count++;
            this.dicDrawShape[key] = count;
        } else {
            count = 1;
            this.dicDrawShape[key] = 1;
        }
        return count;
    }

    finishDrawingSetup() {
        this.vertexes = []; // reset
        if (this.arrow) {
            this.arrow.setMap(null);
            this.arrow = null;
        }

        let id = new Date().getTime() + '';
        
        let idGroup = null;
        let colorSaved = null;
        let color = (this.isDrawModeSingle ? this.singleColor : this.multiColor);
        if (this.colorCurrentSelected) {
            color = this.colorCurrentSelected;
            colorSaved = this.colorCurrentSelected;
        }
        // console.log(`**** colorSaved = ${colorSaved}`);
        
        let lineWidthSave = null;
        let lineWidth = 2;
        if (this.lineWidthCurrentSelected) {
            lineWidth = this.lineWidthCurrentSelected;
            lineWidthSave = this.lineWidthCurrentSelected;
        }
        let lineDash = (this.lineDashCurrentSelected ? this.lineDashCurrentSelected: null);
        let arrowHead = (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT
                || this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_LAST_POINT) ? this.drawTypeSpecific: null;
        let icons = null;
        if (lineDash && Array.isArray(lineDash) && lineDash.length > 1) {
            icons = [
                {
                    icon: {
                    path: `m 0 -${lineDash[0]} l 0 ${lineDash[0]}`, // dash length
                    strokeOpacity: 1,
                    scale: lineWidth,
                    },
                    offset: "0",
                    repeat: `${(lineDash[0] * lineDash[1]) * lineWidth}px`, // dash space
                },
            ];
        }
        return {
            color, idGroup, id, colorSaved, lineWidthSave, lineDash, arrowHead, icons
        };
    }

    // completeObject = 
    // {
    //     type: string, // The type of overlay that was finished: 'marker', 'polygon', 'polyline', 'rectangle', 'circle'.
    //     overlay: object // The overlay object: Marker, Polygon, Polyline, Rectangle, or Circle instance.
    // }
    // Ex: overlay = new google.maps.Polygon({
    //          paths: [
    //             {lat: 37.772, lng: -122.214},
    //             {lat: 21.291, lng: -157.821},
    //             {lat: -18.142, lng: 178.431},
    //             {lat: -27.467, lng: 153.027}
    //             ],
    //         strokeColor: '#FF0000',
    //         strokeOpacity: 0.8,
    //         strokeWeight: 2,
    //         fillColor: '#FF0000',
    //         fillOpacity: 0.35
    //     });
    finishDrawPolyline(completeObject, color, idGroup, id, colorSaved, lineWidthSave, lineDash
        , arrowHead) {
        
        completeObject.overlay.fillColor = color;
        completeObject.overlay.strokeColor = color;
        let dimensionId = null; let dimensionValue = null;
        if (!this.isDrawModeSingle) {

            completeObject.realType = MapDrawType.MULTI_LINE_STRING;
            idGroup = ShapeIdGroup.MULTI_LINE_STRING;
            if (arrowHead === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
                idGroup = ShapeIdGroup.MULTI_ARROW_AT_FIRST_POINT;
            } else if (arrowHead === MapDrawTypeSpecial.ARROW_AT_LAST_POINT) {
                idGroup = ShapeIdGroup.MULTI_ARROW_AT_LAST_POINT;
            }
            const count = this.storeDrawMultiShape(idGroup);
            id = idGroup + '_' + count;
        } else {

            completeObject.realType = MapDrawType.LINE_STRING;
            if (this.drawTypeSpecific === MapDrawTypeSpecial.DIMENSION
                 && this.currentDimensionId != null) {
                dimensionId = this.currentDimensionId;
                id = dimensionId;
                dimensionValue = parseFloat(this.dimensionOverlays[this.currentDimensionId]
                    .dimensionLabel.innerHTML?.replace(this.dimensionsUnit, ''));
            }
        }
        let paths = completeObject.overlay.getPath().getArray();
        if (paths.length < 2 && this.drawTypeSpecific !== MapDrawTypeSpecial.DIMENSION) {
            completeObject.overlay.setMap(null);
            this.finishDrawResetValue();
            return;
        }
        const p2 = new self.google.maps.Data.Feature({
            geometry: new self.google.maps.Data.LineString(paths)
        });
        p2.toGeoJson((json) => {
            this.shapes.add(completeObject, json, id, idGroup, colorSaved, lineWidthSave, lineDash
                , arrowHead, null, null, dimensionId, dimensionValue, false);
            if (typeof this.setDirtyFunction == 'function') {
                this.setDirtyFunction();
            }
        });
        this.finishDrawResetValue();
    }
    finishDrawPoint(completeObject, color, idGroup, id, colorSaved, lineWidthSave, lineDash, arrowHead) {
        if (typeof completeObject.overlay.position === 'undefined'
         || completeObject.overlay.position == null) {
            return;
        }

        completeObject.overlay.icon.strokeColor = color;
        completeObject.overlay.icon.fillColor = color;

        

        // console.log(`***** finishDrawPoint, latLng = ${completeObject.overlay.position.lat()}, ${completeObject.overlay.position.lng()}`);

        const m = new this.google.maps.Data.Feature({
            geometry: new this.google.maps.Data.Point(completeObject.overlay.position)
        });
        
        if (!this.isDrawModeSingle) {
            completeObject.realType = MapDrawType.MULTI_POINT;

            idGroup = ShapeIdGroup.MULTI_POINT;
            const count = this.storeDrawMultiShape(idGroup);
            id = idGroup + '_' + count;
        } else {
            completeObject.realType = MapDrawType.MARKER;
        }
        if (this.drawTypeSpecific === MapDrawTypeSpecial.TEXT_BOX) {

            completeObject.overlay.icon.strokeOpacity = 0;
            completeObject.overlay.icon.fillOpacity = 0;
            completeObject.realType = MapDrawType.MARKER;
            
        }
        const iconImage = (this.drawTypeSpecific === MapDrawTypeSpecial.ICON) ?
        this.iconCurrentSelected : null;
        
        

        m.toGeoJson((json) => {
            if (this.drawTypeSpecific === MapDrawTypeSpecial.TEXT_BOX) {
                if (this.allowCreateNewTextBox) {
                    console.log(`*** create new text box`);
                    const id = uuid.v1();
                    this.createTextBoxFeature(completeObject, completeObject.overlay.position, '', id, true, json
                    , this.fontCurrentSelected, this.fontSizeCurrentSelected);
                } else {
                    // console.log(`*** reset allowCreateNewTextBox`);
                    this.allowCreateNewTextBox = true;
                }
            } else {
                this.shapes.add(completeObject, json, id, idGroup, colorSaved, lineWidthSave, lineDash, arrowHead, iconImage
                    , this.iconAnchorCurrentSelected, null, null, false);
                if (this.setDirtyFunction) {
                    this.setDirtyFunction();
                }
            }
            
        });
        this.finishDrawResetValue();
    }
    finishDrawRectangle() {
        const completeObject: any = {
            type: this.currentDrawingMode,
            overlay: this.sketch,
        };

        const finishSetup = this.finishDrawingSetup();

        completeObject.overlay.fillColor = finishSetup.color;
        completeObject.overlay.strokeColor = finishSetup.color;
        if (finishSetup.icons) {
            completeObject.overlay.icons = finishSetup.icons;
            completeObject.overlay.strokeOpacity = 0;
        }
        
        const b = completeObject.overlay.getBounds(),
            p = [b.getSouthWest(), {
                lat: b.getSouthWest().lat(),
                lng: b.getNorthEast().lng()
            },
                b.getNorthEast(), {
                    lng: b.getSouthWest().lng(),
                    lat: b.getNorthEast().lat()
                }
            ];
        const r = new this.google.maps.Data.Feature({
            geometry: new this.google.maps.Data.Polygon([p])
        });
        if (!this.isDrawModeSingle) {
            completeObject.realType = MapDrawType.MULTI_POLYGON;
            finishSetup.idGroup = ShapeIdGroup.MULTI_RECTANGLE;
            const count = this.storeDrawMultiShape(finishSetup.idGroup);
            finishSetup.id = finishSetup.idGroup + '_' + count;
        } else {
            completeObject.realType = MapDrawType.POLYGON;
        }
        r.toGeoJson((json) => {
            this.shapes.add(completeObject, json, finishSetup.id, finishSetup.idGroup
                , finishSetup.colorSaved, finishSetup.lineWidthSave
                , finishSetup.lineDash, finishSetup.arrowHead
                , null, null, null, null, false);
            if (this.setDirtyFunction) {
                this.setDirtyFunction();
                
            }
        });
        this.finishDrawResetValue();
    }
    finishDrawPolygon(completeObject, color, idGroup, id, colorSaved, lineWidthSave, lineDash, arrowHead) {
        completeObject.overlay.fillColor = color;
        completeObject.overlay.strokeColor = color;
        if (!this.isDrawModeSingle) {
            completeObject.realType = MapDrawType.MULTI_POLYGON;
            idGroup = ShapeIdGroup.MULTI_POLYGON;
            const count = this.storeDrawMultiShape(idGroup);
            id = idGroup + '_' + count;
        } else {
            completeObject.realType = MapDrawType.POLYGON;
        }
        let paths = completeObject.overlay.getPath().getArray();
        if (paths.length < 3) {
            completeObject.overlay.setMap(null);
            return;
        }
        const p1 = new this.google.maps.Data.Feature({
            geometry: new this.google.maps.Data.Polygon([paths])
        });
        p1.toGeoJson((json) => {
            // check duplicate last 2 points of json
            const coords = json?.geometry?.coordinates;
            // console.log(`**** before check, coords = ${JSON.stringify(coords)}`);
            if (Array.isArray(coords) && coords.length > 0) {
                for (let i = coords[0].length - 1; i > 0; i--) {
                    const coorA = coords[0][i];
                    const coorB = coords[0][i - 1];
                    if (Array.isArray(coorA) && Array.isArray(coorB)
                        && coorA.length == 2 && coorB.length == 2
                        && coorA[0] == coorB[0] && coorA[1] == coorB[1]) {
                        coords[0].splice(i, 1);
                    } else {
                        break;
                    }
                }
            }
            // console.log(`**** after check, coords = ${JSON.stringify(coords)}`);

            this.shapes.add(completeObject, json, id, idGroup, colorSaved, lineWidthSave, lineDash, arrowHead
                , null, null, null, null, false);
            if (this.setDirtyFunction) {
                this.setDirtyFunction();
            }
        });
        this.finishDrawResetValue();
        
    }
    finishDrawCircle() {
        const completeObject: any = {
            type: this.currentDrawingMode,
            overlay: this.sketch,
        };

        const finishSetup = this.finishDrawingSetup();

        completeObject.overlay.fillColor = finishSetup.color;
        completeObject.overlay.strokeColor = finishSetup.color;
        const c = new this.google.maps.Data.Feature({
            properties: {
                radius: completeObject.overlay.getRadius()
            },
            geometry: new this.google.maps.Data.Point(completeObject.overlay.getCenter())
        });
        if (!this.isDrawModeSingle) {
            completeObject.realType = MapDrawType.MULTI_POINT;
            finishSetup.idGroup = ShapeIdGroup.MULTI_CIRCLE;
            const count = this.storeDrawMultiShape(finishSetup.idGroup);
            finishSetup.id = finishSetup.idGroup + '_' + count;
        } else {
            completeObject.realType = MapDrawType.POINT;
        }
        c.toGeoJson((json) => {
            this.shapes.add(completeObject, json, finishSetup.id, finishSetup.idGroup
                , finishSetup.colorSaved, finishSetup.lineWidthSave, finishSetup.lineDash
                , finishSetup.arrowHead, null, null, null, null, false);
            if (this.setDirtyFunction) {
                this.setDirtyFunction();
            }
        });
        this.finishDrawResetValue();
    }
    finishDrawResetValue() {
        this.sketch?.setMap(null);
        this.sketch = null; // reset
        this.isSetRadius = false; // reset
        this.isDrawing = false; // reset
        this.vertexes = []; // reset
        this.currentDimensionId = null;
        if (this.drawingShapeMouseMoveListener != null) {
            this.google.maps.event.removeListener(this.drawingShapeMouseMoveListener);
        }
        this.drawingShapeMouseMoveListener = null;
        // this.drawingManager.setMap(null);
        this.drawingManager.setDrawingMode(this.currentDrawingMode);
    }

    // this function for sc-boundary
    addControlDraw(compId, options, cb) {
        let layerIds = [];
        const color = (this.isDrawModeSingle ? this.singleColorDraging : this.multiColorDraging);
        this.drawingManager = new this.google.maps.drawing.DrawingManager({
            drawingControl: false,
            drawingControlOptions: {
                position: this.google.maps.ControlPosition.LEFT_CENTER,
                drawingModes: [
                    this.google.maps.drawing.OverlayType.MARKER,
                    this.google.maps.drawing.OverlayType.CIRCLE,
                    this.google.maps.drawing.OverlayType.POLYGON,
                    this.google.maps.drawing.OverlayType.POLYLINE,
                    this.google.maps.drawing.OverlayType.RECTANGLE
                ]
            },
            markerOptions: {icon: {
                path: this.google.maps.SymbolPath.CIRCLE,
                fillColor: color,
                fillOpacity: 0.6,
                strokeColor: color,
                strokeOpacity: 0.9,
                strokeWeight: 1,
                scale: 7,
                clickable: false
            }
            },
            circleOptions: {
                strokeColor: color,
                fillColor : color,
                clickable: false
            }
            , polylineOptions: {
                strokeColor : color,
                clickable: false
            }
            , rectangleOptions: {
                strokeColor: color,
                fillColor : color,
                clickable: false
            }
            , polygonOptions: {
                strokeColor: color,
                fillColor : color,
                clickable: false
            }
        });
        // this.drawingManager.setMap(this.map);

        const self = this;

        this.google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', function() {
            self.shapes.clearSelection();
            if (self.actionType !== MapDrawAction.SELECT) {
                self.actionType = MapDrawAction.EDIT;
            }
            
            const color = (self.isDrawModeSingle ? self.singleColorDraging : self.multiColorDraging);
            console.log(`**** drawingmode_changed color = ${color}
            , self.currentDrawingMode = ${self.currentDrawingMode}`);
            const lineWidth = (self.lineWidthCurrentSelected ? self.lineWidthCurrentSelected : null);
            if (self.currentDrawingMode) {
                self.map.setOptions({ draggableCursor: 'crosshair', clickableIcons: false });
            } else {
                self.map.setOptions({ draggableCursor: 'default', clickableIcons: true });
            }
            const fillOpacity = 0.3;
            switch(self.currentDrawingMode) {
                case google.maps.drawing.OverlayType.MARKER:
                    if (self.drawTypeSpecific == MapDrawType.TEXT) {
                        self.drawType = self.drawTypeSpecific;
                    } else {
                        self.drawType = MapDrawType.MARKER;
                    }
                    

                    self.sketch = new self.google.maps.Marker({
                        map: self.map,
                        position: {lat: 0, lng: 0},
                        icon: {
                            path: self.google.maps.SymbolPath.CIRCLE,
                            fillColor: color,
                            fillOpacity,
                            strokeColor: color,
                            strokeWeight: 1,
                            scale: 5
                        }
                    });

                    break;
                case google.maps.drawing.OverlayType.CIRCLE:
                    self.drawType = MapDrawType.CIRCLE;
                    self.drawingManager.circleOptions.fillColor = color;
                    self.drawingManager.circleOptions.strokeColor = color;


                    self.sketch = new self.google.maps.Circle({
                        map: self.map,
                        center: {lat: 0, lng: 0},
                        radius: 0, // in meters
                        strokeColor: color,
                        fillColor: color,
                        fillOpacity
                    });
                    self.isSetRadius = false;
                    if (lineWidth) {
                        self.drawingManager.circleOptions.strokeWeight = lineWidth;
                        this.sketch.strokeWeight = lineWidth;
                    }
                    self.drawingShapeMouseMoveListener = self.google.maps.event.addListener(self.sketch, 'mousemove', function(event) {
                        self.updateRadiusSketchCircle(event.latLng);
                    });

                    break;
                case google.maps.drawing.OverlayType.POLYLINE:
                    self.drawType = MapDrawType.LINE_STRING;;

                    self.sketch = new self.google.maps.Polyline({
                        map: self.map,
                        path: [],
                        strokeColor: color,
                        fillColor: color,
                    });

                    self.drawingManager.polylineOptions.fillColor = color;
                    self.drawingManager.polylineOptions.strokeColor = color;
                    if (lineWidth) {
                        self.drawingManager.polylineOptions.strokeWeight = lineWidth;
                        this.sketch.strokeWeight = lineWidth;
                    }
                    
                    break;
                case google.maps.drawing.OverlayType.POLYGON:
                    self.drawType = MapDrawType.POLYGON;
                    self.drawingManager.polygonOptions.fillColor = color;
                    self.drawingManager.polygonOptions.strokeColor = color;
                    self.sketch = new self.google.maps.Polygon({
                        map: self.map,
                        paths: [{lat: 0, lng: 0}],
                        strokeColor: color,
                        fillColor: color,
                        fillOpacity
                    });
                    self.isSetRadius = false;
                    if (lineWidth) {
                        self.drawingManager.polygonOptions.strokeWeight = lineWidth;
                        self.sketch.strokeWeight = lineWidth;
                    }
                    self.drawingShapeMouseMoveListener = self.google.maps.event.addListener(self.sketch, 'mousemove', function(event) {
                        const path = self.sketch.getPath();
                        if (path.getLength() > 0) {
                            path.setAt(path.getLength() - 1, event.latLng);
                        }
                    });
                    break;
                case google.maps.drawing.OverlayType.RECTANGLE:
                    self.drawType = MapDrawType.BOX;
                    self.drawingManager.polygonOptions.fillColor = color;
                    self.drawingManager.polygonOptions.strokeColor = color;

                    self.sketch = new self.google.maps.Rectangle({
                        map: self.map,
                        bounds: {
                            north: 0,
                            south: 0,
                            east: 0,
                            west: 0
                        },
                        strokeColor: color,
                        fillColor: color,
                        fillOpacity
                    });

                    if (lineWidth) {
                        self.drawingManager.polygonOptions.strokeWeight = lineWidth;
                    }
                    self.drawingShapeMouseMoveListener = self.google.maps.event.addListener(self.sketch, 'mousemove', function(event) {
                        self.updatePositionSketchRectangle(event.latLng);
                    });
                    break;
                default:
                    self.drawType = MapDrawType.NA;
                    break;
            }
        });


        this.google.maps.event.addListener(this.drawingManager, 'polylinecomplete', function(polyline) {
            console.log(`***** polylinecomplete`);
            // if (self.isDrawModeSingle) {
            //     polyline.setOptions({strokeColor: self.singleColor, fillColor: self.singleColor});
            // } else {
            //     polyline.setOptions({strokeColor: self.multiColor, fillColor: self.multiColor});
            // }

        });

        this.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
            console.log(`***** overlaycomplete`);
            switch (event.type) {
                case self.google.maps.drawing.OverlayType.MARKER:
                    

                    break;
                case self.google.maps.drawing.OverlayType.RECTANGLE:
                    

                    break;
                case self.google.maps.drawing.OverlayType.POLYGON:
                    
                    break;
                case self.google.maps.drawing.OverlayType.POLYLINE:
                    break;
                case self.google.maps.drawing.OverlayType.CIRCLE:
                    
                    break;

            }
        });

        this.drawingMenu = document.createElement('div');
        this.drawingMenu.id = compId + '_Drawing_Menu_';

        this.elementWrapperForBottomPosition = null;
        if (this.isBottom) {
            const mapActualView = $(this.map.getDiv()).children().eq(1);
            if (!mapActualView || !mapActualView[0]) {
                console.log(`Google map library change it's rendering algorithm`);
                return;
            }
            this.elementWrapperForBottomPosition = mapActualView[0];
        }

        // declare style each button in group
        const css = { 'background-color': 'white', color: 'black',
         width: this.drawToolButtonSize + 'px', height: this.drawToolButtonSize + 'px', border: '0px' };
        
        
        this.drawStylingButtonCss = cloneDeep(css);
        this.drawStylingButtonCss['z-index'] = 200;
        

        this.cssIconDiv = {
            'height': `40px`, 
            'width': `40px`,
            'margin-left': `-7px`,
            'margin-top': `-2px`,
            'position': `relative`,
        };

        
        this.addDrawButtons(layerIds, compId, css, (this.isBottom ? 'draw-menu-gg-bottom' : 'draw-menu-gg'));
        
        
        this.drawingMenu.style.left = '10px';

        if (this.isBottom) {
            this.drawingMenu.style.marginBottom = '12px';
            this.drawingMenu.style.display = 'flex';
            this.map.controls[this.google.maps.ControlPosition.BOTTOM_LEFT].push(this.drawingMenu);
        } else {
            this.drawingMenu.style.marginLeft = '10px';
            this.drawingMenu.style.display = 'grid';
            this.map.controls[this.google.maps.ControlPosition.LEFT_CENTER].push(this.drawingMenu); // add this button to map
        }

        cb({layerIds, menuSelectBtn: this.menuSelectBtn, menuSelectLabel: this.menuSelectLabel});

    }

    addControl(ActionControl, element, options) {

        this.ActionControls.push(element);
    }
    setupControl(ActionControl) {

    }
    setTextBoxLineOffsetCoordinates(id, markerJson) {
        const parentPos = this.mapDiv.getBoundingClientRect();
        const childId = `${this.keyName}__text-content__${id}}`;
        const childElement = document.getElementById(childId);

        if (parentPos === null || childElement === null) {
            return null;
        }

        const childPos = childElement.getBoundingClientRect();
        const top = childPos?.top - parentPos?.top;
        const left = childPos?.left - parentPos?.left;
        const point = { x: left, y: top };
        const latLngTo = this.point2LatLng(point); 
        const coordTo = [latLngTo.lng(), latLngTo.lat()];
        // console.log(`**** coordTo = `, coordTo);

        const lineGeoJson = cloneDeep(markerJson);
        const coordFrom = lineGeoJson.geometry.coordinates;

        const lineCoords = [coordFrom, coordTo];
        const totalLength = sclUtilMap.totalLen(lineCoords);
        // console.log(`***** total Length = ${totalLength}`);
        if (totalLength > 0.001) {
            return null;
        }
        
        lineGeoJson.geometry.coordinates = lineCoords;
        lineGeoJson.geometry.type = MapDrawType.LINE_STRING;

        return lineGeoJson;
    }
    createTextBoxLineOffset(event, markerJson, idLine, id, textContent, fontFamily, fontSize) {
        // console.log(`**** createTextBoxLineOffset, markerJson = `, markerJson);
        // Add line string
        const evtLine = cloneDeep(event);
        evtLine.type = this.google.maps.drawing.OverlayType.POLYLINE;
        evtLine.realType = MapDrawType.LINE_STRING;

        const lineGeoJson = this.setTextBoxLineOffsetCoordinates(id, markerJson);
        if (lineGeoJson == null) {
            return null;
        }

        // console.log(`**** createTextBoxLineOffset, lineGeoJson = `, lineGeoJson);

        const fillColor = lineGeoJson.properties?.fillColor;
        const color = lineGeoJson.properties?.color;

        this.createLineStringByJson(lineGeoJson, idLine, null, fillColor, color, null, null, null
            , null, null, null, null, null, null, false);
        const feaLine = this.shapes.findById(idLine);
        // console.log(`**** AFTER CREATE LINE, feaLine = `, feaLine);
        if (feaLine != null) {
            this.shapes.collection[idLine] = feaLine;
            this.shapes.collection[idLine].setMap(this.map);
            // console.log(`**** DONE CREATE LINE, this.shapes.collection[${idLine}] = `
            // , this.shapes.collection[idLine]);
            


            const path = feaLine.getPath();
            const coords = [];
            for (let i = 0; i < path.length; i++) {
                coords.push([ path.getAt(i).lng(), path.getAt(i).lat() ]);
            }
            // console.log(`**** DONE CREATE LINE, line pos = `, coords);
        }


        return feaLine;
    }

    textBoxDragable(dragElement, destElement, id, idPointAnchor, idLine) {
        let xOffset = 0;
        let yOffset = 0;
    
        /*sets offset parameters and starts listening for mouse-move*/
        const startDrag = (e) => {
            if (this.actionType !== MapDrawAction.SELECT) {
                return;
            }
            // console.log(`***** start drag`);
            e.preventDefault();
            e.stopPropagation();
        
            let hasMove = false;
        
            /* Drag object */
            const dragObject = (e) => {
                e.preventDefault();
                e.stopPropagation();
                if(e.type == 'mousemove') {
                    // console.log(`***** mouse move`);
                    dragElement.style.left = `${(e.clientX - xOffset)}px`; // adjust location of dragged object so doesn't jump to mouse position
                    dragElement.style.top = `${(e.clientY - yOffset)}px`;
        
                    // update line position
                    const parentPos = this.mapDiv.getBoundingClientRect();
                    const dragHandlePos = dragElement.getBoundingClientRect();
                    const top1 = dragHandlePos?.top - parentPos?.top;
                    const left1 = dragHandlePos?.left - parentPos?.left;

                    const point = { x: left1, y: top1 };
                    const latLngFrom = this.point2LatLng(point); 
                    const coordFrom = [latLngFrom.lng(), latLngFrom.lat()];
            
                    
                    const destPos = destElement.getBoundingClientRect();
                    const top2 = destPos?.top - parentPos?.top;
                    const left2 = destPos?.left - parentPos?.left;
                    const point2 = { x: left2, y: top2 };
                    const latLngTo = this.point2LatLng(point2);
                    const coordTo = [latLngTo.lng(), latLngTo.lat()];
            
                    // console.log(`***** mouse move, xOffset = ${xOffset}, yOffset = ${yOffset}
                    // , e.clientX = ${e.clientX}, e.clientY = ${e.clientY}
                    // , top1 = ${top1}, left1 = ${left1}
                    // , top2 = ${top2}, left2 = ${left2}
                    // , coordFrom = ${JSON.stringify(coordFrom)}
                    // , coordTo = ${JSON.stringify(coordTo)}`);
                
                    const lineCoor = [latLngFrom, latLngTo];
                    const feaLine = this.shapes.findById(idLine);
                    // console.log(`**** feaLine = `, feaLine);
                    if (feaLine) {
                        feaLine.setPath(lineCoor);
                        this.shapes.updateCoordsPolyline(feaLine, lineCoor);
                        const path = feaLine.getPath();
                        const coords = [];
                        for (let i = 0; i < path.length; i++) {
                            coords.push([ path.getAt(i).lng(), path.getAt(i).lat() ]);
                        }
                        // console.log(`**** mouse down, line pos = `, coords);
                    }

                    const feaPoint = this.shapes.findById(idPointAnchor);
                    if (feaPoint) {
                        feaPoint.setPosition(latLngFrom);
                        this.shapes.updateCoordsPoint(feaPoint, latLngFrom);
                        const pos = feaPoint.getPosition();
                        // console.log(`**** mouse down, point pos = [${pos.lng()}, ${pos.lat()}]`);
                    }
                    hasMove = true;
                }
            }
            /*End dragging*/
            this.textBoxOnMouseUp = () => {
                // console.log(`***** mouse up, this.shapes = `, this.shapes);
                if (hasMove == false) { return; }
                const feaLine = this.shapes.findById(idLine);
                // console.log(`**** feaLine = `, feaLine);
                if (feaLine) {
                    const path = feaLine.getPath();
                    const coords = [];
                    for (let i = 0; i < path.length; i++) {
                        coords.push([ path.getAt(i).lng(), path.getAt(i).lat() ]);
                    }
                    // console.log(`**** mouse up, line pos = `, coords);
                } else {
                    console.log(`**** mouse up, LINE STRING IS NULL`);
                }

                const feaPoint = this.shapes.findById(idPointAnchor);
                if (feaPoint) {
                    const pos = feaPoint.getPosition();
                    // console.log(`**** mouse up, point pos = [${pos.lng()}, ${pos.lat()}]`);
                } else {
                    console.log(`**** mouse up, POINT IS NULL`);
                }


                this.hasDocumentChangeValue = false;
                

                window.removeEventListener('mousemove', dragObject, true);
                window.removeEventListener('touchmove', dragObject, true);

                if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function') {
                    this.setDirtyFunction();
                }
            };

            if (e.type == 'mousedown') {
            // console.log(`***** mouse down`);
                xOffset = e.clientX - parseInt(window.getComputedStyle(dragElement).left);
                yOffset = e.clientY - parseInt(window.getComputedStyle(dragElement).top);

                window.addEventListener('mousemove', dragObject, true);
            }
        };
    
        dragElement.addEventListener("mousedown", startDrag, true);
    
        
    }

    createTextBoxFeature(event, coor, textContent, id, isEdit, markerJson, fontFamily, fontSize) {
        // console.log(`**** createTextBoxFeature, isEdit = ${isEdit}`);
        let idAnchorPoint = `${id}_AnchorPoint`;
        let idLine = `${id}_Line`;
        let feaPoint = this.shapes.findById(idAnchorPoint);
        if (feaPoint == null) {
            // Add marker
            const evtPoint = cloneDeep(event);
            evtPoint.type = this.google.maps.drawing.OverlayType.MARKER;
            evtPoint.realType = MapDrawType.MARKER;
            feaPoint = this.shapes.addTextBoxAnchorPoint(evtPoint, markerJson, idAnchorPoint
                , textContent, fontFamily, fontSize, id);
        }
        let feaLine = this.shapes.findById(idLine);


        let overlayIsAdded = false;
        const obj = document.getElementById(`${this.keyName}__text-container__${id}}`);
        if (obj) {
            overlayIsAdded = true;
        }
        if (overlayIsAdded) {
            console.log(`This textbox ${id} is added in map before`);
            return;
        }
        
        
        let container;
        let elemContent;
        let elemTextBox;
        

        const overlay = new this.google.maps.OverlayView();
        overlay.setMap(this.map);
        this.overlays.push(overlay);

        overlay.onAdd = () => {
            // console.log(`***** overlay.onAdd`);
            const mapHeight = this.mapDiv?.offsetHeight;
            const mapWidth = this.mapDiv?.offsetWidth;
            let textBoxSize = mapHeight;
            if (mapHeight > mapWidth) { textBoxSize = mapWidth; }
            textBoxSize /= 2;
            if (textBoxSize <= 0) { textBoxSize = 100; }
    
            container = document.createElement('div');
            container.id = `${this.keyName}__text-container__${id}}`;
            container.className = 'ol-popup';
    
            elemContent = document.createElement('div');
            elemContent.id = `${this.keyName}__text-content__${id}}`;
            elemContent.className = 'draw-text-google';
            elemContent.style.display = (isEdit ? 'none': 'block');
            
            container.appendChild(elemContent);
        
            elemTextBox = document.createElement('textarea');
            elemTextBox.id = `${this.keyName}__text-input__${id}}`;
            elemTextBox.className = 'draw-text-area-google';
            elemTextBox.style.width = `${textBoxSize}px`;
            elemTextBox.style['z-index'] = 100;
            elemTextBox.style.display = (isEdit ? 'block': 'none');
            elemTextBox.setAttribute('placeholder', '...');
            container.appendChild(elemTextBox);

            if (textContent) {
                elemContent.innerHTML = textContent;
                elemTextBox.value = textContent;
            }
            if (fontFamily) {
                elemContent.style['font-family'] = fontFamily;
                elemTextBox.style['font-family'] = fontFamily;
            }
            if (fontSize) {
                elemContent.style['font-size'] = fontSize;
                elemTextBox.style['font-size'] = fontSize;
            }

            // Add the element to the "overlayLayer" pane.
            const panes = overlay.getPanes();
            panes.floatPane.appendChild(container);
            // console.log(`**** add new text box id = ${id}`);

            

            const closeTextBoxFn = (e) => {
                // console.log(`**** closeTextBoxFn`);
                if (e) {
                    e.stopPropagation && e.stopPropagation();
                }
                

                elemContent.innerHTML = elemTextBox.value;
                elemContent.style.display = 'block';
                elemTextBox.style.display = 'none';
                this.hasDocumentChangeValue = false;
                
                
          
                this.closeTextBox.style.display = 'none';
                this.currentCloseTextBoxFn = null; // reset
                this.currentTextBoxId = null;
          
                if (elemContent.innerHTML.trim().length == 0) {
                    try {
                        // console.log(`**** delete overlay`);
                        (container.parentNode as HTMLElement).removeChild(container);
                        if (feaPoint != null) {
                            // console.log(`**** remove feature`);
                            this.shapes.deleteFeatureById(idAnchorPoint);
                        }
                        if (feaLine != null) {
                            this.shapes.deleteFeatureById(idLine);
                        }
                    } catch (error) {
                        // console.log(`**** delete overlay err: `, error);
                    }
                } else {
                    feaPoint = this.shapes.findById(idAnchorPoint);
                    console.log(`**** closeTextBoxFn, feaPoint = ${feaPoint}
                        , this.shapes = `, this.shapes);
                    if (feaPoint == null) {
                        // Add marker
                        const evtPoint = cloneDeep(event);
                        evtPoint.type = this.google.maps.drawing.OverlayType.MARKER;
                        evtPoint.realType = MapDrawType.MARKER;
                        feaPoint = this.shapes.addTextBoxAnchorPoint(evtPoint, markerJson, idAnchorPoint
                            , textContent, fontFamily, fontSize, id);
                        this.shapes.setText(elemTextBox.value, idAnchorPoint);
                    } else {
                        this.shapes.setText(elemTextBox.value, idAnchorPoint);
                    }
                    feaLine = this.shapes.findById(idLine);
                    if (feaLine == null) {
                        feaLine = this.createTextBoxLineOffset(event, markerJson, idLine, id
                            , textContent, fontFamily, fontSize);
                        // console.log(`**** closeTextBoxFn CREATE LINE OFFSET
                        // , idLine = ${idLine}, feaLine = `, feaLine);
                        // console.log(`**** closeTextBoxFn CREATE LINE OFFSET, shapes = `, this.shapes);
                    }
                }
                if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function') {
                  this.setDirtyFunction();
                }
                this.drawType = MapDrawType.TEXT;
            }
            this.currentCloseTextBoxFn = (isEdit ? closeTextBoxFn : null);
            this.currentTextBoxId = (isEdit ? id : null);
            elemTextBox.onblur = ((e) => {
                // console.log(`**** elemTextBox onblur`);
                e.stopPropagation && e.stopPropagation();
                if (this.isPressKeyEscape) {
                    this.allowCreateNewTextBox = true;
                    this.isPressKeyEscape = false; // reset
                } else {
                    this.allowCreateNewTextBox = false;
                }
                
                closeTextBoxFn(e);
            });
            elemTextBox.onclick = ((e) => {
                // console.log(`**** elemTextBox onclick`);

                e.stopPropagation && e.stopPropagation();
                this.shapes?.clearSelection();

                this.allowCreateNewTextBox = false;
            });
            container.onclick = ((e) => {
                // console.log(`**** container onclick`);
                
                e.stopPropagation && e.stopPropagation();

                if (this.actionType == MapDrawAction.DELETE) {
                    try {
                        // console.log(`**** delete overlay`);
                        (container.parentNode as HTMLElement).removeChild(container);
                        this.shapes.deleteFeatureById(idAnchorPoint);
                        this.shapes.deleteFeatureById(idLine);
                    } catch (error) {
                        // console.log(`**** delete overlay err: `, error);
                    }
                } else {

                    elemTextBox.style.display = 'block';
                    this.closeTextBox.style.display = 'block';
                    elemContent.style.display = 'none';
                
                    this.currentCloseTextBoxFn = closeTextBoxFn;
                    this.currentTextBoxId = id;
    
                    this.allowCreateNewTextBox = false;
                }
                
            });

            elemTextBox.focus();

            this.textBoxDragable(container, elemContent, id, idAnchorPoint, idLine);
        };

        overlay.draw = () => {
            // console.log(`***** overlay.draw, isEdit = ${isEdit}
            // , feaLine = ${feaLine}`);

            const overlayProjection = overlay.getProjection();
            const position = overlayProjection.fromLatLngToDivPixel(coor);
            container.style.left = position.x + 'px';
            container.style.top = position.y + 'px';

            feaLine = this.shapes.findById(idLine);
            if (feaLine == null) {
                // console.log(`**** overlay.draw CREATE LINE OFFSET`);
                feaLine = this.createTextBoxLineOffset(event, markerJson, idLine, id
                    , textContent, fontFamily, fontSize);
                // console.log(`**** overlay.draw shapes = `, this.shapes.collection);
            } else {
                const lineGeoJson = this.setTextBoxLineOffsetCoordinates(id, markerJson);
                if (lineGeoJson) {
                    this.shapes.collection[idLine].geoJson = lineGeoJson;
                    const paths = [];
                    for (let i = 0; i < lineGeoJson.geometry.coordinates.length; i++) {
                        const coor = lineGeoJson.geometry.coordinates[i];
                        paths.push(new this.google.maps.LatLng(coor[1], coor[0]));
                    }
                    this.shapes.collection[idLine].setPath(paths);
                }
                
            }
        };

        overlay.onRemove = () => {
            // console.log(`***** overlay.onRemove, container = ${container}`);
            if (container) {
                (container.parentNode as HTMLElement)?.removeChild(container);
            }
        }
    }

    updateDimensionPosition(id) {
        const shape = this.shapes.collection[id];
        let dataCoords = [];
        if (shape) {
            dataCoords = shape.geoJson.geometry.coordinates;
        } else if (this.sketch) {
            const path = this.sketch.getPath().getArray();
            for (let i = 0; i < path.length; i++) {
                dataCoords.push([path[i].lng(), path[i].lat()]);
            }
        }
        let dimension = 0;
        if (Array.isArray(dataCoords) && dataCoords.length > 1) {
            const pos0 = {lat: dataCoords[0][1], lng: dataCoords[0][0]};
            const pos = {lat: dataCoords[dataCoords.length - 1][1], lng: dataCoords[dataCoords.length - 1][0]};
            dimension = this.google.maps.geometry.spherical.computeDistanceBetween(pos0, pos); // meters
    
        }
        const totalLength = sclUtilMap.totalLen(dataCoords);
        const midDistance = totalLength / 2;
        const coord = sclUtilMap.getPointByDistance(dataCoords, midDistance); // middle point
        let midPoint = null;
        if (coord) {
            midPoint = new this.google.maps.LatLng(coord[1], coord[0]);
        }
        // console.log(`*** distance = ${totalLength}, midDistance = ${midDistance}
        // , coord = ${JSON.stringify(coord)}
        // , midPoint = ${JSON.stringify(midPoint)}`);

        const dOv = this.dimensionOverlays[id];
        if (dOv == null) {
            console.log(`**** dOv is NULL`);
            return;
        }
        if (midPoint != null) {
            // const overlayProjection = this.map.getProjection();
            const overlayProjection = dOv.overlay.getProjection();
            if (typeof overlayProjection.fromLatLngToDivPixel === 'function') {
                const position = overlayProjection.fromLatLngToDivPixel(midPoint);
                dOv.dimensionContainer.style.left = position.x + 'px';
                dOv.dimensionContainer.style.top = position.y + 'px';
            }
            
        }
        
        // update distance
        if (Array.isArray(dataCoords) && dataCoords.length > 1) {
            dOv.dimensionLabel.innerHTML =
                sclUtilMap.formatDimension(dimension, this.dimensionsUnit, this.dimensionsPrecision);
        }
        
    }

    createDimensionFeature(id, coor, dimensionValue, fontFamily, fontSize) {
        
        let overlayIsAdded = false;
        const idContainer = `${this.keyName}__dimension-container__${id}}`;
        const idLabel = `${this.keyName}__dimension-label__${id}}`; // `${id}_label`;
        const obj = document.getElementById(idContainer);
        if (obj) {
            overlayIsAdded = true;
        }
        if (overlayIsAdded) {
            console.log(`This dimension ${idContainer} is added in map before`);
            this.updateDimensionPosition(id);

            return;
        }

        let dimensionContainer;
        let dimensionLabel;

        const overlay = new this.google.maps.OverlayView();
        overlay.setMap(this.map);
        if (!this.dimensionOverlays.hasOwnProperty(id)) {
            this.dimensionOverlays[id] = { overlay };
        } else if (this.dimensionOverlays[id] == null
            || typeof this.dimensionOverlays[id].overlay === 'undefined'
            || this.dimensionOverlays[id].overlay === null) {
            this.dimensionOverlays[id].overlay = overlay;
        }

        // console.log(`**** createDimensionFeature, id = ${id}
        // , this.currentDimensionId = ${this.currentDimensionId}`);
        this.currentDimensionId = id;
        

        overlay.onAdd = () => {
            // console.log(`****** DIMENSION ON ADD`);
            dimensionContainer = document.createElement('div');
            dimensionContainer.id = idContainer;
            dimensionContainer.className = 'ol-tooltip';

            // show dimension value
            dimensionLabel = document.createElement('div');
            dimensionLabel.id = idLabel;
            dimensionLabel.style.display = 'block';

            dimensionContainer.appendChild(dimensionLabel);

            // Add the element to the "overlayLayer" pane.
            const panes = overlay.getPanes();
            panes.floatPane.appendChild(dimensionContainer);

            
            this.dimensionOverlays[id] = {overlay, dimensionContainer, dimensionLabel};

            if (dimensionValue !== null) {
                dimensionLabel.innerHTML = sclUtilMap.formatDimension(dimensionValue, this.dimensionsUnit
                    , this.dimensionsPrecision);
                dimensionContainer.className = 'ol-tooltip';
            }

            // functions
            const closeDimensionEditorFn = (e) => {
                this.dimensionEditorContainer.style.display = 'none';
                dimensionLabel.style.display = 'block';
                const value = parseFloat(this.dimensionEditorInput.value);
                dimensionLabel.innerHTML = sclUtilMap.formatDimension(value, this.dimensionsUnit
                  , this.dimensionsPrecision);


                this.shapes.collection[this.currentDimensionId].geoJson.properties.dimension = value;

                this.closeDimensionEditorFn = null; // reset
                this.reCalculateDimensionFn = null; // reset
                this.currentDimensionId = null; // reset

                if (this.previousDimensionValue != value) {
                    this.hasDocumentChangeValue = false;
                    if (typeof this.setDirtyFunction === 'function') {
                      this.setDirtyFunction();
                    }
                }
                  
            };

            const reCalculateDimensionFn = (e) => {
                if (this.currentDimensionId === null) {
                    console.log(`Click on dimension value to use this feature`);
                    return;
                }
                const feature = this.shapes.collection[this.currentDimensionId];
                if (feature === null) {
                    console.log(`There has no feature of ${this.currentDimensionId}`);
                    return;
                }

                const dataCoord = feature.geoJson.geometry.coordinates;              ;
                const pos0 = {lat: dataCoord[0][1], lng: dataCoord[0][0]};
                const pos = {lat: dataCoord[dataCoord.length - 1][1], lng: dataCoord[dataCoord.length - 1][0]};
                const distance = this.google.maps.geometry.spherical.computeDistanceBetween(pos0, pos); // meters
                const distanceFormat = sclUtilMap.formatDimension(distance, this.dimensionsUnit, this.dimensionsPrecision);
                const label = this.dimensionOverlays[this.currentDimensionId].dimensionLabel;
                // console.log(`**** re-calculate distance = ${distance}, distanceFormat = ${distanceFormat}
                // , label = `, label);

                this.dimensionEditorInput.value = distance;
                label.innerHTML = distanceFormat;
                 
            };

            // events
            dimensionContainer.onclick = ((e) => {
                if (this.actionType == MapDrawAction.EDIT) {
                    return;
                }
                // console.log(`**** click dimensionContainer ${dimensionContainer.id}`);
                this.currentDimensionId = id;

                e.stopPropagation && e.stopPropagation();

                this.dimensionEditorContainer.style.display = 'flex';
                dimensionLabel.style.display = 'none';

                const containerPos = dimensionContainer.getBoundingClientRect();
                const containerHeight = dimensionContainer.offsetHeight / 2;
                const editorHeight = this.dimensionEditorContainer.offsetHeight;

                this.dimensionEditorContainer.style.top = `${containerPos.top - editorHeight - containerHeight}px`;
                this.dimensionEditorContainer.style.left = `${containerPos.left}px`;
                const content = dimensionLabel.innerHTML.replace(this.dimensionsUnit, '');
                this.previousDimensionValue = parseFloat(content);
                this.dimensionEditorInput.value = this.previousDimensionValue;

                this.closeDimensionEditorFn = closeDimensionEditorFn.bind(this);
                this.reCalculateDimensionFn = reCalculateDimensionFn.bind(this);
                
            });
        };

        overlay.draw = () => {
            if (typeof dimensionContainer === 'undefined' || dimensionContainer === null
            || typeof dimensionLabel === 'undefined' || dimensionLabel === null) {
                // console.log(`****** DIMENSION ON DRAW ERROR`);
                return;
            }
            // console.log(`****** DIMENSION ON DRAW, id = ${id}, list = `, this.dimensionOverlays);
            const overlayProjection = overlay.getProjection();
            const position = overlayProjection.fromLatLngToDivPixel(coor);
            dimensionContainer.style.left = position.x + 'px';
            dimensionContainer.style.top = position.y + 'px';

            if (fontFamily) {
                dimensionContainer.style['font-family'] = fontFamily;
                dimensionLabel.style['font-family'] = fontFamily;
            }
            if (fontSize) {
                dimensionContainer.style['font-size'] = fontSize;
                dimensionLabel.style['font-size'] = fontSize;
            }
            
            // console.log(`**** overlay.draw, id = ${id}, this.currentDimensionId = ${this.currentDimensionId}`);
            this.updateDimensionPosition(id);
        };

        overlay.onRemove = () => {
            console.log(`****** DIMENSION ON REMOVE, dimensionContainer = ${dimensionContainer}`);
            if (dimensionContainer) {
                const parentNode = (dimensionContainer.parentNode as HTMLElement);
                parentNode?.removeChild(dimensionContainer);
            }
        }
    }


    
    mapClickEvent(cb) {

        this.google.maps.event.addListener(this.map, 'click',
            (evt) => {
                // console.log(`map click`);
                if (this.shapes) { this.shapes.clearSelection(); }
                const latLng = evt.latLng;
                evt.latLng = { lat: latLng.lat(), lng: latLng.lng()};
                if (cb && typeof cb === 'function') {
                    cb(evt);
                }
            }
        );

    }

    getPixelByLatLng(latLng) {
        // tslint:disable-next-line: no-bitwise
        const numTiles = 1 << this.map.getZoom();
        const projection = this.map.getProjection();
        const worldCoordinate = projection.fromLatLngToPoint(latLng);
        const pixelCoordinate = new this.google.maps.Point(
            worldCoordinate.x * numTiles,
            worldCoordinate.y * numTiles);

        const topLeft = new this.google.maps.LatLng(
            this.map.getBounds().getNorthEast().lat(),
            this.map.getBounds().getSouthWest().lng()
        );

        const topLeftWorldCoordinate = projection.fromLatLngToPoint(topLeft);
        const topLeftPixelCoordinate = new this.google.maps.Point(
            topLeftWorldCoordinate.x * numTiles,
            topLeftWorldCoordinate.y * numTiles);

        return new this.google.maps.Point(
            pixelCoordinate.x - topLeftPixelCoordinate.x,
            pixelCoordinate.y - topLeftPixelCoordinate.y
        );
    }
    mouseOverAdded = false;
    mapPointerMoveEvent(cb) {
        //// this.google.maps.event.addListener(map, 'mousemove', function (event) {
        ////    redrawLine(event);
        //// });
        // let self = this;
        // this.map.data.addListener('mouseover', function(event) {
        //    let pixelCoordinate = self.getPixelByLatLng(event.latLng);
        //
        //    if(cb && typeof cb == "function")
        //        cb({id: event.feature.j.id, pixel : [pixelCoordinate.x, pixelCoordinate.y]});
        // });
        if (this.mapType === MapComponentName.BOUNDARY) {
            this.google.maps.event.addListener(this.map, 'mousemove', (event) => {
                // console.log(`**** mapPointerMoveEvent`);
                this.mapDivOnMouseMove(event);
            });
        }
        if (this.mouseOverAdded === false) {
            this.mouseOverAdded = true;
            const self = this;
            for (let i = 0; i < this.layerAssets.length; i++) {
                if (this.layerAssets[i].get('isCluster')) { continue; }
                this.layerAssets[i].addListener('mouseover', function(event) {
                    const pixelCoordinate = self.getPixelByLatLng(event.latLng);
                    const id = self.getFeatureId(event.feature);
                    // begin 15141#c57727
                    if (self.mapType === MapComponentName.SELECTED_ASSET) { // selected-asset
                        let color = '#0099FF'; // default ol blue
                        if (self.compActionType === 'primary') {
                            color = 'LimeGreen';
                        } else if (self.compActionType === 'secondary') {
                            color = 'black';
                        } else {
                            if (self.toolTipOnFeatureHover && (typeof self.toolTipOnFeatureHover === 'function') ) {
                                self.toolTipOnFeatureHover(event);
                            }
                        }
                        const type = event.feature.getGeometry().getType();
                        if (type === MapDrawType.POINT) {
                            // Not change style for point
                        } else if (type === MapDrawType.MULTI_POINT) {
                            const icon = {
                                path: self.google.maps.SymbolPath.CIRCLE ,
                                strokeOpacity: 1,
                                scale: 7,
                                strokeColor: color,
                                strokeWeight: 1,
                                fillColor: color,
                                fillOpacity: 0.5
                            };
                            self.layerAssets[i].overrideStyle(event.feature, {icon: icon});
                        } else {
                            self.layerAssets[i].overrideStyle(event.feature, {strokeColor: color});
                        }
                    }
                    // end 15141#c57727
                    if (cb && typeof cb === 'function') {
                        cb({id: id, pixel : [pixelCoordinate.x, pixelCoordinate.y]});
                    }
                });
                // begin 15141#c57727
                if (this.mapType === MapComponentName.SELECTED_ASSET) { // selected-asset
                    this.layerAssets[i].addListener('mouseout', function(event) {
                        self.layerAssets[i].revertStyle();
                    });
                }
                // end 15141#c57727
            }
        }
    }

    updateLocationMarkers = [];
    updateLocation(lat, lon, id, image, name, proId, isMapClick) {
        if (this.mapType === MapComponentName.BOUNDARY
            && this.drawType != null) {
            if (!this.sketch) { return; }
            const latLng = new this.google.maps.LatLng(lat, lon);
            this.hasDocumentChangeValue = false;
            this.isDrawing = true;
            this.vertexes.push(latLng);
            let path;
            switch(this.drawType) {
                case MapDrawType.MARKER:
                case MapDrawType.TEXT:
                    this.sketch.setPosition(latLng);
                    this.finishDrawShape(false);
                    break;
                case MapDrawType.CIRCLE:
                    if (this.isSetRadius == false) {
                        this.sketch.setCenter(latLng);
                        this.isSetRadius = true;
                    } else {
                        this.finishDrawCircle();
                    }
                    break;
                case MapDrawType.LINE_STRING:
                    path = this.sketch.getPath();
                    const len = path.getLength();
                    if (len == 0) {
                        path.push(latLng);
                        console.log(`**** updateLocation, push, len ${len}`);
                    } else {
                        path.push(latLng);
                        console.log(`**** updateLocation, push, len ${len}`);
                        path.setAt(len - 1, latLng);
                        console.log(`**** updateLocation, setAt len - 1, len ${len}`);
                    }
                    switch(this.drawTypeSpecific) {
                        case MapDrawTypeSpecial.DIMENSION:
                            if (this.vertexes.length == 1) {
                                const id = uuid.v1();
                                this.createDimensionFeature(id, latLng, null, this.fontCurrentSelected
                                    , this.fontSizeCurrentSelected);
                            }
                            break;
                        case MapDrawTypeSpecial.ARROW_AT_FIRST_POINT:
                            if (this.vertexes.length == 2) {
                                // add arrow
                                const color = (this.isDrawModeSingle ? this.singleColorDraging : this.multiColorDraging);
                                const bearing = this.google.maps.geometry.spherical.computeHeading(this.vertexes[1], this.vertexes[0] );
                
                                if (this.arrow == null) {
                                    this.arrow = new this.google.maps.Marker({
                                        position: this.vertexes[0],
                                        icon: {
                                            path: this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                            fillColor: color,
                                            strokeColor: color,
                                            scale: (this.lineWidthCurrentSelected ? this.lineWidthCurrentSelected : 2),
                                            rotation: bearing,
                                        },
                                    });
                                    this.arrow.setMap(this.map);
                                } else {
                                    this.arrow.setPosition(this.vertexes[0]);
                                }
                                
                            }
                            break;
                        default: break;
                    }
                    break;
                case MapDrawType.POLYGON:
                    path = this.sketch.getPath();
                    if (this.vertexes.length == 1) {
                        path.setAt(0, latLng);
                    } else {
                        const len = path.getLength();
                        if (this.vertexes.length > 2) {
                            const distance = this.distanceBetween2LatLngInPixel(this.vertexes[0]
                                , this.vertexes[this.vertexes.length - 1]);
                            // console.log(`**** distance = ${distance}`);
                            if (distance == 0) {
                                path.setAt(len - 1, latLng);
                                this.finishDrawShape(false);
                            } else {
                                path.push(latLng);
                                path.setAt(len - 1, latLng);
                            }
                        } else {
                            path.push(latLng);
                            path.setAt(len - 1, latLng);
                        }
                    }
                    break;
                case MapDrawType.BOX:
                    if (this.isSetRadius == false) {
                        this.sketch.setBounds(new this.google.maps.LatLngBounds(latLng, latLng));
                        this.isSetRadius = true;
                    } else {
                        this.updatePositionSketchRectangle(latLng);
                        this.finishDrawRectangle();
                    }
                    break;
                default: break;
            }
            
        } else {
            // go to map 'idle' event to create address point
            const position = new this.google.maps.LatLng(lat.toFixed(7), lon.toFixed(7));
            this.markerImage = image;
            this.updateLocationMarkers.push({ coor: position, id: id, proId: proId});
            if (!this.marker) {
                const geom = new this.google.maps.Data.Point(this.updateLocationMarkers[0].coor);
                this.marker = new this.google.maps.Data.Feature();
                this.marker.setGeometry(geom);
    
                if (this.markerImage != null) { // 15260
                    this.marker.setProperty('icon', this.markerImage);
                }
    
                this.marker.setProperty('zIndex', this.layerIndexAddress);
                this.marker.setProperty('id', this.updateLocationMarkers[0].proId);
                this.marker.id = this.updateLocationMarkers[0].proId;
                this.layerAssets[this.layerIndexAddress].add(this.marker);
            }
            if (this.updateLocationMarkers && this.updateLocationMarkers.length > 0) {
                this.marker.setGeometry( new this.google.maps.Data.Point(
                    this.updateLocationMarkers[this.updateLocationMarkers.length - 1].coor) );
            }
            if (isMapClick === false) {
                // this.map.setZoom(13);
                const bounds = new this.google.maps.LatLngBounds();
                bounds.extend(position);
                this.map.fitBounds(bounds);
                this.map.setCenter(position);
                this.map.panToBounds(bounds);
                // let cZoom = this.map.getZoom();//test test
                // this.map.setZoom(this.map.getZoom() - 3);
            }
        }
        
    }

    removeLocation(feature) {
        if (feature) {
            if (this.layerAssets[this.layerIndexAddress] !== null) {
                this.layerAssets[this.layerIndexAddress].remove(this.marker);
            }
        }

        this.marker = null;
    }


    zoomToLocation(lat, lon) {
        if (this.drawType !== MapDrawType.NA) { return; } // ignore zoom to location when in drawing
        const position = new this.google.maps.LatLng(lat, lon);
        const bounds = new this.google.maps.LatLngBounds();
        bounds.extend(position);
        this.map.fitBounds(bounds);
        this.map.setCenter(position);
        this.map.panToBounds(bounds);
        let cZoom = this.map.getZoom();
        cZoom = ( cZoom - 2 <= 0 ? cZoom : cZoom - 2 );
        this.map.setZoom(cZoom);
        // console.log('%c zoomToLocation = ' + cZoom, 'color:blue');
    }

    zoomToValue(zoomValue) {
        // if(!zoomValue && this.defaultZoom) zoomValue = this.defaultZoom; // 14707
        if (zoomValue) {
            this.map.setZoom(zoomValue);
        }

    }
    // 14781
    centerDefault() {
        // this.zoomToLocation(this.defaultLat, this.defaultLon);
        const position = new this.google.maps.LatLng(this.defaultLat, this.defaultLon);
        this.map.setCenter(position);
    }
    // 14781
    fitLayers(layersIndexFit, hasDefaultCoord) {
        const bounds = new this.google.maps.LatLngBounds();
        if (hasDefaultCoord) {
            bounds.extend(new this.google.maps.LatLng(this.defaultLat, this.defaultLon));
        }
        for (let i = 0; i < layersIndexFit.length; i++) {
            const idx = layersIndexFit[i];
            if ( this.isHeatLayer(idx)) { continue; } // heat map
            this.layerAssets[idx].forEach(function(feature) {
                const geom = feature.getGeometry();
                geom.forEachLatLng(function(latlng) {
                    bounds.extend(latlng);
                });
            });
        }
        this.map.fitBounds(bounds, {duration: 0});
    }
    fitLayerIndex(layersIndexFit) {
        const bounds = new this.google.maps.LatLngBounds();
        if ( this.isHeatLayer(layersIndexFit)) { return; } // heat map
        this.layerAssets[layersIndexFit].forEach((feature) => {
            const geom = feature.getGeometry();
            geom.forEachLatLng((latlng) => {
                bounds.extend(latlng);
            });
        });
        this.map.fitBounds(bounds, {duration: 0});

    }

    createMarkerAsset(lat, lon, id, image, name , type) {
        // console.log('create marker asset, id = ' + id + ', name = ' + name + ', type = ' + type + ', image = ' + image);
        const location = new this.google.maps.LatLng(lat, lon);

        let f = this.getFeatureById(id);
        const properties = this.createPointProperty(location, image, name, id, null, null, null
            , null, null, null, null, null, null);
        if (type) { properties.assetType = type; }
        properties.id = id;
        const geom = new this.google.maps.Data.Point(location);
        if (type) { geom.assetType = type; }
        // let isContain = this.map.data.contains(f);
        if (f == null) {
            geom.id = id;

            f = new this.google.maps.Data.Feature();
            f.setGeometry(geom);
            f.id = id;

            this.setFeatureProperties(f, properties);

            // this.addFeature(f);
            this.storeSelectedAssets(f, undefined);
        } else {
            f.setGeometry(geom);
        }


        return location;
    }
    getGEOJSON(cb) {
        const geoJson = { type: GEOJSON_TYPE.FEATURE_COLLECTION, features: [] };
        geoJson.features = this.shapes.getGeoJson();

        if (cb && typeof cb === 'function') {
            cb(geoJson);
        }

    }

    transformEPSG(long, lat, from, to) {
        // let location = this.ol.proj.transform([parseFloat(long), parseFloat(lat)], from, to);
        // return location;
    }

    isHeatLayer(layerIndex) {
        if (layerIndex < this.layerAssets.length) {
            const isHeatMap = this.layerAssets[layerIndex].get('isHeatMap');
            if (isHeatMap) { return true; }
            return false;
        }
        return false;
    }

    fit(ConfigService, maxZoom, initialZoomChange) {
        // console.log('***************** GG fit ***************************');
        // let _maxZoom = 15;
        // if(maxZoom) _maxZoom = maxZoom;
        // else{
        //     if (ConfigService.clientConfig().maxZoomLevel) {
        //         _maxZoom = ConfigService.clientConfig().maxZoomLevel;
        //     }
        // }// not use anymore

        // zoom to show all the features
        const bounds = new this.google.maps.LatLngBounds();
        let hasFeature = false;
        for (let i = 1; i < this.layerAssets.length; i++) {
            if ( this.isHeatLayer(i)) { continue; } // heat map
            try {
                if (this.layerAssets[i].isCluster) {
                    const features = this.layerAssets[i].markers;
                    features.forEach(function(feature) {
                        const latlng = feature.position;
                        if (latlng) {
                            hasFeature = true;
                            bounds.extend(latlng);
                        }
                    });  
                } else {
                    
                    this.layerAssets[i].forEach(function(feature) {
                        const geom = feature.getGeometry();
                        if (geom) {
                            geom.forEachLatLng(function(latlng) {
                                hasFeature = true;
                                bounds.extend(latlng);
                            });
                        }
                    });    
                }
                
            } catch (err) {
                console.log(`**** Fit feature error happen in layer index = ${i}`, err);
            }
            
        }

        this.map.fitBounds(bounds, {duration: 0});
        // 13928, use in case the map is visible at the begining, then it will go to tilesloaded in this.init
        // and set map to fit bounds with self.bounds value
        if (hasFeature) {
            this.bounds = bounds;
        }
        if (initialZoomChange != null && initialZoomChange !== 0) {
            const self = this;
            const listener = this.google.maps.event.addListener(this.map, 'idle', function() {
                console.log('%c idle 2 ', 'color:blue');
                let currentZoom = self.map.getZoom();
                currentZoom += initialZoomChange;
                self.map.setZoom(currentZoom);
                // if (self.map.getZoom() > 16) self.map.setZoom(16);
                self.google.maps.event.removeListener(listener);
            });
        }
        this.clampZoomFloor();
    }
    fitCoords(coords) {
        // calculate bounds base on collection of coordinates
        if (!coords || coords.length === 0) { return; }

        this.bounds = new this.google.maps.LatLngBounds();
        this.fitCoordCount = coords.length;
        for (let i = 0; i < coords.length; i++) {
            this.bounds.extend( new this.google.maps.LatLng(coords[i][1], coords[i][0]) );
        }
        this.map.fitBounds(this.bounds, {duration: 0});

        if (coords.length === 1) {
            let currentZoom = this.map.getZoom();
            currentZoom = currentZoom - 2;
            if (currentZoom < 0) { currentZoom = 1; }
            this.map.setZoom(currentZoom);
        }
        this.clampZoomFloor();
    }

    mapReadOnly(isReadOnly) {

    }

    getAllFeatures() {
        let features = [];
        for (let i = 1; i < this.layerAssets.length; i++) {
            if (this.isHeatLayer(i)) { continue; }// heat map
            if (this.layerAssets[i].isCluster) {
                const lst = this.layerAssets[i].markers;
                if (lst && lst.length > 0) {
                    for (let i = 0; i < lst.length; i++) {
                        features.push(lst[i]); 
                    }
                }
            } else {
                this.layerAssets[i].forEach(function(feature) {
                    features.push(feature);
                });
            }
            
        }
        return features;
    }

    getDifference(a1, a2) {
        a1 = (a1 > 0) ? a1 : 360 + a1;
        a2 = (a2 > 0) ? a2 : 360 + a2;
        let angle = Math.abs(a1 - a2) + 180;
        if (angle > 180) {
            angle = 360 - angle;
        }
        return   Math.abs(angle);
    }

    getBearings(point1, point2, point3) {
        // let spherical = this.google.maps.geometry.spherical;

        const bearing1 = this.google.maps.geometry.spherical.computeHeading(point1, point2);
        const bearing2 = this.google.maps.geometry.spherical.computeHeading(point2, point3);
        const angle = this.getDifference(bearing1, bearing2);
        return angle;
    }

    rad(x) {
        return x * Math.PI / 180;
    }

    getDistance(p1, p2) {
        const R = 6378137; // Earth mean radius in meter
        const dLat = this.rad(p2.lat() - p1.lat());
        const dLong = this.rad(p2.lng() - p1.lng());
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.rad(p1.lat())) * Math.cos(this.rad(p2.lat())) *
            Math.sin(dLong / 2) * Math.sin(dLong / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d; // returns the distance in meter
    }
    getFeaturesFromMap(features, clickedFeature, type, assetSelectionsAvailable) {
        let existedFeature;
        let clickedId = this.getFeatureId(clickedFeature);
        const p: any = this.getFeatureProperties(clickedFeature, ['layerDisplayOnly', 'zIndex', 'isCluster']);
        const pId = this.getFeatureId(clickedFeature);
        const pLayerDisplayOnly = p.layerDisplayOnly;
        const zIndex = p.zIndex;

        if (p.isCluster) {
            for (let i = 0; i < this.selectedAssets.length; i++) {
                let sId = this.getFeatureId(this.selectedAssets[i]);
                if (sId.indexOf(type) < 0) { continue; }
                if (sId === pId) {
                    existedFeature = this.selectedAssets[i];
                    break;
                }
            }
            if (pLayerDisplayOnly || pId === 'address') {
                return;
            }
            features.push(clickedFeature);
        } else {
            if (type === MapSelectAssetType.PRIMARY) {
                if (clickedId && clickedId.indexOf('_secondary') < 0) {
                    this.layerAssets[this.layerIndexPrimary].forEach((feature) => {
                        const fId = this.getFeatureId(feature); // feature.j.id;
                        if (fId === clickedId) {
                            existedFeature = feature;
                            return;
                        }
                        // if(fId && fId.indexOf(clickedId) > -1){
                        //     existedFeature = feature;
                        //     return;
                        // }
                    });
                } else {
                    if (clickedId && clickedId.indexOf('_') > -1) { clickedId = clickedId.split('_')[0]; }
                    this.layerAssets[this.layerIndexPrimary].forEach((feature) => {
                        const fId = this.getFeatureId(feature); // feature.j.id;
                        if (fId && fId.indexOf(clickedId) > -1 ) {
                            existedFeature = feature;
                            return;
                        }
                    });
                }
                if (assetSelectionsAvailable == null && pLayerDisplayOnly) { return; } else {
                    const iAssetSelectionsAvailable = assetSelectionsAvailable[((zIndex - 1) < 0 ? 0 : (zIndex - 1))];
                    let sType = type.replace('Asset', '');
                    if ( iAssetSelectionsAvailable != null && iAssetSelectionsAvailable.indexOf(sType) < 0 ) {
                        
                        if (sType != null && sType.trim().length > 0) {
                            sType = sType.charAt(0).toUpperCase() + ( (sType != null && sType.trim().length > 1 ) ? sType.slice(1) : '' );
                        }
                        console.log('sc-selected-asset: The assetSelectiosAvailable field is not set to allow ' + sType
                        + ' selections for this layer');
                        return;
                    }
                }
    
                if (pLayerDisplayOnly || pId === 'address') {
                    return;
                }
    
                features.push(clickedFeature);
            } else if (type === MapSelectAssetType.SECONDARY) {
                if (clickedId && clickedId.indexOf('_primary') < 0) {
                    this.layerAssets[this.layerIndexSecondary].forEach((feature) => {
                        const fId = this.getFeatureId(feature); // feature.j.id;
                        if (fId === clickedId) {
                            existedFeature = feature;
                            return;
                        }
                        // if(fId && fId.indexOf(clickedId) > -1){
                        //     existedFeature = feature;
                        //     return;
                        // }
                    });
                } else {
                    if (clickedId && clickedId.indexOf('_') > -1) {
                        clickedId = clickedId.split('_')[0];
                    }
                    this.layerAssets[this.layerIndexSecondary].forEach((feature) => {
                        const fId = this.getFeatureId(feature); // feature.j.id;
                        if (fId && fId.indexOf(clickedId) > -1) {
                            existedFeature = feature;
                            return;
                        }
                    });
                }
    
                if (pLayerDisplayOnly || pId === 'address') {
                    return;
                }
                features.push(clickedFeature);
            }
        }

        // find features in the same layer index with the same sharedId ( if have )
        const existingKeys = new Set<string>();

        for(let i = 0; i < features.length; i++) {
            const p: any = this.getFeatureProperties(clickedFeature, ['sharedId', 'zIndex']);
            const pSharedId = p.sharedId;

            if (typeof pSharedId === 'string') {
                const pId = this.getFeatureId(features[i]);

                const key = `${pSharedId}|${pId}`;
                if (existingKeys.has(key)) {
                continue;
                }
                existingKeys.add(key);

                
                const pLayerIndex = p.zIndex;
                this.layerAssets[pLayerIndex].forEach((f) => {
                    const fId = this.getFeatureId(f);
                    const fSharedId = this.getFeatureProperty(f, 'sharedId');
                    const fKey = `${fSharedId}|${fId}`;

                    if (typeof fSharedId === 'string' && fId !== pId && fSharedId === pSharedId
                        && !existingKeys.has(fKey)
                    ) {
                        features.push(f);
                        existingKeys.add(fKey);
                    }
                });
            }
        }
        
        return existedFeature;
    }

    getAssetProperties(feature, relatedFields, coordinates, typeAsset, typeSelection) {
        let name = '';
        let id = this.getFeatureId(feature); // feature.j.id;
        if (id.indexOf('_') > -1) { id = id.split('_')[0]; }
        // feature.j.properties;
        const p: any = this.getFeatureProperties(feature, ['name', 'type', 'radius', 'circleCenter']);
        const pName = p.name;
        if (pName) { name = pName; }
        let type = p.type;
        

        const propertiesLinkAsset = {
            documentId: id,
            name: name
        };
        const asset: any = {
            type: FEATURE_TYPE.FEATURE,
            properties : {
                type: typeAsset,
                linkAssets: []
            }
        };
        if (p.radius) {
            type = MapDrawType.POINT;
            asset.properties.radius = p.radius;
            asset.properties.subType = MapDrawType.CIRCLE;
        }
        if (!typeSelection || typeSelection === 'featureCollection' ) {
            if (p.radius) { coordinates = p.circleCenter; }
            asset.geometry = {
                type : MapDrawType.POINT,
                coordinates : coordinates// [coordinates.lng(), coordinates.lat() ]
            };
        } else if (typeSelection !== 'undefined'
         && typeSelection === MapSelectAssetMode.ASSET) {
            const t = type;
            if (p.radius) { coordinates = p.circleCenter; }
            asset.geometry = {
                type : t,
                coordinates : coordinates// [coordinates.lng(), coordinates.lat() ]
            };
        }

        if (!id) {
            return '';
        }
        if (relatedFields) {
            for (const field in relatedFields) {
                if (relatedFields.hasOwnProperty(field)) {
                    const value = this.getFeatureProperty(feature, field); // pro[field];
                    if (value) {
                        propertiesLinkAsset[field] = value;
                    }
                }
            }
        }
        asset.properties.linkAssets.push(propertiesLinkAsset);
        return asset;
    }


    removeUnselectedAssetItem(existAsset, assets, type) {
        if (existAsset) {
            let isExist = false;
            let idExistAsset = existAsset.properties.linkAssets[0].documentId;
            if (idExistAsset && idExistAsset.indexOf('_') > -1) {
                idExistAsset = idExistAsset.split('_')[0];
            }
            for (let j = 0; j < assets.length; j++) {
                const item = assets[j];
                const idItem = item.properties.linkAssets[0].documentId;
                if (idItem && idItem.indexOf(idExistAsset) > -1) {
                    assets.splice(j, 1);
                    break;
                }
            }
            const len = this.selectedAssets.length;

            for (let i = len - 1; i > -1; i--) {
                const f = this.selectedAssets[i];
                const fId = this.getFeatureId(f);
                if (fId && fId.indexOf(idExistAsset) > -1) {
                    try {
                        f.setMap(null);
                    } catch (err) {
                        const isRemoved = false;
                        const self = this;
                        if (type === MapSelectAssetType.PRIMARY) {
                            this.layerAssets[this.layerIndexPrimary].forEach(function(fea) {
                                const id = self.getFeatureId(fea);
                                if (id && id.indexOf(idExistAsset) > -1) {// if(fea.j.id.indexOf(idExistAsset) > -1){
                                    self.layerAssets[self.layerIndexPrimary].remove(fea);
                                }
                            });
                        } else if (type === MapSelectAssetType.SECONDARY) {
                            this.layerAssets[this.layerIndexSecondary].forEach(function(fea) {
                                const id = self.getFeatureId(fea);
                                if (id && id.indexOf(idExistAsset) > -1) {// if(fea.j.id.indexOf(idExistAsset) > -1){
                                    self.layerAssets[self.layerIndexSecondary].remove(fea);
                                }
                            });
                        }
                    }

                    this.selectedAssets.splice(i, 1);
                    isExist = true;
                    break;
                }
            }
            return isExist;
        }
        return false;
    }

    parseAssetsFromFeatures(features, assetField, coor, typeAsset, mode) {

        if (mode === MapSelectAssetMode.ASSET) {
            const asset = this.getAssetProperties(features, assetField.relatedFields, coor, typeAsset, mode);
            return asset;
        } else {
            const assets = [];
            for (let i = 0; i < features.length; i++) {
              const asset = this.getAssetProperties(features[i], assetField.relatedFields, coor[i], typeAsset, null);
              if (!asset) { continue; }
              const sharedId = this.getFeatureProperty(features[i], 'sharedId');

              if (typeof sharedId === 'string') {
                if (assets.length === 0) {
                  asset.type = FEATURE_TYPE.GEOMETRY_COLLECTION;
                  asset.geometries = [
                    asset.geometry
                  ];
                  delete asset.geometry;
                  assets.push(asset);
                } else {
                  assets[0].geometries.push(asset.geometry);
                  delete asset.geometry;
                }
              } else {
                assets.push(asset);
              }
              
            }
            return assets;
            
          }
    }

    getAllFeaturesSelected() {
        return (this.selectedFeatures == null ? [] : this.selectedFeatures);
    }
    addInteractionSelect(currentSelected) {
        //// this.multipleSelection = true;
        if (this.selectedFeatures == null || ( currentSelected != null
            && this.selectedFeatures.length !== currentSelected.length) ) {
                this.selectedFeatures = currentSelected;
        }
        //// if(this.selectedFeatures != null && this.selectedFeatures.length > 0){
        ////    //this.map.data.revertStyle();
        ////    for(let i = 0; i < this.selectedFeatures.length; i++){
        ////        let item = this.selectedFeatures[i];
        ////        item.j.properties.isColorful = true;
        ////        this.map.data.overrideStyle(item);
        ////    }
        ////
        //// }//13835

        const self = this;
        this.layerAssets[this.layerIndexUser].forEach(function(f) {
            self.layerAssets[self.layerIndexUser].overrideStyle(f, {zIndex: self.layerIndexUser, visible: true});
        });

        for (let i = 0; i < this.selectedFeatures.length; i++) {
            let id = this.getFeatureId(this.selectedFeatures[i]); // this.selectedFeatures[i].j.id;
            if (id && id.indexOf('_') > -1) { id = id.split('_')[0]; }
            for (let j = 0; j < this.layerIndexFilter + 1; j++) {
                if (this.isHeatLayer(j) || this.layerAssets[j].get('isCluster') ) { continue; }// heat map
                this.layerAssets[j].forEach(function(f) {
                    const fId = self.getFeatureId(f);
                    if (fId && fId.indexOf(id) > -1) {// if(f.j.id.indexOf(id) > -1){
                        self.layerAssets[j].overrideStyle(f, {zIndex: j});
                    }
                });
            }
        }



        this.multipleSelection = true;
    }
    removeInteractionSelect() {
        this.multipleSelection = false;
        // if(this.selectedFeatures != null && this.selectedFeatures.length > 0){
        //    this.map.data.revertStyle();
        //    for(let i = 0; i < this.selectedFeatures.length; i++){
        //        this.selectedFeatures[i].j.properties.isColorful = false;
        //        this.map.data.overrideStyle(this.selectedFeatures[i]);
        //    }
        //
        // }//13835
        // console.log('%c removeInteractionSelect, getMap = ' + this.layerAssets[this.layerIndexUser].getMap() , 'color:blue');
        // if(this.selectedFeatures != null)
        //    console.log('%c |==> removeInteractionSelect, selectedFeatures.len = ' + this.selectedFeatures.length , 'color:blue');
        // this.layerAssets[this.layerIndexUser].setMap(null);
        // this.layerAssets[this.layerIndexUser].setStyle({visible: false});
        // this.layerAssets[this.layerIndexUser].setStyle(this.styleAddress.bind(this));
        const self = this;
        this.layerAssets[this.layerIndexUser].forEach(function(f) {
            self.layerAssets[self.layerIndexUser].overrideStyle(f, {visible: false});
        });

        for (let i = 0; i < this.selectedFeatures.length; i++) {
            let id = this.getFeatureId(this.selectedFeatures[i]); // this.selectedFeatures[i].j.id;
            if (id && id.indexOf('_') > -1) { id = id.split('_')[0]; }
            for (let j = 0; j < this.layerIndexFilter + 1; j++) {
                if (this.isHeatLayer(j) || this.layerAssets[j].get('isCluster')) { continue; }// heat map
                this.layerAssets[j].forEach(function(f) {
                    const fId = self.getFeatureId(f);
                    if (fId && fId.indexOf(id) > -1) {// if(f.j.id.indexOf(id) > -1){
                        self.layerAssets[j].overrideStyle(f, {zIndex: j});
                    }
                });
            }
        }
    }
    showLayer(options) {
        this.modeMultiple = options.isShow;
        if (options.isShow) {
            this.addInteractionSelect(options.currentSelected);
        } else {
            this.removeInteractionSelect();
        }
    }
    activeInteractionSelect(isActive) {
        this.multipleSelection = isActive;
    }

    drawActionDelete(event) {
        // if (event.type == 'circle') {
        //    let radius = event.overlay.getRadius();
        // }
        // logger.info("event = ");
        // logger.info(event);
    }

    drawActionProperties(evt) {

    }



    createTextStyle_14313(label, pColor) {
        // if (label.labelFont == '\'Open Sans\'' && !this.openSansAdded) {
        //    let openSans = document.createElement('link');
        //    openSans.href = 'https://fonts.googleapis.com/css?family=Open+Sans';
        //    openSans.rel = 'stylesheet';
        //    document.getElementsByTagName('head')[0].appendChild(openSans);
        //    this.openSansAdded = true;
        // }
        const fontFamily = (label.labelFont === '' || label.labelFont == null) ? 'Open Sans' : label.labelFont;
        let sColor = pColor;
        if (label.labelColor !== undefined && label.labelColor !== null && label.labelColor !== '') {
            sColor = label.labelColor;
        }

        const fontSize = (label.labelFontSize === '' || label.labelFontSize == null) ? '12px' :
        ( (typeof label.labelFontSize === 'string') ? (label.labelFontSize.replace('px', '') + 'px' ) : (label.labelFontSize + 'px') );
        const baseline = (label.labelTextBaseline === '' || label.labelTextBaseline == null) ? 'baseline' : label.labelTextBaseline + '';
        const fontWeight = (label.labelFontWeight === '' || label.labelFontWeight == null) ? 'normal' : label.labelFontWeight ;
        const strokeColor = (label.labelOutlineColor === '' || label.labelOutlineColor == null) ? 'black' : label.labelOutlineColor;
        const strokeWidth = (label.labelOutlineWidth === '' || label.labelOutlineWidth == null) ? '2px' : label.labelOutlineWidth + 'px';
        const rotation = (label.labelRotation === '' || label.labelRotation == null) ? 0 : label.labelRotation;
        let padding = (label.labelPadding === '' || label.labelPadding == null) ? undefined : label.labelPadding;
        if (!padding) { padding = [0, 0, 0, 0]; }

        // let style = {display: "inline-block"
        //     , "text-align": label.labelTextAlign
        //     , "vertical-align" : baseline
        //     , "color": sColor
        //     , "-webkit-text-stroke-color": strokeColor
        //     , "-webkit-text-stroke-width": strokeWidth
        //     , "font-family": fontFamily
        //     , "font-size": fontSize
        // };
        const style: any = {
             'text-align': label.labelTextAlign
            , 'vertical-align' : baseline
            , color: sColor
            , '-webkit-text-stroke-color': strokeColor
            , '-webkit-text-stroke-width': strokeWidth
            , 'font-family': fontFamily
            , 'font-size': fontSize
            , 'transform-origin': '0 0'// Rotate from top left corner (not default)
            , transform: 'rotate(' + parseFloat(rotation) + 'deg)'
            , 'padding-top': padding[0] + 'px'
            , 'padding-right': padding[1] + 'px'
            , 'padding-bottom': padding[2] + 'px'
            , 'padding-left': padding[3] + 'px'
        };
        if (fontWeight === 'bold') { style['font-weight'] = fontWeight; } else { style['font-style'] = fontWeight; }

        const offsetY = (label.labelOffsetY === '' || label.labelOffsetY == null) ? 0 : label.labelOffsetY;
        if (offsetY !== 0) {
            style.position = 'relative';
            style.top = offsetY + 'px';
        }

        // if (fontFamily == '\'Open Sans\'' && !this.openSansAdded) {
        //    let openSans = document.createElement('link');
        //    openSans.href = 'https://fonts.googleapis.com/css?family=Open+Sans';
        //    openSans.rel = 'stylesheet';
        //    document.getElementsByTagName('head')[0].appendChild(openSans);
        //    this.openSansAdded = true;
        // }

// labelPlacement , labelMaxAngle ,labelOverflow , labelRotationWithView ,labelRotation ,labelPadding ,

        return style;
    }

    createTextStyle(label, pColor) {
        // if (label.labelFont == '\'Open Sans\'' && !this.openSansAdded) {
        //    let openSans = document.createElement('link');
        //    openSans.href = 'https://fonts.googleapis.com/css?family=Open+Sans';
        //    openSans.rel = 'stylesheet';
        //    document.getElementsByTagName('head')[0].appendChild(openSans);
        //    this.openSansAdded = true;
        // }
        const fontFamily = (label.labelFont) ? label.labelFont : 'Open Sans';
        let sColor = pColor;
        if (label.labelColor) { sColor = label.labelColor; }

        const fontSize = (!label.labelFontSize) ? '12px' : ( (typeof label.labelFontSize === 'string')
        ? (label.labelFontSize.replace('px', '') + 'px' ) : (label.labelFontSize + 'px') );
        let fontWeight = (label.labelFontWeight) ? label.labelFontWeight : 'normal';
        fontWeight = fontWeight.toLowerCase();

        const rotation = (label.labelRotation) ? label.labelRotation : 0;
        let padding = (label.labelPadding === '' || label.labelPadding == null) ? undefined : label.labelPadding;
        if (!padding) { padding = [0, 0, 0, 0]; }

        const strokeColor = (label.labelOutlineColor) ? label.labelOutlineColor : 'black';
        const strokeWidth = (!label.labelOutlineWidth) ? '0px' : ( (typeof label.labelOutlineWidth === 'string')
        ? (label.labelOutlineWidth.replace('px', '') + 'px' ) : (label.labelOutlineWidth + 'px') );

        const style: any = {display: 'inline-block'
            , 'text-align': '' + label.labelTextAlign + ''
            , 'vertical-align' : '' + (label.labelTextBaseline === '' || label.labelTextBaseline == null)
            ? 'baseline' : label.labelTextBaseline + ''
            , color: sColor
            , '-webkit-text-stroke-color': strokeColor
            , '-webkit-text-stroke-width': strokeWidth
            , 'text-indent': '' + (label.labelOffsetX === '' || label.labelOffsetX == null) ? 0 : label.labelOffsetX + 'px'
            , 'font-family': '' + fontFamily + ''
            , 'font-size': fontSize
            , 'transform-origin': '0 0'// Rotate from top left corner (not default)
            , transform: 'rotate(' + parseFloat(rotation) + 'deg)'
        };
        if (fontWeight === 'bold') { style['font-weight'] = fontWeight; } else { style['font-style'] = fontWeight; }

        const offsetY = (label.labelOffsetY === '' || label.labelOffsetY == null) ? 0 : label.labelOffsetY;
        if (offsetY !== 0) {
            style.position = 'relative';
            style.top = offsetY + 'px';
        }

        // if (fontFamily == '\'Open Sans\'' && !this.openSansAdded) {
        //    let openSans = document.createElement('link');
        //    openSans.href = 'https://fonts.googleapis.com/css?family=Open+Sans';
        //    openSans.rel = 'stylesheet';
        //    document.getElementsByTagName('head')[0].appendChild(openSans);
        //    this.openSansAdded = true;
        // }

// labelPlacement , labelMaxAngle ,labelOverflow , labelRotationWithView ,labelRotation ,labelPadding ,

        return style;
    }

    centerPoint(points) {
        const center = [ 0.0, 0.0 ];
        for (let i = 0; i < points.length; i++) {
            center[0] += points[i].lat;
            center[1] += points[i].lng;
        }

        const totalPoint = points.length;
        center[0] = center[0] / totalPoint;
        center[1] = center[1] / totalPoint;

        return center;
    }

    createLabel(lat, lon, label, color, id) {
        const currentZoom = this.map.getZoom();
        const displayZoom = (!label.labelDisplayZoom ? 9: (label.labelDisplayZoom > 17 ? 17 : label.labelDisplayZoom));
        const text = (currentZoom < displayZoom ? '': (label.labelText ? label.labelText: ''));

        const lb = new this.MarkerWithLabel({
            // map: this.map,
            position:  new this.google.maps.LatLng(lat, lon),
            icon: '  ', // markerIcon,
            labelContent: text,
            labelAnchor: new this.google.maps.Point(18, 12),
            labelClass: '', // the CSS class for the label
            labelStyle: this.createTextStyle(label, color), //
            labelInBackground: true
        });
        lb.label.labelDiv_.id = id;
        lb.labelText = label.labelText;
        lb.labelDisplayZoom = label.labelDisplayZoom;
        // console.log('**** createLabel, labelText = ' + label.labelText + ', id = ' + id + ', labelDiv_ = ' , lb.label.labelDiv_);
        return lb;
    }
    updateLabelAllLayers() {
        const currentZoom = this.map.getZoom();

        for (let i = 1; i < this.layerAssets.length; i++) {
            try {
                if (this.layerAssets[i].get('isCluster')) {
                    continue;
                }
                this.layerAssets[i].forEach((fea) => {
                    const lb = this.getFeatureProperty(fea, 'lb');
                    // console.log('**** updateLabelAllLayers, lb = ', lb);
                    if (lb) {
                        const displayZoom = (!lb.labelDisplayZoom ? 9: (lb.labelDisplayZoom > 17 ? 17 : lb.labelDisplayZoom));
                        const text = (currentZoom < displayZoom ? '': (lb.labelText ? lb.labelText: ''));
                        lb.labelContent = text;
                    }
                });
            } catch (err) {
                console.log(err);
            }
        }
    }
    updateRotateScaleByZoom() {
        // console.log('%c updateRotateScaleByZoom', 'color:blue');
        const currentZoom = this.map.getZoom();
        for (let i = 1; i < this.layerAssets.length; i++) {
            try {
                if (this.layerAssets[i].get('isCluster') || this.isHeatLayer(i)) {
                    continue;
                }
                this.layerAssets[i].forEach((fea) => {
                    const p: any = this.getFeatureProperties(fea, ['icon', 'id', 'rotation', 'size', 'scaledInfo', 'lb']);
                    const pIcon = p.icon + '#' + p.id;

                    if (p.lb) {
                        const displayZoom = (!p.lb.labelDisplayZoom ? 9: (p.lb.labelDisplayZoom > 17 ? 17 : p.lb.labelDisplayZoom));
                        const text = (currentZoom < displayZoom ? '': (p.lb.labelText ? p.lb.labelText: ''));
                        p.lb.labelContent = text;
                    }

                    if (p.rotation && p.rotation != 0) {
                        this.iconRotate(pIcon, p.rotation, p.id);
                    }
                    if (p.scaledInfo) {
                        this.iconScale(pIcon, p.size[0], p.size[1], p.scaledInfo.w, p.scaledInfo.h
                            , p.scaledInfo.top, p.scaledInfo.left, p.scaledInfo.isFlip);
                        
                    }
                });
            } catch (err) {
                console.log(err);
            }
        }
    }

    traverseCoor(coor, obj) {
        if (Array.isArray(coor)) {
            for (let i = 0; i < coor.length; i++) {
                if (Array.isArray(coor[i])) {
                    this.traverseCoor(coor[i], obj);
                } else {
                    if (isNaN(coor[i]) ) { obj.hasNaN = true; } else { coor[i] = Number(coor[i]); }
                }
            }
        }
    }
    createFeatureCluster(coord, type, options) {
        let geom; let properties;
        const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
        const url = (options.url ? options.url : '');
        const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
        const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');

        const lon = Number(coord[0]);
        const lat = Number(coord[1]);
        if (isNaN(lon) || isNaN(lat)) { return null; }

        const latLng = new this.google.maps.LatLng(lat, lon);
        let point = SclMapConstantService.MAP_MARKER;
        if (options.point) { point = options.point; }
        if (options.imageFileNo) {
            point = sclUtilMap.handleImageFileNo(options.imageFileNo);
        }
        if (options.image) { point = options.image; }
        properties = this.createPointProperty(latLng, point, options.name, options.id, relatedAssets
            , options.color, options.layerDisplayOnly,
            options.tooltip, options.anchor, type, '', options.url, options.sharedId);
            
        let clusterImageWidth = 18; let clusterImageHeight = 30;
        if (options.layer.clusterImageWidth) { clusterImageWidth = options.layer.clusterImageWidth; }
        if (options.layer.clusterImageHeight) { clusterImageHeight = options.layer.clusterImageHeight; }
        const markerImage = new this.google.maps.MarkerImage(
            point,
            new this.google.maps.Size(clusterImageWidth, clusterImageHeight)
        );
        const feature = new this.google.maps.Marker({
            position: latLng,
            icon: markerImage,
        });
        properties.clusterImageWidth = clusterImageWidth;
        properties.clusterImageHeight = clusterImageHeight;
        properties.isCluster = true;
        if (options.rotation) { properties.rotation = options.rotation; }
        if (options.scale) { properties.scale = options.scale; }
        feature.setValues(properties);
        // event for click to cluster marker
        this.google.maps.event.addListener(feature, 'click', () => {
            // console.log('marker ' + feature.get('id') + ' clicked');
            
            const fs = [feature];

            const fId = feature.id;
            let id0 = fId;
            if (id0.indexOf('_') > -1) { id0 = id0.split('_')[0]; }
            const lst = this.layerAssets[feature.zIndex].markers;
            for (let i = 0; i < lst.length; i++) {
                const nId = lst[i].id;
                if (nId === fId) { continue; }
                if (nId.indexOf(id0) > -1) {
                    fs.push(lst[i]);
                }
            }
            // console.log('|===> select fs = ', fs);
            if (this.multipleSelection) {
                const isRemove = this.removeSelectedAsset(id0);
                if (isRemove) { return; }
            }

            if (this.singleSelectModeCluster && typeof this.singleSelectModeCluster === 'function') {
                this.singleSelectModeCluster(fs);
            }
            const latLng = feature.getPosition();
            const obj = {latLng: [ latLng.lng(), latLng.lat() ], clickFeature : feature};
            if (this.drawStartCluster && typeof this.drawStartCluster === 'function') {
                this.drawStartCluster(obj);
            }
            if (this.drawEndCluster && typeof this.drawEndCluster === 'function') {
                this.drawEndCluster(obj);
            }
        });
        return feature;
    }
    createFeatureByType(coord, type, options) {
        let geom; let properties;
        const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
        const url = (options.url ? options.url : '');
        const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
        const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');
        const radius = options.radius;
        // let isDashedLine = (options.layer && options.layer.lineDash !== undefined
        // && options.layer.lineDash instanceof Array && options.layer.lineDash.length > 0);
        // let lineWidth = 4;
        // if(options.layer && options.layer.lineWidth) lineWidth = options.layer.lineWidth;
        // let lineDash = isDashedLine ? options.layer.lineDash : undefined;
        // let lineCap = "round";
        // if(options.layer && options.layer.lineCap) lineCap = options.layer.lineCap;


        if (type === MapDrawType.POINT) {
            if (options.layerType === 'cluster') {
                return this.createFeatureCluster(coord, type, options);
            } else {
                const lon = Number(coord[0]);
                const lat = Number(coord[1]);
                if (isNaN(lon) || isNaN(lat)) { return null; }
    
                const latLng = new this.google.maps.LatLng(lat, lon);

                let point = SclMapConstantService.MAP_MARKER;
                    if (options.point) { point = options.point; }
                    if (options.imageFileNo) {
                        point = sclUtilMap.handleImageFileNo(options.imageFileNo);
                    }
                    if (options.image) { point = options.image; }
                    properties = this.createPointProperty(latLng, point, options.name, options.id, relatedAssets
                        , options.color, options.layerDisplayOnly,
                        options.tooltip, options.anchor, type, '', options.url, options.sharedId);
                    
                    if (options.rotation) { properties.rotation = options.rotation; }
                    if (options.scale) { properties.scale = options.scale; }

                    geom = new this.google.maps.Data.Point(latLng);
                    geom.id = options.id;


                if (typeof options.label !== undefined && options.label != null) {
                    properties.lb = this.createLabel(lat, lon, options.label, options.color, options.id);
                }
            }
            
        } else {
            const hasNaN = false;
            const obj = { hasNaN: hasNaN};
            this.traverseCoor(coord, obj);
            if (obj.hasNaN) { return null; }

            if (options.layerType === 'cluster') {
                type = MapDrawType.POINT;
                const centerPoint = options.centerPoint;
                delete options.centerPoint;
                return this.createFeatureCluster(centerPoint, type, options); // coord, type, options
            }

            let points = []; // [{lat: 25.774, lng: -80.190}, {lat: 18.466, lng: -66.118}]

            if (type === MapDrawType.MULTI_POINT) {
                // geom = new this.google.maps.Data.MultiPoint([coord]);
                for (let j = 0; j < coord.length; j++) {
                    points.push({lat: coord[j][1], lng: coord[j][0]});
                }
                geom = new this.google.maps.Data.MultiPoint(points);
            } else if (type === MapDrawType.LINE_STRING) {
                const elements = [];
                for (let i = 0; i < coord.length; i++) {
                    elements.push({ lat: coord[i][1], lng: coord[i][0] });
                }
                points = elements;
                geom = new this.google.maps.Data.LineString(elements);
            } else if (type === MapDrawType.MULTI_LINE_STRING) {
                const elements = [];
                for (let i = 0; i < coord.length; i++) {
                    const item = coord[i];
                    const part = [];
                    for (let j = 0; j < item.length; j++) {
                        part.push({ lat: item[j][1], lng: item[j][0]});
                        points.push({lat: item[j][1], lng: item[j][0]});
                    }
                    elements.push(part);
                }
                geom = new this.google.maps.Data.MultiLineString(elements);
            } else if (type === MapDrawType.POLYGON) {
                const elements = [];
                for (let i = 0; i < coord.length; i++) {
                    const item = coord[i];
                    const part = [];
                    for (let j = 0; j < item.length; j++) {
                        part.push({ lat: item[j][1], lng: item[j][0]});
                        points.push({ lat: item[j][1], lng: item[j][0]});
                    }
                    elements.push(part);
                }
                geom = new this.google.maps.Data.Polygon(elements);
            } else if (type === MapDrawType.MULTI_POLYGON) {
                const elements = [];
                for (let i = 0; i < coord.length; i++) {
                    const item = coord[i];
                    const part = [];
                    for (let j = 0; j < item.length; j++) {
                        const jItem = item[j];
                        const jPart = [];
                        for (let k = 0; k < jItem.length; k++) {
                            jPart.push({ lat: jItem[k][1], lng: jItem[k][0]});
                            points.push({ lat: jItem[k][1], lng: jItem[k][0]});
                        }
                        part.push(jPart);
                    }
                    elements.push(part);
                }
                geom = new this.google.maps.Data.MultiPolygon(elements);
            }
            if (geom) {
                let color = 'purple';
                
                if (options.color) { color = options.color; }
                properties = sclAssetLayers.createLineProperties(options.layer, options.name, color, options.id
                    , options.tooltip, primaryMultiPopup, secondaryMultiPopup,
                    options.layerDisplayOnly, relatedAssets, options.url, options.sharedId);
                
                geom.id = options.id;
                if (typeof options.label !== undefined && options.label != null) {
                    const labelLatLng = this.centerPoint(points);
                    properties.lb = this.createLabel(labelLatLng[0], labelLatLng[1], options.label, color, options.id);
                }

                if (type === MapDrawType.POLYGON && radius) {
                    properties.circleCenter = options.circleCenter;
                    properties.radius = radius;
                    properties.subType = MapDrawType.CIRCLE;
                }
            }
        }
        const feature = new this.google.maps.Data.Feature();
        feature.setGeometry(geom);
        feature.id = options.id;
        this.setFeatureProperties(feature, properties);

        return feature;
    }
    
    createPointProperty(latLng , image, name, id, relatedAsset, color, layerDisplayOnly
                                      , tooltip, anchor, type, layerName, url, sharedId) {
        const properties: any = {
            icon : image,
            name : name,
            id : id
        };
        if (color != null) { properties.color = color; }
        if (tooltip != null) { properties.tooltip = tooltip; }
        if (layerDisplayOnly != null) { properties.layerDisplayOnly = layerDisplayOnly; }
        if (type != null) { properties.type = type; }
        if (anchor != null) { properties.anchor = anchor; }
        if (layerName != null) { properties.layerName = layerName; }
        if (url != null) { properties.url = url; }
        if (relatedAsset != null) {
            for (const field in relatedAsset) {
                if (relatedAsset.hasOwnProperty(field)) {
                    const value = relatedAsset[field];
                    properties[field] = value;
                }
            }
        }
        if (typeof sharedId === 'string') { properties.sharedId = sharedId; }

        return properties;
    }
    setFeatureProperties(feature, properties) {
        if (feature.isCluster) {
            for (const p in properties) {
                if (properties.hasOwnProperty(p) && !feature.get(p) ) {
                    feature.set(p, properties[p]);
                }
            }
        } else {
            for (const p in properties) {
                if (properties.hasOwnProperty(p)) {
                    feature.setProperty(p, properties[p]);
                }
            }
        }
    }
    resetFeatureProperties(feature, properties) {
        feature.properties = properties;
    }
    getFeatureProperty(feature, propertyName) {
        if (feature) {
            if (feature.isCluster) {
                return feature[ propertyName ];
            } else {
                return feature.getProperty(propertyName);
            }
        } else {
            // console.log('%c try to get property of NULL', 'color:blue');
            return null;
        }
        
    }
    getFeatureProperties(feature, fieldNames) {
        const p = {};
        for (let i = 0; i < fieldNames.length; i++) {
            // p[fieldNames[i]] = feature.getProperty( fieldNames[i] );
            p[fieldNames[i]] = this.getFeatureProperty(feature, fieldNames[i]);
        }
        return p;
    }
    getFeatureId(feature) {
        let id = feature.id;
        if (!id) { id = feature.getId(); }
        if (!id) { id = feature.getProperty('id'); }
        return id;
    };
    setFeatureId(feature, id) {
        feature.id = id;
    }
    getFeatureGeomType(feature) {
        const geom = feature.getGeometry();
        const type = geom.getType();
        return type;
    }
    getFeatureById(id) {
        let f = null;
        const self = this;
        // for(let i = 1; i < this.layerIndexFilter + 1; i++){
        for (let i = 1; i < this.layerAssets.length; i++) {
            if (this.isHeatLayer(i)) { continue; }// heat map
            if (this.layerAssets[i].get('isCluster')) {
                this.layerAssets[i].markers.forEach(function(feature) {
                    const fId = self.getFeatureId(feature);
                    if (fId === id) {// if(feature.j != null && feature.j.id != null){
                        f = feature;
                        return;
                    }
    
                });
            } else {
                this.layerAssets[i].forEach(function(feature) {
                    const fId = self.getFeatureId(feature);
                    if (fId === id) {// if(feature.j != null && feature.j.id != null){
                        f = feature;
                        return;
                    }
    
                });
            }
            
        }
        return f;
    }
    getFeatureByLayer(id, layerIndex) {
        if (layerIndex > this.layerAssets.length - 1) { return null; }
        let f = null;
        if (this.isHeatLayer(layerIndex)) { return null; }// heat map
        const self = this;
        this.layerAssets[layerIndex].forEach(function(feature) {
            const fId = self.getFeatureId(feature);
            if (fId === id) {// if(feature.j != null && feature.j.id != null){
                f = feature;
                return;
            }

        });
        return f;
    }
    // use for sc-address-map & sc-selected-asset
    getFeatureByPixel(pixel) {
        let f = null;
        if (typeof pixel.id === 'undefined' || pixel.id === null ) { return null; }
        const self = this;
        if (f == null) {
            for (let i = 0; i < this.layerIndexFilter + 1; i++) {
                if (this.isHeatLayer(i)) { continue; }// heat map
                if (this.layerAssets[i].get('isCluster')) {
                    const features = this.layerAssets[i].markers;
                    features.forEach((feature) => {
                        const fId = this.getFeatureId(feature);
                        if (fId === pixel.id) {
                            f = feature;
                            return;
                        }
                    });
                } else {
                    this.layerAssets[i].forEach(function(feature) {
                        const fId = self.getFeatureId(feature); // feature.j.id;
                        if (fId === pixel.id) {
                            f = feature;
                            return;
                        }
                    });
                }
            }
        }
        return {feature: f, layerIdx: 0} ;
    }
    featureClone(fea, layerIndex) {
        if (fea.isCluster) {
            const pos = fea.getPosition();
            const coords = [pos.lng(), pos.lat()];
            const p: any = this.getFeatureProperties(fea, ['clusterImageWidth', 'clusterImageHeight', 'imageFileNo', 'name', 'id'
            , 'color', 'layerDisplayOnly', 'anchor', 'url', 'tooltip', 'label']);
            const layerClone = { clusterImageWidth: p.clusterImageWidth, clusterImageHeight: p.clusterImageHeight };
            const f = this.createFeatureByType( coords, MapDrawType.POINT, {EPSG: null, imageFileNo: p.imageFileNo, name: p.name, id: p.id
                , color: p.color, layerDisplayOnly: p.layerDisplayOnly, anchor: p.anchor, url: p.url, layer: layerClone
                , tooltip: p.tooltip, point: SclMapConstantService.MAP_MARKER, label: p.label, layerType: 'normal'
                , layerIndex: layerIndex} );
            return f;
        } else {
            return fea;
        }
    }
    getEventByPixel(pixel) {
    }
    addFeature(feature, layerIndex) {
        if (feature === null) {
            console.error('try to add feature NULL to layer');
            return;
        }
        if (this.layerAssets[layerIndex].get('isCluster')) {
            feature.set('zIndex', layerIndex);
            this.layerAssets[layerIndex].addMarker(feature);
            // console.log('%c addFeature cluster', 'color:blue');
        } else {
            this.layerAssets[layerIndex].add(feature);
            feature.setProperty('zIndex', layerIndex); // feature.j.properties.zIndex = layerIndex;
            const p: any = this.getFeatureProperties(feature, ['lb', 'circle']);
            const lb = p.lb; const circle = p.circle;
            if (lb) {
                if (lb.labelText && lb.labelText.trim().length > 0) { // 15492: labelText is empty and have zIndex bigger than feature index then will prevent the click in feature
                    lb.label.labelDiv_.style.zIndex = layerIndex;
                    lb.setMap(this.map);
                }
            }
            if (circle) {
                circle.setMap(this.map);
            }
            // console.log('addFeature normal');
        }

        
        // 14796 -> update from 15492 : no need to remove transparent image
        // const lst = document.querySelectorAll('[src="https://maps.gstatic.com/mapfiles/transparent.png"]');
        // // console.log('%c hideImgTransparency, lst.len = ' + lst.length, 'color:blue');
        // if (lst && lst.length > 0) {
        //     let root = null;
        //     for (let i = 0; i < lst.length; i++) {
        //         // this div is for multipoint, if remove it we can't select multipoint by clicking
        //         if (lst[i].clientWidth === 16 || this.checkTransparenImgIsCluster( lst[i].clientWidth, lst[i].clientHeight )) { continue; }
        //         const parent = lst[i].parentNode;
        //         root = parent.parentNode;
        //         if (root) {
        //             root.removeChild(parent);
        //         }
        //     }
        // }
    }

    removeFeature(feature, layerIndex) {
        const self = this;
        const id = this.getFeatureId(feature);
        if (layerIndex) {
            if (layerIndex > this.layerAssets.length) { return; }

            this.layerAssets[layerIndex].forEach(function(f) {
                const fId = self.getFeatureId(f);
                if (fId === id) {// if(f.j.id == feature.j.id){
                    self.layerAssets[layerIndex].remove(feature);
                    return;
                }
            });
        } else {
            try {
                feature.setMap(null);
            } catch (err) {
                // this.map.data.remove(feature);
                for (let i = 1; i < this.layerIndexFilter + 1; i++) {
                    if (this.isHeatLayer(i)) {continue; }// heat map
                    if (this.layerAssets[i].isCluster) {
                        continue; // selected-asset
                    } else {
                        this.layerAssets[i].forEach(function(f) {
                            const fId = self.getFeatureId(f);
                            if (fId === id) {// if(f.j.id == feature.j.id){
                                self.layerAssets[i].remove(feature);
                                return;
                            }
                        });
                    }
                }
            }
        }


    }
    removeItemFromMap(id) {
        const fea = this.getFeatureById(id);
        if (fea) {
            const zIndex = this.getFeatureProperty(fea, 'zIndex');
            if (zIndex) {
                this.removeFeature(fea, zIndex);
            }
        }
    }
    getMapSize() {
        const w = this.map.getDiv().offsetWidth;
        const h = this.map.getDiv().offsetHeight;
        return [w, h];
    }
    getBoundingBox(options) {
        // get coordinate / latLngBounds of the current viewport
        const zoom = this.map.getZoom();
        const bounds = this.map.getBounds();
        if (bounds === undefined) {
            return null;
        } else {
            // coor = [144.84272334255306,-37.74612232200406], coorNext = [145.01595120556692,-37.853297033123845]
            // north-east = top-right
            const northEast = bounds.getNorthEast();
            // south-west (bottom-left)
            const southWest = bounds.getSouthWest();
            const left = southWest.lng();
            const bottom = southWest.lat();
            const top = northEast.lat();
            const right = northEast.lng();

            if (isNaN(left) || isNaN(bottom) || isNaN(top) ||  isNaN(right)) { return null; }


            let minLon = left; let maxLon = right;
            if (left > right) {
                minLon = right; maxLon = left;
            }

            let minLat = bottom;
            let maxLat = top;
            if (bottom > top) {
                minLat = top; maxLat = bottom;
            }

            return { minLon, maxLat, maxLon, minLat, zoom }
        }
    }


    addSearchAddress(apiKey, wrapper, cb) {
        const autocomplete = new this.google.maps.places.Autocomplete(
            wrapper,
            { types: ['geocode'] });

        this.google.maps.event.addListener(autocomplete, 'place_changed', function() {
            const place = autocomplete.getPlace();
            const lat = place.geometry.location.lat();
            const lon = place.geometry.location.lng();

            if (cb && typeof cb === 'function') {
                cb(place, lat, lon);
            }
        });
    }

    clearAllFeatures() {
        const self = this;
        for (let i = 1; i < this.layerIndexFilter + 1; i++) {
            if (this.isHeatLayer(i)) { continue; }// heat map
            this.layerAssets[i].forEach((f) => {
                const lb = this.getFeatureProperty(f, 'lb');
                if (lb) {
                    // console.log('%c clearAllFeatures , remove label ' + lb.label.marker_.labelContent, 'color:green');
                    lb.setMap(null);

                }
                self.layerAssets[i].remove(f);
            });
        }
    }
    clearAllFeaturesLayer(layerIndex) {
        if (layerIndex > this.layerAssets.length) { return; }
        const self = this;
        if (this.isHeatLayer(layerIndex)) {
            this.layerAssets[layerIndex].setMap(null);
        } else {
            if (this.layerAssets[layerIndex].get('isCluster')) {
                if (this.mapType === MapComponentName.SELECTED_ASSET) {
                    const lst = this.layerAssets[layerIndex].markers;
                    if (lst && lst.length > 0) {
                        this.layerAssets[layerIndex].removeMarkers(lst);
                    }
                }
            } else {
                this.layerAssets[layerIndex].forEach((f) => {
                    const lb = this.getFeatureProperty(f, 'lb');
                    if (lb) {
                        lb.setMap(null);
                    }
                    self.layerAssets[layerIndex].remove(f);
                });
            }
            
        }
    }

    mapMoveEnd(moveEndFunc) {
        if (this.mapType === MapComponentName.BOUNDARY
             || this.mapType === MapComponentName.STREET_ADDRESS
              || this.mapType === MapComponentName.SELECTED_ASSET) { // 15264
            this.map.addListener('zoom_changed', () => {
                console.log('%c zoom_changed ', 'color:blue');
                if (moveEndFunc && typeof moveEndFunc === 'function') {
                    moveEndFunc();
                }
            });
        }

        this.google.maps.event.addListener(this.map, 'dragend', () => {
            // console.log('%c dragend ', 'color:blue');
            if (moveEndFunc && typeof moveEndFunc === 'function') {
                moveEndFunc();
            }
        });
    }

    updateSize() {
    }

    getLatLngFromPixel(pixel) {
        return [];
    }

    getPixelFromCoordinate(coordinate) {
        const coor = coordinate;
        const lat = coor[1];
        const lng = coor[0];

        let siny = Math.sin(lat * Math.PI / 180);

        // Truncating to 0.9999 effectively limits latitude to 89.189. This is
        // about a third of a tile past the edge of the world tile.
        siny = Math.min(Math.max(siny, -0.9999), 0.9999);

        const TILE_SIZE = 256;
        const worldCoordinate = new this.google.maps.Point(
            TILE_SIZE * (0.5 + lng / 360),
            TILE_SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)));

        // tslint:disable-next-line: no-bitwise
        const scale = 1 << this.map.getZoom();

        const pixel = [Math.floor(worldCoordinate.x * scale), Math.floor(worldCoordinate.y * scale)];

        return {coor: coor, pixel: pixel};
    }

    checkClickFeatureIsExist(features, clickFeature, sType, assetSelectionsAvailable){
        let existedFeature = this.getFeaturesFromMap(features, clickFeature, sType, assetSelectionsAvailable);
        if (existedFeature == null) {
            for (let i = 0; i < features.length; i++) {
                const id = this.getFeatureProperty(features[i], 'id');
                if ( id && id.indexOf(sType) > -1) {
                    existedFeature = features[i];
                    break;
                }
            }
        }
        return existedFeature;
    }

    findFeatureByClick(evt, sType, assetSelectionsAvailable) {
        const features = [];
        const obj = this.getPixelFromCoordinate(evt.latLng);
        let existedFeature;
        if (Array.isArray(evt.clickFeature)) {
            for (let i = 0; i < evt.clickFeature.length; i++) {
                existedFeature = this.checkClickFeatureIsExist(features, evt.clickFeature[i], sType, assetSelectionsAvailable);
            }
        } else {
            existedFeature = this.checkClickFeatureIsExist(features, evt.clickFeature, sType, assetSelectionsAvailable);
        }
        

        return { coor: obj.coor, pixel: obj.pixel, features: features, existedFeature: existedFeature };
    }

    storeSelectedAssets(feature, isPrimary) {

        // if(this.selectedAssets == null) this.selectedAssets = [];
        // let len = this.selectedAssets.length;
        // for(let i = 0; i < len; i++){
        //    if(this.selectedAssets[i].id == feature.id){
        //        this.map.data.remove(feature);
        //        this.map.data.add(feature);
        //
        //        //this.map.data.revertStyle();
        //        //this.map.data.overrideStyle(feature);
        //        return;
        //    }
        // }
        // this.selectedAssets.push(feature);
        // this.map.data.add(feature);//13835
        const id = this.getFeatureId(feature);
        if (this.selectedAssets == null) { this.selectedAssets = []; }
        const len = this.selectedAssets.length;
        for (let i = 0; i < len; i++) {
            if (this.selectedAssets[i].id === id) {
                //// feature.setMap(null);
                const f = this.getFeatureById(id);
                if (isPrimary == true) {
                    feature.setProperty('zIndex', this.layerIndexPrimary);
                    if (f == null) {
                        this.layerAssets[this.layerIndexPrimary].add(feature);
                    } else {
                        this.layerAssets[this.layerIndexPrimary].remove(f);
                        this.layerAssets[this.layerIndexPrimary].add(feature);
                    }

                } else if (isPrimary == false){
                    feature.setProperty('zIndex', this.layerIndexSecondary);
                    if (f == null) {
                        this.layerAssets[this.layerIndexSecondary].add(feature);
                    } else {
                        this.layerAssets[this.layerIndexSecondary].remove(f);
                        this.layerAssets[this.layerIndexSecondary].add(feature);
                    }
                }
                this.selectedAssets[i] = feature;
                return;
            }
        }
        this.selectedAssets.push(feature);
        if (isPrimary === undefined) {
            if (id && id.indexOf('primary') > -1) { isPrimary = true; } else if (id && id.indexOf('secondary') > -1) { isPrimary = false; }
        }
        if ( isPrimary) {
            feature.setProperty('zIndex', this.layerIndexPrimary);
            this.layerAssets[this.layerIndexPrimary].add(feature);
        } else {
            feature.setProperty('zIndex', this.layerIndexSecondary);
            this.layerAssets[this.layerIndexSecondary].add(feature);
        }

    }
    async updateStoredSelectedAssetVisualize(id, handlebarsContext, primaryIcon
        , primaryAssetSelection, secondaryIcon, secondaryAssetSelection, handlebarAssetFn) {
        if (!this.selectedAssets) { return; }
        const len = this.selectedAssets.length;
        for (let i = 0; i < len; i++) {
          const feature = this.selectedAssets[i];
          const assetType = this.getFeatureProperty(feature, 'assetType');

          let fId = this.getFeatureId(feature);
          
          if (fId.indexOf('_') > -1) { fId = fId.split('_')[0]; }
          if (id.indexOf(fId) > -1) {
            let isPrimary = false;
            if (assetType === MapSelectAssetType.PRIMARY) { isPrimary = true; }

            
            if (isPrimary) {
                const primary = await handlebarAssetFn(handlebarsContext, primaryIcon
                    , primaryAssetSelection, true);

                this.setFeatureProperties(feature, { primary});

                this.layerAssets[this.layerIndexPrimary].remove(feature);
                this.layerAssets[this.layerIndexPrimary].add(feature);
            } else {
                const secondary = await handlebarAssetFn(handlebarsContext, secondaryIcon
                    , secondaryAssetSelection, false);

                this.setFeatureProperties(feature, { secondary});

                this.layerAssets[this.layerIndexSecondary].remove(feature);
                this.layerAssets[this.layerIndexSecondary].add(feature);
            }
            
            break;
          }
        }
    }
    removeSelectedAssetsById(id) {
        const len = this.selectedAssets.length;
        let fId = id;
        let sType = null;
        if (fId && fId.indexOf('primary') > -1) {
            fId = fId.split('_')[0];
            sType = MapSelectAssetType.PRIMARY;
        } else if (fId && fId.indexOf('secondary') > -1) {
            fId = fId.split('_')[0];
            sType = MapSelectAssetType.SECONDARY;
        }
        for (let i = len - 1; i > -1; i--) {
            if (this.selectedAssets[i].id && this.selectedAssets[i].id.indexOf(sType) > -1 && this.selectedAssets[i].id.indexOf(fId) > -1 ) {
                const f = this.selectedAssets[i];
                const iId = this.getFeatureId(f);
                //// let isContain = this.map.data.contains(f);
                // this.map.data.remove(f);
                try {
                    f.setMap(null);
                } catch (err) {
                    const self = this;
                    if (sType == null) {
                        let isRemoved = false;

                        this.layerAssets[this.layerIndexPrimary].forEach(function(fea) {
                            const feaId = self.getFeatureId(fea);
                            if (feaId === iId) {// if(fea.j.id == f.j.id){
                                self.layerAssets[self.layerIndexPrimary].remove(fea);
                                isRemoved = true;
                                return;
                            }
                        });
                        if (isRemoved === false) {
                            this.layerAssets[this.layerIndexSecondary].forEach(function(fea) {
                                const feaId = self.getFeatureId(fea);
                                if (feaId === iId) {// if(fea.j.id == f.j.id){
                                    self.layerAssets[self.layerIndexSecondary].remove(fea);
                                    return;
                                }
                            });
                        }
                    } else {
                        if (sType === MapSelectAssetType.PRIMARY) {
                            this.layerAssets[this.layerIndexPrimary].forEach(function(fea) {
                                const feaId = self.getFeatureId(fea);
                                if (feaId && feaId.indexOf(fId) > -1 ) {// if(fea.j.id.indexOf(fId) > -1 ){
                                    self.layerAssets[self.layerIndexPrimary].remove(fea);
                                    return;
                                }
                            });
                        } else {
                            this.layerAssets[this.layerIndexSecondary].forEach(function(fea) {
                                const feaId = self.getFeatureId(fea);
                                if (feaId && feaId.indexOf(fId) > -1) {// if(fea.j.id.indexOf(fId) > -1){
                                    self.layerAssets[self.layerIndexSecondary].remove(fea);
                                    return;
                                }
                            });
                        }
                    }
                }

                this.selectedAssets.splice(i, 1);
                break;
            }
        }
    }
    removeLayerFeatures() {
        // console.log('***********************google removeLayerFeatures***************************');
        // let self = this;
        // this.map.data.forEach(function(feature) {
        //    // If you want, check here for some constraints.
        //    self.map.data.remove(feature);
        // });
        const self = this;
        for (let i = 1; i < this.layerAssets.length; i++) {
            if (this.isHeatLayer(i)) { continue; }// heat map
            this.layerAssets[i].forEach(function(feature) {
                self.layerAssets[i].remove(feature);
            });
        }
    }
    removeUnselectedAsset(assets, unSelectedAssetIds, type) {
        // for sc-selected-asset
        for (let i = 0; i < unSelectedAssetIds.length; i++) {
            let priAsset = unSelectedAssetIds[i];
            if (priAsset.indexOf('_') > -1) { priAsset = priAsset.split('_')[0]; }
            for (let j = 0; j < assets.length; j++) {
              const id = assets[j].properties.linkAssets[0].documentId;
              if (id === priAsset) {
                this.removeSelectedAssetsById(id + '_' + type);
                assets.splice(j, 1);
              }
            }
        }
    }
    updateLayers(pLayerAssets) {
        // store all feature of filter
        // let fs = [];
        // this.layerAssets[this.layerIndexFilter].forEach(function(feature){
        //     fs.push(feature);
        // });
        // remove feature in all layers
        this.removeLayerFeatures();
        // remove old layers
        for (let i = 1; i < this.layerAssets.length; i++) {// start with layer index of asset from 1 to n
            this.layerAssets[i].setMap(null);
        }

        // add new layers
        const obj = {layerAssets: pLayerAssets};
        this.createLayers(obj, null);
        for (let i = 1; i < this.layerAssets.length; i++) {// start with layer index of asset from 1 to n
            this.layerAssets[i].setMap(this.map);
        }

        // //add all feature back to filter layer
        // //console.log('%c updateLayers, fs.len = ' + fs.length + ', this.layerIndexFilter = ' + this.layerIndexFilter , 'color:blue');
        // if(fs != null && fs.length > 0){
        //     for(let i = 0; i < fs.length; i++){
        //         this.addFeature(fs[i], this.layerIndexFilter);
        //     }

        // }

        // add click event for each layer asset & layer filter, this is this.google.map.data
        this.setLayerSelectAsset();
    }

    getFeaturesCollection(options) {
        const fs = [];
        const feature = options.feature;
        // if(feature === null || typeof feature.j === 'undefined' || feature.j === null ) return fs;
        if (feature === null || typeof feature.getProperty !== 'function') { return fs; }
        const id = this.getFeatureId(feature); // feature.j.id;
        const zIndex = this.getFeatureProperty(feature, 'zIndex');
        fs.push({feature: feature, layerIdx: zIndex });
        if (id && id.indexOf('_') < 0) { return fs; }
        const id0 = id.split('_')[0];
        const self = this;
        for (let i = 0; i < this.layerAssets.length; i++) {
            if (this.isHeatLayer(i) || this.layerAssets[i].get('isCluster')) { continue; }// heat map
            this.layerAssets[i].forEach(function(f) {
                const fId = self.getFeatureId(f); // f.j.id;
                if (fId && fId !== id && fId.indexOf(id0) > -1 ) {
                    fs.push({feature: f, layerIdx: i });
                }
            });
        }
        // return {feature: f, layerIdx: 0} ;
        return fs;
    }

    getFeaturesCollectionId(id) {
        const fs = [];
        const self = this;
        for (let i = 0; i < this.layerAssets.length; i++) {
            if (this.isHeatLayer(i)) { continue; }// heat map
            this.layerAssets[i].forEach(function(f) {
                const fId = self.getFeatureId(f); // f.j.id;
                if (fId && fId.indexOf(id) > -1 ) {
                    // make sure this feature was not added in array
                    let isExist = false;
                    for (let k = 0; k < fs.length; k++) {
                        if (self.getFeatureId(fs[k]) === fId) {// if(fs[k].j.id === fId){
                            isExist = true;
                            break;
                        }
                    }
                    if (!isExist) { fs.push(f); }
                }
            });
        }

        return fs;
    }

    psmaStyleFunction(feature) {
        if (feature == null || feature.properties === null) { return { }; }
        const fGeom = feature.getGeometry();
        const color = 'gray';
        // feature.j.properties;
        // color = p.color;
        const type = feature.getProperty('type');
        const zIndex = feature.getProperty('zIndex');

        if (type === undefined || type === 'circle') {
            // tslint:disable-next-line: no-redundant-jsdoc
            return /** @type {!this.google.maps.Data.StyleOptions} */({
                fillOpacity: 1,
                strokeWeight: 2,
                zIndex: zIndex
            });
        } else {
            // tslint:disable-next-line: no-redundant-jsdoc
            return /** @type {!this.google.maps.Data.StyleOptions} */({
                fillColor: 'rgba(255,255,255,0.4)', // white
                fillOpacity: 1,
                strokeColor: '#3399CC', // blue
                strokeWeight: 1,
                zIndex: zIndex
            });
        }
    }

    psmaCreateLayer(psmaPoints) {
        if (typeof this.psmaReverse === 'undefined' || this.psmaReverse === null) {
            this.psmaReverse = {};

            this.layerAssets[this.layerIndexAddress].add(psmaPoints); // 13835
            this.psmaReverse.psmaSourceVector = this.layerAssets[this.layerIndexAddress]; // 13835

            this.layerAssets[this.layerIndexAddress].setStyle(this.psmaStyleFunction.bind(this)); // 13835
            this.psmaReverse.psmaLayer = this.layerAssets[this.layerIndexAddress]; // 13835
            this.psmaReverse.isGoogle = true;
        }

        return this.psmaReverse;
    }
    psmaCreatePoint(coor, properties, psmaPoints) {

        const options = {
            label: { labelText: properties.description },
            color: 'red'
        };
        const lb = this.createLabel(coor[1], coor[0], options.label, options.color, coor[1] + '_' + coor[0]);

        const latLng = new this.google.maps.LatLng(coor[1], coor[0]);

        const c = new this.google.maps.Circle({
            map: this.map,
            center: latLng,
            radius: 1,
            fillColor: 'rgba(255, 127, 39, 1)', // orange
            strokeColor: 'rgba(255, 0, 0, 1)', // red
            strokeWeight: 1.25
        });

        const f = new this.google.maps.Data.Feature();
        f.setGeometry(latLng);
        properties.lb = lb;
        // f.j.properties = properties;
        for (const p in properties) {
            if (properties.hasOwnProperty(p)) {
                f.setProperty(p, properties[p]);
            }
        }

        psmaPoints.push(c);
        psmaPoints.push(f);

        return psmaPoints;
    }
    psmaCreatePointClick(coor, radius, psmaPoints) {
        // let p = {zIndex: this.layerIndexAddress, type: 'circle'};
        const latLng = new this.google.maps.LatLng(coor[1], coor[0]);
        const circle = new this.google.maps.Circle({
            map: this.map,
            center: latLng,
            radius: radius,
            fillOpacity: 0,
            strokeColor: '#3399CC',
            clickable: false
        });

        psmaPoints.push(this.marker);
        psmaPoints.push(circle);

        return psmaPoints;
    }
    psmaRemovePoint(psmaPoints, psmaSourceVector) {
        for (let i = 0; i < psmaPoints.length; i++) {
            if (psmaPoints[i] == null) { continue; }

            if (psmaPoints[i].j && psmaPoints[i].j.properties && psmaPoints[i].j.properties.lb) {
                psmaPoints[i].j.properties.lb.setMap(null);
            }
            try {
                psmaSourceVector.remove(psmaPoints[i]);
            } catch (err) {
                psmaPoints[i].setMap(null);
            }
        }

        return { psmaPoints: psmaPoints, psmaSourceVector: psmaSourceVector };
    }
    psmaDistanceCoords(coorA, coorB) {
        const R = 6378137; // Earth’s mean radius in meter
        const dLat = this.rad(coorB[1] - coorA[1]);
        const dLong = this.rad(coorB[0] - coorA[0]);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.rad(coorA[1])) * Math.cos(this.rad(coorB[1])) *
            Math.sin(dLong / 2) * Math.sin(dLong / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d; // returns the distance in meter
    }

    positionView(lat, lon, zoom, EPSG) {
        lat = typeof lat !== 'undefined' ? lat : 0;
        lon = typeof lon !== 'undefined' ? lon : 0;
        zoom = typeof zoom !== 'undefined' ? zoom : 2;
        EPSG = typeof EPSG !== 'undefined' ? EPSG : SclMapConstantService.EPSG_3857;
        this.map.setZoom(zoom);      // This will trigger a zoom_changed on the map
        this.map.setCenter(new this.google.maps.LatLng(lat, lon));
    }

    setCenterMapViewByCoordinates(bbox) {

        const southWest = new this.google.maps.LatLng(bbox[1][1], bbox[0][0]); // lat,lng
        const northEast = new this.google.maps.LatLng(bbox[0][1], bbox[1][0]); // lat,lng
        const bounds = new this.google.maps.LatLngBounds(southWest, northEast);

        this.map.fitBounds(bounds);
        this.map.setCenter(bounds.getCenter());
        // this.map.panToBounds(bounds);

    }
    // 15262
    setCenter(lat, lon) {
        const center = new this.google.maps.LatLng(lat, lon);
        this.map.setCenter(center);
    }

    convertLatLngToPixel(latLng) {
        const scale = Math.pow(2, this.map.getZoom());
        const nw = new this.google.maps.LatLng(
            this.map.getBounds().getNorthEast().lat(),
            this.map.getBounds().getSouthWest().lng()
        );
        const worldCoordinateNW = this.map.getProjection().fromLatLngToPoint(nw);
        const worldCoordinate = this.map.getProjection().fromLatLngToPoint(latLng); // marker.getPosition()
        const pixelOffset = [
            Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale),
            Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale)
        ];
        return pixelOffset;
    }

    extendToCoordinate(coord) {
        // console.log('extendToCoordinate, coord = ', coord);
        const position = new this.google.maps.LatLng(coord[1], coord[0]); // lat, lng
        const bounds = new this.google.maps.LatLngBounds();
        bounds.extend(position);
        this.map.fitBounds(bounds, {duration: 0});
    }

    getFeatureCoordinate(feature) {
        let coords = [];
        const coordArray = [];
        const tmpCoords = [];
        let type = null;

        try {
            const geom = cloneDeep(feature.getGeometry());
            type = geom.getType();
            geom.forEachLatLng((latlng) => {
                tmpCoords.push([latlng.lng(), latlng.lat()]);
                coordArray.push([latlng.lng(), latlng.lat()]);
            });
            if (type === MapDrawType.MULTI_POINT) {
                coords = tmpCoords;
            } else {
                for (let i = 0; i < tmpCoords.length - 1; i++) {
                    coords.push([ tmpCoords[i], tmpCoords[i + 1] ]);
                }
            }
        } catch (err) {
            console.log(`getFeatureCoordinate error: `, err);
        }

        return { coords, type, coordArray };
    }
}